/* 3D-Konfigurator der Produktseite.

   Ausgelagert aus sections/fmnv_pdp-3d-konfigurator.liquid (2026-09-21):
   Die Section war mit 268 KB ueber Shopifys 256-KB-Grenze fuer Liquid-
   Dateien und liess sich nicht mehr pushen. Der Code hier ist unveraendert
   uebernommen; einzig die Werte, die frueher als Liquid im Code standen,
   kommen jetzt aus dem JSON-Block [data-p3d-daten] neben dem Skript.

   Damit wird die Datei ausserdem vom CDN gecacht, statt bei jedem
   Seitenaufruf im HTML mitzureisen. */
/* Die Daten der Ausführung stehen als JSON neben diesem Skript. Vorher
     standen sie als Liquid mitten im Code — der ganze Block musste deshalb
     inline bleiben und trieb die Section über Shopifys 256-KB-Grenze. */
  const D = JSON.parse(document.querySelector('[data-p3d-daten]').textContent);

  /* Dynamisch importiert, weil die Asset-URLs erst aus D kommen. Ein Modul
     wird pro URL nur einmal ausgewertet — die Section liegt auf der PDP
     genau einmal, mehrfach eingebunden würde nur die erste starten. */
  // Parallel statt nacheinander: spart auf dem Telefon einen Netz-Umlauf vor dem Start.
  const [{ setupMobileWorkspace }, { erstelleSchaufenster }] =
    await Promise.all([import(D.mobileTestUrl), import(D.schaufensterUrl)]);
  (() => {
    const root = document.getElementById(D.rootId);
    if (!root) return;

    /* Familien ohne eine einzige Farbe mit Bild fallen heraus: Stünde so eine
       an erster Stelle, wäre `color` undefined und das ganze Skript bräche ab
       (eine neue Familie wird meist angelegt, bevor die Bilder da sind). */
    const FAMILIES = (D.families).filter((f) => f.colors && f.colors.length);
    if (!FAMILIES.length) {
      /* Nicht still aussteigen: Ohne Stoffe gibt es keinen Kaufweg. Der
         Hinweis steht dort, wo die Stoffe stünden — im Editor fällt die
         Lücke damit sofort auf, und der Kunde sieht keine tote Fläche. */
      console.error('[fmnv-p3d] Keine Stofffamilie mit Farben gefunden (Shop-Metafeld fmnv.fabric_families)');
      const leer = root.querySelector('[data-p3d-families]');
      if (leer) leer.innerHTML = '<p class="fmnv-p3d__hint">Die Stoffauswahl ist gerade nicht verfügbar. Bitte später erneut versuchen.</p>';
      return;
    }

    /* Die zweite Achse heißt nicht überall gleich. Mechanisch ist sie dasselbe
       — ein Ja/Nein je Ausführung —, inhaltlich klappt Uppsala aus statt auf.
       Ein Sofa mit Relaxfunktion als „Mit Schlaffunktion" auszuzeichnen wäre
       schlicht falsch, deshalb kommt das Wort aus den Section-Einstellungen.
       Vorgabe bleibt „Schlaffunktion": alle bestehenden Serien behalten ihre
       Beschriftung, ohne dass ihre Vorlagen angefasst werden müssen. */
    const FUNKTION = D.funktion;

    /* ---------------------------------------------------------------
       Farbstimmung
       Namensbasiert klassifiziert — bewusst nicht aus dem Swatch-Bild
       gemittelt: Studiofotos ziehen dunkle und gedeckte Stoffe Richtung
       Grau, was schon die Basiscolor-Taxonomie im Shop verfälscht hätte.
       "Dunkel" ist eine Helligkeits-, keine Farbtonaussage — eine Farbe
       kann also Warm UND Dunkel sein.
    --------------------------------------------------------------- */
    // Reihenfolge ist die Logik: Der erste Treffer gewinnt, damit
    // "DarkGrey" bei Grau landet und nicht bei Schwarz, "DarkBlue" bei Blau.
    // Jede Farbe bekommt genau einen Ton — Mehrfachzuordnung macht einen
    // Filter unbrauchbar, weil dann überall dasselbe auftaucht.
    const COLOR_RULES = [
      ['blau',    'Blau',    /blue|navy|sky|ocean|glacier|azure|niagara|turquoise|petrol/i],
      ['gruen',   'Grün',    /green|grass|forest|hunter|moss|olive|pine|turtle|khaki|beetle/i],
      ['rosa',    'Rosa',    /rose|blossom|blush|pink/i],
      ['lila',    'Lila',    /purple|violet|lila/i],
      ['rot',     'Rot',     /red|rot|bordeaux|chianti|wine|coral|chili/i],
      ['orange',  'Orange',  /orange|rust|terra|lava|brick|cinnamon/i],
      ['gelb',    'Gelb',    /gold|mustard|curry|amber|senf/i],
      ['braun',   'Braun',   /brown|braun|chocolate|cocoa|cacao|cognac|espresso|coffee|toffee|truffle|tobacco|woody|mud|fango|schoko|liver|cappuccino|rabbit/i],
      ['beige',   'Beige',   /beige|ivory|cream|nata|natural|nature|sand|sahara|desert|taupe|cornstalk|savannah|pale/i],
      ['weiss',   'Weiß',    /white|weiss|snow|bianco|pearl/i],
      ['grau',    'Grau',    /grey|gray|grau|silver|platin|stone|steel|iron|smoke|cement|ash|elephant|eiffel|mouse|dust/i],
      ['schwarz', 'Schwarz', /black|schwarz|anthra|antracite|charcoal|coal|nightshadow|graphite/i],
    ];
    const TONE_LABEL = Object.fromEntries(COLOR_RULES.map(([k, l]) => [k, l]));

    const toneOf = (name) => {
      const hit = COLOR_RULES.find(([, , re]) => re.test(name));
      // Ohne Zuordnung fiele die Farbe aus jedem Filter und wäre über die
      // Filterleiste nicht mehr erreichbar.
      return hit ? hit[0] : 'grau';
    };

    /* In welcher Farbe ein Stoff gezeigt wird, wenn er die gerade gewählte
       nicht führt.

       Bisher fiel die erste der Liste an. Bei „City" ist das Pearl, ein fast
       reines Weiß — auf voller Fläche ist daran keine Struktur mehr zu
       erkennen, und genau die soll in diesem Schritt beurteilt werden
       („Suche dir zuerst die Stoffstrukturen aus … die Farben wählst du im
       nächsten Schritt"). Weiß wird deshalb übersprungen, solange es eine
       Alternative gibt. Führt der Stoff die gewählte Farbe, gewinnt weiterhin
       sie — dann vergleicht man Strukturen bei gleicher Farbe. */
    // "Dark_Blue_R452" → Code "R452", Label "Dark Blue"
    const codeOf = (c) => (c.title.match(/[A-Z]\d{3,4}/) || [c.title])[0];
    const labelOf = (c) => c.title.replace(/_[A-Z]\d{3,4}$/, '').replace(/_/g, ' ').trim();

    FAMILIES.forEach((f) => f.colors.forEach((c) => {
      c.code = codeOf(c);
      c.label = labelOf(c);
      c.tone = toneOf(c.label);
      // Rückverweis: Die Farbliste mischt mehrere Stoffe, jede Farbe muss
      // also selbst wissen, zu welchem sie gehört.
      c.fam = f;
    }));

    /* In welcher Farbe ein Stoff gezeigt wird, wenn er die gerade gewählte
       nicht führt.

       Bisher fiel die erste der Liste an. Bei „City" ist das Pearl, ein fast
       reines Weiß — auf voller Fläche ist daran keine Struktur mehr zu
       erkennen, und genau die soll in diesem Schritt beurteilt werden
       („Suche dir zuerst die Stoffstrukturen aus … die Farben wählst du im
       nächsten Schritt").

       Weiß wird deshalb übersprungen, ausverkaufte Farben ebenso: Es wäre
       verkehrt, einen Stoff ausgerechnet in der Farbe zu bewerben, die man
       nicht bestellen kann. Bleibt nichts übrig, gilt wieder die erste —
       lieber eine schlecht lesbare Farbe als gar keine Vorschau.
       Führt der Stoff die gewählte Farbe, gewinnt weiterhin sie; dann
       vergleicht man Strukturen bei gleicher Farbe. */
    const zeigefarbe = (f) =>
      f.colors.find((c) => c.available !== false && c.tone !== 'weiss')
      || f.colors.find((c) => c.available !== false)
      || f.colors[0];

    /* --------------------------- DOM --------------------------- */
    const $ = (s) => root.querySelector(s);
    const mv = $('[data-p3d-viewer]');
    /* Das GLB der aufgerufenen Ausführung steht im Markup als data-Attribut
       (nicht als src) — geladen wird es erst, wenn der Konfigurator aufgeht. */
    const START_GLB = (mv && mv.dataset.p3dGlb) || '';
    // Lite-GLB-URLs, die nicht geladen werden konnten → Original verwenden.
    const liteFehlt = new Set();
    /* Schaufenster: Bis „Jetzt konfigurieren" gedrückt ist, zeigt die Seite
       Wohnbilder und sonst nichts vom Konfigurator. */
    let showroomAktiv = false;
    // Schaufenster (Wohnbilder vor dem Konfigurator) entfällt seit 2026-10-06: Marc, GA zeigte ~50 % Abbruch dort.
    let srUeberspringen = true;
    // Von der Sofa-Kollektion mit schon gewählter Form (?gewaehlt=1): Schritt 1 entfällt.
    let formGewaehlt = false;
    // Gewünschtes Modell, solange das Schaufenster es zurückhält.
    let glbWunsch = null;

    /* Modellwechsel an einer Stelle.

       Über das Attribut vergleichen und setzen, nicht über die Eigenschaft:
       Die Bibliothek lädt asynchron, das Element kann noch nicht aufgerüstet
       sein — dann wäre `mv.src` undefined und eine gesetzte Eigenschaft
       ginge verloren. Im Schaufenster wird der Wunsch nur gemerkt. */
    function setzeGlb(url) {
      if (!mv || !url) return;
      let u = url.replace(/^\/\//, location.protocol + '//');
      // Lite-Datei schon einmal gescheitert: gleich das Original nehmen.
      if (liteFehlt.has(u)) u = u.replace(/-lite\.glb$/, '.glb');
      if (showroomAktiv) { glbWunsch = u; return; }
      const ziel = new URL(u, location.href).href;
      const aktuell = new URL(mv.getAttribute('src') || '', location.href).href;
      if (aktuell === ziel) return;
      /* Das Material gehört zum alten Modell. Bliebe es stehen, malte
         paint() ins Leere, und das Vorschaubild für den Warenkorb käme vom
         alten Sofa. Neu gesetzt wird es im load-Handler. */
      fabricMat = null;
      mv.setAttribute('src', ziel);
    }

    /* Startabstand als Vielfaches der Einpassung, die model-viewer selbst
       rechnet (100 % = das Modell passt vollständig ins Bild).

       Auf dem Telefon deutlich näher heran: Die Einpassung geht von der
       Hüllkugel aus und lässt bei einem breiten, flachen Sofa so viel Luft,
       dass das Produkt auf einem Handybild zur Briefmarke wird. 86 % füllen
       die Bühne fast aus, ohne dass die Frontansicht — die breiteste — an den
       Rändern anstößt; ab 80 % ist die Ottomane rechts angeschnitten. Am
       Schreibtisch bleibt es bei den 105 % aus dem Markup: Dort steht das
       Modell in einer hohen Spalte und hat die Luft ohnehin.

       Gesetzt wird das Attribut, nicht der Meterwert: model-viewer rechnet
       Prozente gegen die Einpassung und behält sie auch dann, wenn es nach
       dem Ladeereignis noch einmal neu einpasst. Ein in Metern gesetzter
       Abstand wurde dabei still wieder überschrieben. */
    const MOBIL_ABSTAND = 0.86;
    const STARTABSTAND = () => (innerWidth <= 989 ? MOBIL_ABSTAND : 1.05);
    if (mv && innerWidth <= 989) {
      mv.setAttribute('camera-orbit', `0deg 85deg ${Math.round(MOBIL_ABSTAND * 100)}%`);
    }
    const famEl = $('[data-p3d-families]');
    const moodEl = $('[data-p3d-moods]');
    const colEl = $('[data-p3d-colors]');
    const previewEl = $('[data-p3d-preview]');
    const loadingEl = $('[data-p3d-loading]');
    const dotsEl = $('[data-p3d-dots]');
    const curFamEls = root.querySelectorAll('[data-p3d-current-family]');
    const curColEls = root.querySelectorAll('[data-p3d-current-color]');
    const prevNameEls = root.querySelectorAll('[data-p3d-preview-name]');

    let family = FAMILIES.find((f) => f.popular) || FAMILIES[0];
    let color = family.colors[0];
    /* Stoff und Auswahl auf die Ausführung abstimmen. Läuft beim Start und
       bei jedem Wechsel der Ausführung: Was dort keine Preisgruppe hat, fliegt
       aus der Auswahl; zeigt das Modell so einen Stoff, springt es auf den
       ersten bestellbaren um. Liefert true, wenn der gezeigte Stoff wechselte. */
    function sichereStoffwahl() {
      if (!konfig) return false;
      [...chosen].forEach((f) => { if (!bestellbar(f)) chosen.delete(f); });
      // Ein Filter, den kein bestellbarer Stoff mehr trägt (etwa „Leder"
      // nach dem Wechsel auf eine Ausführung ohne Ledervariante), ließe den
      // Stoffschritt leer zurück — ohne Chip, an dem man ihn lösen könnte.
      MERKMALE.forEach((m) => [...filter[m.id]].forEach((w) => {
        if (!bestellbareFamilien().some((f) => f[m.id] === w)) filter[m.id].delete(w);
      }));
      if (bestellbar(family)) return false;
      const ersatz = [...chosen].find(bestellbar)
        || bestellbareFamilien().find((f) => f.popular)
        || bestellbareFamilien()[0];
      if (!ersatz) return false;
      family = ersatz;
      color = ersatz.colors.find((c) => c.label.toLowerCase() === (color && color.label || '').toLowerCase())
        || ersatz.colors[0];
      // Diese Farbe hat niemand gewählt — der Warenkorb bleibt gesperrt.
      farbeBestaetigt = false;
      return true;
    }
    // Mehrere Stoffe gleichzeitig: Schritt 2 zeigt dann die Farben aller
    // gewählten Stoffe nebeneinander. `family` ist immer der Stoff der
    // aktuell im 3D dargestellten Farbe.
    /* Leer starten: Der Kunde soll seinen Stoff selbst wählen. Das Modell
       zeigt trotzdem einen Stoff, sonst stünde ein weißes Sofa da — aber
       keine Kachel ist markiert, und ohne Auswahl geht es nicht weiter. */
    const chosen = new Set();
    // Mehrere Farbtöne zugleich wählbar — leere Menge heißt: nicht gefiltert.
    const tone = new Set();
    // Vor renderTones deklariert — die Funktion läuft schon beim ersten
    // Zeichnen und greift über syncFarbansicht darauf zu.
    let farbenGezeigt = false;
    let wiederaufnahmeSchritt = null;
    // Vor dem Ende des Starts darf nichts in die Adresse geschrieben werden —
    // sonst überschreibt der noch offene Schritt 1 den wiederhergestellten.
    let startFertig = false;
    // Vor renderFamilies deklariert: Die Funktion ruft syncKauf schon beim
    // ersten Zeichnen auf, und let wirkt davor nicht.
    let farbeBestaetigt = false;
    // Nur ein eigener Klick auf eine Farbe macht das Sofa zum „zuletzt konfigurierten“ —
    // ein Link mit ?stoff= (Anzeige, Teilen) setzt farbeBestaetigt schon beim Laden.
    let selbstGewaehlt = false;

    /* Filtermerkmale.

       Jedes Merkmal filtert für sich, die Auswahl mehrerer wirkt zugleich
       (Leder UND haustiergeeignet). „unbekannt" ist eine echte dritte
       Möglichkeit: Solche Stoffe erscheinen nicht unter „Ja" und ebenso wenig
       unter „Nein" — eine fehlende Angabe ist keine Verneinung. Ein Merkmal,
       zu dem bei keinem Stoff etwas gepflegt ist, blendet seinen Filter aus,
       statt eine leere Reihe zu zeigen. */
    // Die Beschriftung trägt das Merkmal mit — so braucht keine Zeile eine
    // eigene Überschrift und alle Filter passen in eine gemeinsame Zeile.
    const MERKMALE = [
      /*
        Der Filter nach Materialart (Stoff/Leder) ist am 2026-09-08 auf Marcs
        Wunsch entfallen; „Haustiergeeignet" heißt seitdem „Tierfreundlich".
        Das Feld `art` bleibt am Stoff erhalten — es wird nur nicht mehr
        gefiltert. Am 2026-09-15 ist auf Marcs Wunsch auch „Hoher Abrieb"
        entfallen; das Feld `abrieb` bleibt ebenso am Stoff.
      */
      { id: 'struktur', werte: [['mit', 'Mit Struktur'], ['ohne', 'Glatt']] },
      { id: 'haustier', werte: [['ja', 'Tierfreundlich']] },
    ];
    // Je Merkmal eine Menge: leer heißt „nicht eingeschränkt". Damit ist ein
    // eigener Alle-Knopf überflüssig — Abwählen genügt.
    const filter = {};
    MERKMALE.forEach((m) => { filter[m.id] = new Set(); });

    /* Bestellbar heißt: Die Ausführung hat eine Variante in der Preisgruppe
       des Stoffs. Fehlt sie, gab es den Stoff bisher trotzdem zur Auswahl —
       und erst nach Stoff- und Farbwahl stand „nicht bestellbar" am Knopf.
       Eine Sackgasse nach drei Schritten. Deshalb zählen überall nur die
       Stoffe, die es für diese Ausführung wirklich gibt. Ohne Ausführung
       (Vorschau ohne Konfigurationen) bleibt alles sichtbar. */
    const bestellbar = (f) => !konfig || konfig.preise.some((p) => p.gruppe === (f.gruppe || ''));
    const bestellbareFamilien = () => FAMILIES.filter(bestellbar);

    const visibleFamilies = () => bestellbareFamilien().filter((f) =>
      MERKMALE.every((m) => !filter[m.id].size || filter[m.id].has(f[m.id])));

    /* ----------------------- 3D-Material ----------------------- */
    const CONFIGS = D.configs;
    const VIDEOS = D.videos;
    // Produktionsvideo für alle Serien (Shop-Metafeld fmnv.pdp_video), null = keins.
    const PDP_VIDEO = D.pdpVideo || null;

    /* Preisgruppe aus dem Variantentitel ziehen.

       Im PIM heißt eine Kombination aus Ausführung und Stoffgruppe
       <Config-ID>_<Preisgruppe>, z. B. F-C649250_1S. Gemeint ist immer der
       Teil nach dem letzten Unterstrich; ohne Unterstrich gilt der Titel
       selbst. Damit trägt die Variante die volle Artikelnummer, ohne dass die
       Zuordnung zum Stoff daran zerbricht — und eine spätere Umbenennung legt
       den Shop nicht lahm. Dasselbe gilt für das Feld am Stoffblock, falls
       dort einmal die ganze Nummer landet. */
    const gruppeAus = (t) => String(t == null ? '' : t).split('_').pop().trim();
    CONFIGS.forEach((k) => k.preise.forEach((p) => {
      // Rohtitel behalten: Er ist die Artikelnummer und damit die Auskunft,
      // welche Variante gemeint war, wenn eine Zuordnung doch fehlschlägt.
      p.titel = p.gruppe;
      p.gruppe = gruppeAus(p.gruppe);
    }));
    FAMILIES.forEach((f) => { f.gruppe = gruppeAus(f.gruppe); });

    /* Ausführungen ohne eigene Fotos erben die der Geschwister-Ausführung.

       Für die Schlaf-Varianten gibt es im Katalog kein Bildprodukt. Oben blieb
       dadurch nur das drehbare Modell — ausgerechnet dort, wo der Kunde die
       meisten Fragen hat. Zugeklappt ist es dasselbe Möbel, also lassen sich
       Raumaufnahmen und Vorteilsgrafik gefahrlos übernehmen.

       Die Maßzeichnung nicht: Sie trägt die Breite als Zahl im Bild. Beim
       2-Sitzer stimmt sie (183 cm hier wie dort), beim 3-Sitzer nicht
       (274 gegen 220 cm) — und eine falsche Maßzeichnung ist schlechter als
       keine. Deshalb wandert sie nur mit, wenn die Breite übereinstimmt. */
    const breiteAus = (masse) => {
      const zeile = String(masse || '').split(';')
        .map((z) => z.split('|').map((x) => x.trim()))
        .find((p) => /breite/i.test(p[0] || ''));
      return zeile ? zeile[1] : '';
    };
    // Die Quellen (Katalogprodukt, eigene Medien, Metafeld) ergänzen sich seit
    // 2026-10-08 — dieselbe Datei kann deshalb doppelt ankommen.
    CONFIGS.forEach((k) => {
      const gesehen = new Set();
      k.bilder = (k.bilder || []).filter((b) => !gesehen.has(b.datei) && gesehen.add(b.datei));
    });
    CONFIGS.forEach((k) => {
      if (k.bilder && k.bilder.length) return;
      const quelle = CONFIGS.find((x) => x.name === k.name && (x.seite || '') === (k.seite || '')
        && !!x.schlaf !== !!k.schlaf && x.bilder && x.bilder.length);
      if (!quelle) return;
      const gleicheBreite = !!breiteAus(k.masse) && breiteAus(k.masse) === breiteAus(quelle.masse);
      k.bilder = quelle.bilder.filter((b) => b.art !== 'spec' || gleicheBreite);
    });
    /* Das Maßblatt der Ausführung (Raumbild mit Maßpfeilen, Zahlen aus den
       Shopdaten) ersetzt jede ältere Maßzeichnung — auch eine geerbte. Erst
       nach dem Erben, sonst hätte eine Ausführung mit nur dem Maßblatt
       eigene Bilder und bekäme die Wohnbilder der Geschwister nicht mehr. */
    CONFIGS.forEach((k) => {
      if (!k.massblatt) return;
      const datei = k.massblatt.split('?')[0].split('/').pop();
      k.bilder = (k.bilder || []).filter((b) => b.art !== 'spec')
        .concat({ code: '', art: 'spec', datei, u: k.massblatt });
    });
    /* Vorteilsgrafik in jeder Ausführung (Marc, 2026-10-12) — auch bei Serien ohne
       eigene _usp_-Datei (Durham, Treviso, Visby …). Erst nach dem Erben, sonst
       hätte jede Ausführung schon ein Bild und bekäme keine Wohnbilder mehr. */
    CONFIGS.forEach((k) => {
      if ((k.bilder || []).some((b) => b.art === 'usp')) return;
      k.bilder = (k.bilder || []).concat({ code: '', art: 'usp', datei: 'foamnova_usp_01.png',
        u: 'https://cdn.shopify.com/s/files/1/0974/7673/9459/files/foamnova_usp_01.png?width=1400' });
    });

    // Startkonfiguration: die erste ohne Schlaffunktion, sonst die erste.
    let konfig = null;

    const BASISPREIS = D.basispreis;
    const VARIANTE = D.variante;
    const PRODUKT_HANDLE = D.produktHandle;
    const PRODUKT_TITEL = D.produktTitel;
    // Herkunft fürs Muster: das Sofa, das gerade im Konfigurator steht (Auswertung je Modell).
    const musterSofa = () => ({ _sofa: (konfig && konfig.handle) || PRODUKT_HANDLE, _sofa_name: PRODUKT_TITEL });
    // Raumaufnahme der Serie (Metafeld, auch Kachel der Kollektionsseite) —
    // letzter Ersatz, wenn die Ausführung überhaupt kein Wohnbild hat.
    const SERIENBILD = D.serienbild;
    // Raumbilder der Serie (Theme-Assets fmnv-raum-<serie>*.jpg, Snippet fmnv_raumbilder):
    // hängen an jedem Modell der Serie, jeweils mit dem Stoffcode, den das Sofa im Bild trägt.
    const RAUMBILDER = D.raumbilder || [];

    let kpGemeldet = false;

    // Meldet Nutzeraktionen an die Kundenereignisse (Pixel „Google Analytics“).
    function melde(ereignis, aktion, detail) {
      try {
        const sa = window.Shopify && window.Shopify.analytics;
        if (!sa || typeof sa.publish !== 'function') return;
        sa.publish('fmnv:' + ereignis, {
          aktion,
          detail: detail == null ? '' : String(detail).slice(0, 90),
          produkt: PRODUKT_HANDLE,
          stoff: family ? family.name : '',
          farbe: color ? color.label : '',
        });
        // Wer Stoff oder Farbe waehlt, konfiguriert wirklich — Metas eigenes
        // Playbook nutzt 'CustomizeProduct' fuer Konfigurations-Abschluesse.
        // Einmal je Seitenaufruf, sonst feuert jeder Farbklick.
        if (!kpGemeldet && ereignis === 'konfigurator'
            && (aktion === 'stoff_gewaehlt' || aktion === 'farbe')
            && typeof window.fbq === 'function') {
          kpGemeldet = true;
          fbq('track', 'CustomizeProduct', {
            content_ids: [String(VARIANTE)],
            content_type: 'product',
            content_name: PRODUKT_TITEL,
            value: BASISPREIS / 100,
            currency: 'EUR'
          });
        }
      } catch (e) { /* Messung darf den Konfigurator nie stören */ }
    }

    /* Katalog-Retargeting (Meta Advantage+ Katalog-Ads, Katalog „foamnova Sofas – 3D-Konfigurator“).
       Artikel-ID wie im Feed: <Ausführungs-Handle>__<Farbcode>, z. B. mantua-4-sitzer__H308.
       ViewContent erst nach 15 s sichtbarer Verweildauer auf derselben Kombination
       („etwas länger angeschaut“), AddToCart beim Absenden des Sofa-Formulars.
       Bewusst OHNE value: die Custom Conversions „Sofa-Ansicht“/„Sofa-Warenkorb“
       filtern auf value > 299 und dürfen diese Zusatz-Ereignisse nicht doppelt zählen.
       Je Kombination und Ereignis höchstens einmal pro Seitenaufruf. */
    const KAT_VERWEIL_MS = 15000;
    const katGemeldet = new Set();
    let katTimer = null, katKey = '', katStart = 0, katRest = KAT_VERWEIL_MS;
    function katId() {
      const h = (konfig && konfig.handle) || PRODUKT_HANDLE;
      return h && color && color.code ? `${h}__${String(color.code).toUpperCase()}` : '';
    }
    function katFeuer(ereignis, id) {
      try {
        if (!id || typeof window.fbq !== 'function') return;
        const k = ereignis + ':' + id;
        if (katGemeldet.has(k)) return;
        katGemeldet.add(k);
        fbq('track', ereignis, { content_ids: [id], content_type: 'product', content_name: PRODUKT_TITEL });
      } catch (e) { /* Messung darf den Konfigurator nie stören */ }
    }
    function katPlane() {
      try {
        clearTimeout(katTimer);
        const id = katId();
        if (!id || katGemeldet.has('ViewContent:' + id)) return;
        if (id !== katKey) { katKey = id; katRest = KAT_VERWEIL_MS; }
        if (document.hidden) return;
        katStart = Date.now();
        katTimer = setTimeout(() => katFeuer('ViewContent', katKey), katRest);
      } catch (e) {}
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearTimeout(katTimer);
        if (katStart) katRest = Math.max(0, katRest - (Date.now() - katStart));
        katStart = 0;
      } else katPlane();
    });

    /* Erst hier, nicht oben bei CONFIGS: Die Zuordnung braucht PRODUKT_HANDLE,
       und ein Zugriff vor dessen Deklaration killt das gesamte Skript.
       Die Ausführung ergibt sich aus der aufgerufenen Seite — ruft jemand
       /products/cappa-3-sitzer-schlaffunktion auf, steht genau die vorne. */
    konfig = CONFIGS.find((k) => k.handle === PRODUKT_HANDLE)
          || CONFIGS.find((k) => !k.schlaf) || CONFIGS[0] || null;
    /* Die Vorbelegung oben kennt die Ausführung noch nicht. Ist der beliebte
       Stoff hier nicht bestellbar, mit dem ersten bestellbaren beginnen —
       sonst zeigt das Modell einen Stoff, den es für dieses Sofa nicht gibt. */
    sichereStoffwahl();

    const REPEAT = 10497;   // gl.REPEAT — UV-Scale > 1 kachelt
    const ENV_TOP = D.envTop;
    const ENV_BOTTOM = D.envBottom;
    // Shopify liefert Asset-URLs protokollrelativ. Im Dev-Server über http
    // scheitert der Abruf dann still — dieselbe Falle wie beim HDRI.
    const NAP_URL = D.napUrl.replace(/^\/\//, location.protocol + '//');
    const NAP_INTENSITAET = D.napIntensitaet;
    const NAP_WEICHHEIT = D.napWeichheit;
    const NAP_SCHIMMER = D.napSchimmer;

    /* Blickwinkelunabhängige Fleckigkeit.

       Sheen ist von Natur aus streifend: stark im flachen Winkel, frontal
       fast unsichtbar. Für Flecken, die aus jeder Richtung bleiben, braucht
       es einen Kanal, der nicht vom Blickwinkel abhängt — die Verdeckung.
       Sie dämpft das Umgebungslicht und wirkt damit überall gleich.

       glTF kennt für occlusionTexture eine strength, model-viewer stellt sie
       aber nicht bereit (der Slot bietet nur setTexture). Die Stärke muss
       deshalb ins Bild — hier zur Laufzeit gerechnet und in Stufen von 0,05
       zwischengespeichert, damit ein Farbwechsel keine neue Textur kostet. */
    const napBild = new Promise((fertig, schief) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => fertig(i);
      i.onerror = schief;
      i.src = NAP_URL;
    });
    const aoCache = new Map();
    const napVerdeckung = (staerke) => {
      const stufe = Math.round(Math.min(1, staerke) * 20) / 20;
      if (!aoCache.has(stufe)) {
        aoCache.set(stufe, (async () => {
          const img = await napBild;
          const cv = document.createElement('canvas');
          cv.width = cv.height = 512;
          const g = cv.getContext('2d', { willReadFrequently: true });
          g.drawImage(img, 0, 0, 512, 512);
          const bild = g.getImageData(0, 0, 512, 512);
          const p = bild.data;
          for (let i = 0; i < p.length; i += 4) {
            // Weiß = unverändert, dunkel = abgeschattet. Die Stufe bestimmt,
            // wie weit die dunklen Stellen überhaupt herunterreichen.
            const v = Math.round(255 * (1 - stufe * (1 - p[i] / 255)));
            p[i] = p[i + 1] = p[i + 2] = v;
            p[i + 3] = 255;
          }
          g.putImageData(bild, 0, 0);
          return mv.createTexture(cv.toDataURL('image/png'));
        })());
      }
      return aoCache.get(stufe);
    };

    /* Mittlere Helligkeit einer Farbe, gemessen am Swatch statt geraten.
       16x16 genügt — gebraucht wird ein Mittelwert, keine Zeichnung. */
    const lumaCache = new Map();
    const helligkeit = (url) => {
      if (!url) return Promise.resolve(0.5);
      if (!lumaCache.has(url)) {
        lumaCache.set(url, new Promise((fertig) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            try {
              const cv = document.createElement('canvas');
              cv.width = cv.height = 16;
              const g = cv.getContext('2d', { willReadFrequently: true });
              g.drawImage(img, 0, 0, 16, 16);
              const d = g.getImageData(0, 0, 16, 16).data;
              let sum = 0;
              for (let i = 0; i < d.length; i += 4) {
                sum += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255;
              }
              fertig(sum / (d.length / 4));
            } catch (e) {
              fertig(0.5);   // getImageData scheitert bei fremder Herkunft
            }
          };
          img.onerror = () => fertig(0.5);
          img.src = url;
        }));
      }
      return lumaCache.get(url);
    };

    // Weiches Gradienten-Environment statt model-viewer-Default: dessen
    // heller Oberpol liest sich auf waagerechten Stoffflächen als
    // Glanzschleier. Zur Laufzeit als Canvas — kein Download, kein Hosting.
    // Ein reiner Verlauf beleuchtet flach — nichts wirft ein Licht, in dem
    // sich matt von glänzend unterscheiden ließe. Ein echtes Studio-HDRI
    // wiederum hat harte Softboxen und lässt Cord wie Satin glänzen.
    // Deshalb hier ein breites, weiches Deckenlicht: genug Richtung für
    // Plastizität, zu diffus für Spitzlichter.
    const buildEnv = (top, bottom, softness, softbox) => {
      const c = document.createElement('canvas');
      c.width = 512;
      c.height = 256;
      const ctx = c.getContext('2d');
      const mid = Math.round((top + bottom) / 2);
      const g = ctx.createLinearGradient(0, 0, 0, c.height);
      g.addColorStop(0, `rgb(${top},${top},${top})`);
      g.addColorStop(0.5, `rgb(${mid},${mid},${mid})`);
      g.addColorStop(1, `rgb(${bottom},${bottom},${bottom})`);
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, c.width, c.height);

      // Weiche Fläche am Zenit. Der Radius ist bewusst groß: je kleiner die
      // Lichtquelle, desto schärfer das Spitzlicht auf dem Stoff.
      if (softness > 0) {
        const lift = Math.round((255 - top) * softness);
        if (lift > 0) {
          const r = ctx.createRadialGradient(c.width * 0.5, 0, 0, c.width * 0.5, 0, c.height * 1.25);
          r.addColorStop(0, `rgba(255,255,255,${(lift / 255).toFixed(3)})`);
          r.addColorStop(1, 'rgba(255,255,255,0)');
          ctx.fillStyle = r;
          ctx.fillRect(0, 0, c.width, c.height);
        }
      }

      /* Softboxen für spiegelnde Beschläge.

         Ein reiner Verlauf gibt Chrom nichts zu spiegeln — die Füße lesen sich
         als flaches Grau. Nur bei Modellen mit Chrom nötig, deshalb aus, solange
         die Einstellung 0 ist (Carlisle hat schwarze Füße).

         Der Trick liegt in der Zeilenangleichung am Ende: die Leuchtflächen
         variieren waagerecht, und danach wird jede Bildzeile auf ihren
         Ausgangsmittelwert zurückgeholt. Die vertikale Lichtverteilung — die
         den Stoff bestimmt — bleibt damit Zeile für Zeile exakt erhalten, der
         Spiegel sieht trotzdem einzelne Leuchtflächen. Ohne diesen Schritt
         verschiebt sich Energie nach oben und alle 181 Stoffe werden heller. */
      if (softbox > 0) {
        const vorher = ctx.getImageData(0, 0, c.width, c.height).data;
        const hoehe = c.height * 0.62;              // nur oberhalb des Horizonts
        const band = (mitte, breite, farbe, staerke) => {
          const gr = ctx.createLinearGradient((mitte - breite) * c.width, 0,
                                              (mitte + breite) * c.width, 0);
          gr.addColorStop(0, `rgba(${farbe},0)`);
          gr.addColorStop(0.5, `rgba(${farbe},${(staerke * softbox).toFixed(3)})`);
          gr.addColorStop(1, `rgba(${farbe},0)`);
          ctx.fillStyle = gr;
          ctx.fillRect((mitte - breite) * c.width, 0, 2 * breite * c.width, hoehe);
        };
        for (const [m, b, s] of [[0.10, 0.10, 0.95], [0.36, 0.07, 0.75],
                                 [0.62, 0.12, 0.95], [0.86, 0.06, 0.60]]) {
          band(m, b, '255,255,255', s);
        }
        for (const [m, b] of [[0.24, 0.06], [0.49, 0.05], [0.74, 0.05]]) {
          band(m, b, '0,0,0', 0.45);
        }

        const img = ctx.getImageData(0, 0, c.width, c.height);
        const d = img.data;
        for (let y = 0; y < c.height; y++) {
          let alt = 0;
          let neu = 0;
          for (let x = 0; x < c.width; x++) {
            const i = (y * c.width + x) * 4;
            alt += vorher[i];
            neu += d[i];
          }
          const f = neu > 0 ? alt / neu : 1;
          for (let x = 0; x < c.width; x++) {
            const i = (y * c.width + x) * 4;
            d[i] = Math.min(255, d[i] * f);
            d[i + 1] = Math.min(255, d[i + 1] * f);
            d[i + 2] = Math.min(255, d[i + 2] * f);
          }
        }
        ctx.putImageData(img, 0, 0);
      }
      return c.toDataURL('image/png');
    };

    // Steht kein Studio-HDRI am Element, trägt der selbst gezeichnete
    // Verlauf das Licht. Mit HDRI bleibt er ungenutzt.
    if (mv && !mv.getAttribute('environment-image')) {
      mv.environmentImage = buildEnv(ENV_TOP, ENV_BOTTOM, D.envSoftness, D.envSoftbox);
    }


    // UV-Offset hält die Kachelung verankert. Formel gegen die drei vom
    // 3D-Artist gebackenen Familien verifiziert (Cloud/Cord/Miracle).
    // Ferrara und Vannes liegen mit gedrehten UVs im GLB: Cord braucht dort die
    // Vierteldrehung, sonst laufen die Rippen senkrecht (wie CORD_ROTATION im Render).
    const rotOf = (f) => (f.name === 'Cord' && /fmnv-(ferrara|vannes)-/.test(mv?.getAttribute('src') || '') ? 1.5707964 : f.rot);
    const offsetFor = (f, sc) => (rotOf(f) > 0.1 ? { u: -sc, v: 1 } : { u: 0, v: 1 - sc });

    /* Relief gröber kacheln als die Farbe.

       Cords Rippen liegen bei 2,3 mm. In der Übersicht ist das Sofa rund
       410 px breit bei 183 cm Objektbreite — ein Bildpunkt entspricht also
       4,5 mm. Die Rippe ist kleiner als der Pixel, der sie zeigen soll, und
       das Mipmapping mittelt sie weg. Gemessen liegen 15 der 17 Familien
       unter dieser Grenze; nur City und Napoli weben grob genug.

       KHR_texture_transform gilt pro Textur, deshalb bekommt allein die
       Normal-Map eine gröbere Kachelung. Farbe und Rauheit bleiben
       maßstabstreu — der Stoff behält seine richtige Zeichnung, nur die
       Tiefenstruktur wird auf eine darstellbare Größe gebracht. */
    const reliefScale = (f) => f.scale / (f.relief > 0 ? f.relief : 1);

    // createTexture() liefert eine frische Textur ohne Sampler-State —
    // Scale/Rotation/Offset müssen nach JEDEM setTexture() neu gesetzt werden.
    const applyXF = (tex, f, skala) => {
      if (!tex) return;
      const sc = skala || f.scale;
      const s = tex.sampler;
      s.setScale({ u: sc, v: sc });
      s.setRotation(rotOf(f));
      s.setOffset(offsetFor(f, sc));
      s.setWrapS(REPEAT);
      s.setWrapT(REPEAT);
    };

    /* ----------------------- Anisotropes Filtern -----------------------
       model-viewer stellt Texturen auf Anisotropie 4. Bei 4- bis 12-fach
       gekachelter Webstruktur und flachem Blickwinkel reicht das auf
       1x-Bildschirmen nicht: Die Rippen werden unterabgetastet und flimmern
       als Moiré. Auf Retina fällt es nicht auf, weil dort doppelt so viele
       Abtastpunkte auf dieselbe Fläche kommen — ein Kunde am normalen
       Monitor sieht es aber sehr wohl.

       Anisotropes Filtern ist genau dafür da und kostet praktisch nichts.
       Der Zugriff geht über die three.js-Szene, weil model-viewer dafür
       keine eigene Schnittstelle hat — deshalb defensiv gekapselt.
    ------------------------------------------------------------------- */
    // 16 ist das übliche Hardware-Maximum. three.js begrenzt beim Hochladen
    // selbst auf das, was die Grafikkarte kann — ein eigener WebGL-Kontext
    // zum Abfragen wäre unnötig und scheitert, wenn der Browser schon zu
    // viele Kontexte offen hat.
    const MAX_ANISO = 16;

    function schaerfeTexturen() {
      try {
        const key = Object.getOwnPropertySymbols(mv).find((x) => String(x) === 'Symbol(scene)');
        const scene = key && mv[key];
        scene?.traverse?.((o) => {
          const mat = o.material;
          if (!mat) return;
          for (const v of Object.values(mat)) {
            if (v && v.isTexture && v.anisotropy !== MAX_ANISO) {
              v.anisotropy = MAX_ANISO;
              v.needsUpdate = true;
            }
          }
        });
      } catch (err) {
        // Interner Zugriff — bricht er weg, bleibt es beim Standardwert.
        console.warn('[fmnv-p3d] Anisotropie nicht setzbar', err);
      }
    }

    const gpuCache = new Map();
    const prefetched = new Set();
    const conn = navigator.connection;
    const slowConn = !!(conn && (conn.saveData || /(^|-)2g/.test(conn.effectiveType || '')));

    const texture = (url) => {
      if (!url || !mv) return Promise.resolve(null);
      if (!gpuCache.has(url)) gpuCache.set(url, mv.createTexture(url));
      return gpuCache.get(url);
    };
    const prefetch = (url) => {
      if (!url || prefetched.has(url) || gpuCache.has(url)) return;
      prefetched.add(url);
      const img = new Image();
      img.decoding = 'async';
      img.src = url;
    };

    /* Relief und Rauheit gehören der Familie, nicht der Farbe — ein
       Farbwechsel innerhalb eines Stoffs braucht sie nicht neu. Mit 500 bis
       760 kB sind sie zugleich die schwersten Texturen des Konfigurators.
       Wer sie anstößt, bevor jemand eine Farbe wählt, nimmt dem Stoffwechsel
       seinen langen Teil. Nur HTTP-Cache, keine GPU-Textur — die entsteht
       erst in paint(), und nur für den Stoff, der wirklich gezeigt wird. */
    const vorladenStruktur = (f) => {
      if (!f || !f.structure) return;
      prefetch(f.normal);
      prefetch(f.orm);
    };

    let fabricMat = null;
    let applying = false;
    let queued = null;

    async function paint(leise) {
      if (!fabricMat) return;
      if (applying) { queued = true; return; }
      applying = true;
      // Die Topseller-Rotation färbt ohne Ladehinweis um — den hat niemand ausgelöst.
      const timer = leise ? 0 : setTimeout(() => showLoading('Stoff wird geladen …'), 140);
      let fehler = false;
      const f = family, c = color;
      /* Das Material zu Beginn festhalten: Wechselt währenddessen die
         Ausführung, ist fabricMat null oder gehört zum neuen Modell — dann
         stumm aufhören, der load-Handler malt das neue Modell ohnehin. */
      const mat = fabricMat;
      try {
        const pbr = mat.pbrMetallicRoughness;

        /* Erst alles anfordern, dann alles setzen.

           Vorher lief das nacheinander: Die Farbe wurde gesetzt, sobald sie
           da war, Relief und Rauheit erst nach ihrem jeweils eigenen
           Download. Das Sofa wechselte dadurch sichtbar in zwei Schritten —
           zuerst die Farbe, dann die Struktur — und die Wartezeit war die
           Summe aller Downloads statt die des längsten. Jetzt laufen sie
           nebeneinander und landen gemeinsam im Material.

           Struktur-Maps und Nap hängen an der Familie und stehen nach dem
           ersten Stoff im Cache; ein reiner Farbwechsel wartet deshalb nur
           noch auf das Farbbild. */
        const eigenesRelief = f.structure && !!f.normal;
        const eigeneRauheit = f.structure && !!f.orm;

        /* ------------------------------- Nap -------------------------------
           Echter Stoff liegt nicht überall gleich: Der Flor wird beim Sitzen
           und Beziehen in Richtungen gedrückt, an denen das Licht anders
           bricht. Der Fabric Tuner erzeugt das aus velvet_caracole.jpg über
           zwei Wege — eine Aufhellung/Abdunklung der Farbe im SOFT_LIGHT-Mix
           und eine Maske auf das Sheen-Gewicht. Den zweiten Weg nennt der
           Quelltext dort selbst den eigentlichen Nap-Effekt, und nur er ist
           in glTF nachbaubar: sheenColorTexture ist ein eigener Slot mit
           eigener Texturtransformation.

           Genau daran scheiterten die früheren Versuche. Wird der Nap mit der
           Stoffkachelung mitgekachelt, wiederholt er sich vielfach über die
           Sitzfläche und liest sich als Rauschen. Er braucht seine eigene,
           viel gröbere Kachelung — im Tuner eine Box-Projektion im Objektraum
           bei Scale 1 bis 3, hier dieselbe Größenordnung auf der UV.

           Textur, Swatch-Helligkeit und die daraus gerechnete Verdeckung
           liefen früher hintereinander mitten im Stoffwechsel. Sie stecken
           jetzt in einem Auftrag, der neben den übrigen Texturen läuft; sein
           Ergebnis wird unten mit ihnen zusammen gesetzt. */
        const napStaerke = f.nap * NAP_INTENSITAET;
        const napAuftrag = (napStaerke > 0.001 && mat.sheenColorTexture)
          // Eigener Schutz: Der Nap ist Beiwerk. Fällt er aus, soll der Stoff
          // trotzdem erscheinen — nicht das ganze Material mit ihm scheitern.
          ? (async () => {
              const [napTex, luma] = await Promise.all([texture(NAP_URL), helligkeit(c.swatch)]);
              if (!napTex) return null;

              // Helle Stoffe vertragen kaum Nap — auf Weiß und Beige liest
              // sich dieselbe Fleckigkeit als Verschmutzung statt als
              // Florrichtung. Kurve wie im Tuner: bis Luminanz 0,65 von voll
              // auf 15 % herunter.
              const t = Math.min(Math.max(luma / 0.65, 0), 1);
              const daempfung = 1 - t * 0.85;

              // nap_strength als Fleckigkeit — im Tuner der SOFT_LIGHT-Mix
              // auf die Farbe, hier die Verdeckung. Beide wirken unabhängig
              // vom Blickwinkel, das ist die tragende Gemeinsamkeit.
              // Ersetzt die Webungs-Verdeckung im Occlusion-Slot; deren
              // Struktur liegt in der Übersicht ohnehin unter einem
              // Bildpunkt, die Rauheit im Grünkanal des ORM bleibt unberührt.
              // Sanft nach oben abflachen statt linear weiterlaufen.
              //
              // Der Tuner mischt die Fleckigkeit über SOFT_LIGHT, das von
              // sich aus begrenzt. Die Verdeckung hier multipliziert dagegen
              // ungebremst aufs Umgebungslicht: New Lucca — mit nap_strength
              // 0,5 der Höchstwert aller Familien — käme auf einer dunklen
              // Farbe auf 48 % Abdunklung. Die Kurve hält die Abstände der
              // Familien im unteren Bereich fast unverändert und läuft erst
              // oben gegen die Grenze.
              const FLECK_MAX = 0.45;
              const roh = napStaerke * daempfung;
              const fleck = FLECK_MAX * (1 - Math.exp(-roh / FLECK_MAX));
              const aoTex = (fleck > 0.01 && mat.occlusionTexture)
                ? await napVerdeckung(fleck)
                : null;
              return { napTex, aoTex };
            })().catch(() => null)
          : null;

        const [base, n, om, nap] = await Promise.all([
          texture(c.tex),
          eigenesRelief ? texture(f.normal) : null,
          eigeneRauheit ? texture(f.orm) : null,
          napAuftrag,
        ]);

        pbr.baseColorTexture.setTexture(base);
        applyXF(base, f);

        // Struktur-Maps: eigene der Familie, sonst die im GLB gebackenen.
        // Sie müssen dieselbe UV-Transform bekommen wie das Farbbild, sonst
        // liegen Webstruktur und Farbe in unterschiedlicher Kachelung
        // übereinander und der Stoff wirkt unruhig.
        if (f.structure) {
          if (eigenesRelief) {
            mat.normalTexture.setTexture(n);
            applyXF(n, f, reliefScale(f));
          } else if (mat.normalTexture?.texture) {
            applyXF(mat.normalTexture.texture, f, reliefScale(f));
          }
          // Ein Bild bedient zwei Kanäle: glTF liest die Rauheit aus Grün,
          // die Verdeckung aus Rot. Deshalb dieselbe Textur auf beide Slots.
          // Verdeckung und Rauheit müssen dieselbe Kachelung haben wie das
          // Relief, nicht wie die Farbe: Der Schatten gehört in die Rille.
          // Läuft er quer darüber, hebt er die Vertiefung nicht hervor und
          // der Stoff wirkt flach, obwohl das Relief da ist.
          if (eigeneRauheit) {
            pbr.metallicRoughnessTexture.setTexture(om);
            applyXF(om, f, reliefScale(f));
            // Rot des ORM ist die Verdeckung. Ohne sie bleiben die
            // Vertiefungen des Gewebes gleich hell wie die Erhebungen —
            // der Stoff wirkt dann flach, egal wie stark das Relief ist.
            if (mat.occlusionTexture) {
              mat.occlusionTexture.setTexture(om);
              applyXF(om, f, reliefScale(f));
            }
          } else if (pbr.metallicRoughnessTexture?.texture) {
            applyXF(pbr.metallicRoughnessTexture.texture, f, reliefScale(f));
          }
        } else {
          // Bei 90° gedrehter UV drehen sich die Normalenvektoren nicht mit;
          // das liest sich als Glanzschleier. Dann lieber ohne Struktur.
          mat.normalTexture?.setTexture(null);
          pbr.metallicRoughnessTexture?.setTexture(null);
        }

        // Faserrichtung: Cord und flach gewebte Stoffe reflektieren entlang
        // der Webrichtung anders als quer dazu. Die Werte stammen aus
        // fabrictuner.json; wirksam erst mit der Anisotropie-Erweiterung im GLB.
        mat.setAnisotropyStrength?.(f.aniso ?? 0);
        mat.setAnisotropyRotation?.(rotOf(f) > 0.1 ? 1.5707964 : 0);

        pbr.setRoughnessFactor(f.rough);
        mat.setSheenRoughnessFactor?.(f.sheenRough);
        mat.setSpecularFactor(f.spec);

        if (nap) {
          mat.sheenColorTexture.setTexture(nap.napTex);
          const s = nap.napTex.sampler;
          s.setScale({ u: f.napScale, v: f.napScale });
          s.setRotation(0);
          s.setOffset({ u: 0, v: 0 });
          s.setWrapS(REPEAT);
          s.setWrapT(REPEAT);

          // Der Tuner rechnet die beiden Werte NICHT zusammen:
          //   Sheen Weight    = velvet_strength × Nap-Maske(0,5…1,2)
          //   Farbfleckigkeit = nap_strength     (SOFT_LIGHT-Mix)
          // nap_strength erzeugt dort also keinen Schimmer, sondern die
          // Fleckigkeit; velvet_strength allein bestimmt den Schimmer und
          // wird von der Maske nur moduliert. Cord steht auf 0 und darf
          // deshalb gar nicht schimmern.
          const v = Math.min(1, f.sheen * NAP_SCHIMMER);
          mat.setSheenColorFactor([v, v, v]);

          if (nap.aoTex) {
            mat.occlusionTexture.setTexture(nap.aoTex);
            const a = nap.aoTex.sampler;
            a.setScale({ u: f.napScale, v: f.napScale });
            a.setRotation(0);
            a.setOffset({ u: 0, v: 0 });
            a.setWrapS(REPEAT);
            a.setWrapT(REPEAT);
          }

          // Menge und Schärfe des Schimmers sind zwei Dinge. Die
          // Weichheitswerte des Tuners stammen aus Cycles; unter dem
          // Verlaufslicht hier liest dieselbe Zahl als enges Glanzlicht —
          // Miracle etwa steht auf 0,1 und wirkt dadurch speckig. Deshalb
          // eine Untergrenze: weicher als vorgegeben ja, härter nie.
          mat.setSheenRoughnessFactor?.(Math.max(f.sheenRough, NAP_WEICHHEIT));
        } else {
          mat.sheenColorTexture?.setTexture(null);
          mat.setSheenColorFactor([f.sheen, f.sheen, f.sheen]);
        }

      } catch (e) {
        if (mat !== fabricMat) { /* Modell inzwischen gewechselt — kein Fehler */ }
        else {
        /* Reißt der Download ab (Mobilfunk, CDN-Hänger), bliebe die Ablehnung
           im Cache und der Stoff wäre bis zum Neuladen tot — die Auswahl
           zeigte längst die neue Farbe, das Sofa nicht. Einträge verwerfen,
           damit der nächste Klick es erneut versucht, und das sagen. */
        [c.tex, f.normal, f.orm].forEach((u) => { if (u) gpuCache.delete(u); });
        console.warn('[fmnv-p3d] Stoff konnte nicht geladen werden', e);
        fehler = true;
        showLoading('Stoff konnte nicht geladen werden — bitte Farbe erneut wählen.');
        }
      } finally {
        schaerfeTexturen();
        clearTimeout(timer);
        if (fehler) setTimeout(hideLoading, 4000); else hideLoading();
        applying = false;
        if (queued) { queued = false; paint(); } else { scheduleThumbs(); }
      }
    }

    function showLoading(text) {
      if (!loadingEl) return;
      const t = loadingEl.querySelector('[data-p3d-loading-text]');
      if (t && text) t.textContent = text;
      loadingEl.hidden = false;
    }
    const hideLoading = () => { if (loadingEl) loadingEl.hidden = true; };
    const skeletonEl = root.querySelector('[data-p3d-skeleton]');
    const hideSkeleton = () => { if (skeletonEl) skeletonEl.hidden = true; };

    /* --------------------------- UI --------------------------- */
    /* Test 2026-09-15: Stoff und Farbe in einem Schritt. Je Stoff eine Zeile —
       links die große Probe, rechts seine Farben. Neu gebaut wird die Liste
       nur bei Filter- oder Ausführungswechsel; ein Farbklick setzt nur die
       Markierung um (markiereStoffFarben), damit auf dem Telefon nichts
       springt. Der Farbtonfilter wirkt auf die Farben jeder Zeile, ein Stoff
       ohne passende Farbe fällt heraus. */
    function renderFamilies() {
      famEl.innerHTML = '';
      const zeilen = visibleFamilies()
        .map((f) => [f, tone.size ? f.colors.filter((c) => tone.has(c.tone)) : f.colors])
        .filter(([, farben]) => farben.length);
      if (!zeilen.length) {
        const p = document.createElement('p');
        p.className = 'fmnv-p3d__empty';
        p.textContent = 'Kein Stoff passt zu diesen Filtern.';
        famEl.appendChild(p);
      }
      zeilen.forEach(([f, farben]) => {
        const z = document.createElement('div');
        z.className = 'fmnv-p3d__sf';
        z._familie = f;
        z._farben = farben;
        // Stoffart neben dem Namen; bei „Cord – Cord" nur einmal. Die Farbzahl
        // entfällt (Marc, 2026-09-15) — die Farben stehen ja daneben.
        const art = f.type && f.type.toLowerCase() !== f.name.toLowerCase() ? f.type : '';
        z.innerHTML =
          `<button type="button" class="fmnv-p3d__sf-img">${aufpreisHinweis(f)}</button>
           <button type="button" class="fmnv-p3d__sf-zoom" aria-label="${f.name} im Vollbild zeigen">
             <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15.5 15.5L20 20M10.5 7.5v6M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
           </button>
           <div class="fmnv-p3d__sf-body">
             <div class="fmnv-p3d__sf-head">
               <strong>${f.name}</strong>
               ${art ? `<span>${art}</span>` : ''}
               <em class="fmnv-p3d__sf-muster" hidden></em>
             </div>
             <div class="fmnv-p3d__sf-name"></div>
             <div class="fmnv-p3d__sf-colors" role="radiogroup" aria-label="Farben von ${f.name}"></div>
           </div>`;
        const reihe = z.querySelector('.fmnv-p3d__sf-colors');
        farben.forEach((c) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'fmnv-p3d__sf-color';
          b._farbe = c;
          b.style.backgroundImage = `url('${c.tile || c.swatch}')`;
          b.title = `${c.label} · ${c.code}`;
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-label', `${f.name} ${c.label} (${c.code})`);
          b.addEventListener('pointerenter', (e) => {
            prefetch(c.tex);
            // Mit der Maus zeigt die Probe links die Farbe schon beim
            // Drüberfahren; auf dem Telefon ist der Tipp selbst die Wahl.
            if (e.pointerType === 'mouse') zeigeInZeile(z, c);
          });
          b.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') zeigeInZeile(z); });
          b.addEventListener('pointerdown', () => { if (!slowConn) texture(c.tex); }, { passive: true });
          b.addEventListener('click', () => selectColor(c));
          reihe.appendChild(b);
        });
        /* Die schweren Struktur-Maps schon beim Annähern an die Zeile holen,
           nicht erst beim Klick auf eine ihrer Farben. Auf dem Telefon gibt
           es kein Darüberfahren — dort trägt pointerdown den Vorsprung, der
           dem Klick um die Fingerbewegung vorausgeht. */
        z.addEventListener('pointerenter', () => vorladenStruktur(f), { passive: true });
        z.addEventListener('pointerdown', () => vorladenStruktur(f), { passive: true });

        // Die große Probe wählt die Farbe, die sie gerade zeigt.
        z.querySelector('.fmnv-p3d__sf-img').addEventListener('click', () => selectColor(z._zeigt));
        z.querySelector('.fmnv-p3d__sf-zoom').addEventListener('click', () => zeigeLupe(z));
        famEl.appendChild(z);
      });
      markiereStoffFarben();
      renderBestseller();
      // Nach jedem Neuaufbau die Häkchen der gemerkten Muster wieder setzen.
      if (startFertig) markSampled();
      renderFabFilter();
      // Mobil ist die Eigenschaftsreihe wischbar — ohne Pfeil sähe man das nicht.
      ruesteWischreihe(root.querySelector('[data-p3d-fabfilter]'));
      syncKauf();
      passeZeilenFarbenAn();
    }

    /* Bestseller-Zeile über der Stoffliste: bis zu 10 Stoff-Farb-Kombinationen
       aus D.bestseller (Farbcodes). Ein Tipp wählt Stoff und Farbe in einem
       Schritt wie ein Farbkreis der Liste. Es erscheinen nur Farben, die es
       für die gewählte Ausführung gibt; ohne Treffer bleibt die Zeile weg. */
    const bsEl = root.querySelector('[data-p3d-bestseller]');
    const bsRow = root.querySelector('[data-p3d-bestseller-row]');
    function bestsellerFarben() {
      const codes = String(D.bestseller || '').split(/[,\s]+/).filter(Boolean);
      const alle = bestellbareFamilien().flatMap((f) => f.colors);
      return codes.map((k) => alle.find((c) => c.code === k)).filter(Boolean).slice(0, 10);
    }
    function renderBestseller() {
      zeichneBildleiste();
      if (!bsEl || !bsRow) return;
      const treffer = bestsellerFarben();
      bsRow.innerHTML = '';
      bsEl.hidden = !treffer.length;
      treffer.forEach((c, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__bs-item';
        b._farbe = c;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', `Bestseller ${i + 1}: ${c.fam.name} ${c.label} (${c.code})`);
        b.innerHTML = `<span class="fmnv-p3d__bs-img" style="background-image:url('${c.tile || c.swatch}')"></span>
          <span class="fmnv-p3d__bs-name">${c.fam.name}</span>
          <span class="fmnv-p3d__bs-farbe">${c.label}</span>`;
        b.addEventListener('pointerenter', () => prefetch(c.tex));
        b.addEventListener('pointerdown', () => { if (!slowConn) texture(c.tex); }, { passive: true });
        b.addEventListener('click', () => { melde('konfigurator', 'bestseller', `${c.fam.name} ${c.label}`); selectColor(c); });
        bsRow.appendChild(b);
      });
      markiereBestseller();
    }
    /* Topseller-Leiste unten im Bild (Marc, 2026-10-20). Umrandet ist immer die Farbe, die
       das Bild gerade zeigt — auch während der Rotation; ein Tipp wählt sie wie ein Farbkreis. */
    let bildleiste = null;
    function zeichneBildleiste() {
      const vm = root.querySelector('.fmnv-p3d__viewer-main');
      if (!vm) return;
      if (!bildleiste) {
        bildleiste = document.createElement('div');
        bildleiste.className = 'fmnv-p3d__bsbar';
        bildleiste.setAttribute('role', 'radiogroup');
        bildleiste.setAttribute('aria-label', 'Bestseller-Farben');
        vm.appendChild(bildleiste);
      }
      const treffer = bestsellerFarben();
      bildleiste.innerHTML = '';
      bildleiste.hidden = treffer.length < 2;
      treffer.forEach((c) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__bsbar-item';
        b._farbe = c;
        b.title = `${c.fam.name} ${c.label}`;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', `Bestseller ${c.fam.name} ${c.label}`);
        b.style.backgroundImage = `url('${c.swatch || c.tile}')`;
        b.addEventListener('pointerenter', () => prefetch(c.tex));
        b.addEventListener('click', () => { melde('konfigurator', 'bestseller_bild', `${c.fam.name} ${c.label}`); selectColor(c); });
        bildleiste.appendChild(b);
      });
      /* Dass es weit mehr gibt als die zehn (Marc, 2026-10-20): Zähler am Ende, öffnet Stoff & Farbe. */
      const fams = bestellbareFamilien();
      const mehr = fams.reduce((n, f) => n + f.colors.length, 0) - treffer.length;
      if (mehr > 0) {
        const m = document.createElement('button');
        m.type = 'button';
        m.className = 'fmnv-p3d__bsbar-mehr';
        m.innerHTML = `+${mehr} Farben<small>${fams.length} Stoffe</small>`;
        m.setAttribute('aria-label', `Alle ${mehr + treffer.length} Farben in ${fams.length} Stoffen ansehen`);
        m.addEventListener('click', () => { melde('konfigurator', 'bestseller_mehr', String(mehr)); unlockFabrics(); });
        bildleiste.appendChild(m);
      }
      markiereBestseller();
    }
    function markiereBestseller() {
      bildleiste?.querySelectorAll('.fmnv-p3d__bsbar-item').forEach((b) => {
        b.classList.toggle('is-active', b._farbe === color);
        b.setAttribute('aria-checked', String(b._farbe === color));
        // Mobil passt nicht jede Farbe in die Leiste: die gezeigte hineinrollen (kein scrollIntoView — das rollt die Seite).
        if (b._farbe === color) bildleiste.scrollTo({ left: b.offsetLeft - (bildleiste.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' });
      });
      if (!bsRow) return;
      bsRow.querySelectorAll('.fmnv-p3d__bs-item').forEach((b) => {
        const an = farbeBestaetigt && b._farbe === color;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-checked', String(an));
      });
    }

    /* Welche Farbe eine Zeile zeigt: die gewählte, wenn sie dazugehört, sonst
       dieselbe Farbbezeichnung — so vergleicht man Stoffe in ähnlicher Farbe —
       und erst dann die erste der Zeile. */
    function zeileFarbe(z) {
      const farben = z._farben;
      if (farben.includes(color)) return color;
      const werbung = zeigefarbe(z._familie);
      return farben.find((c) => c.label.toLowerCase() === color.label.toLowerCase())
        || (farben.includes(werbung) ? werbung : farben[0]);
    }
    function zeigeInZeile(z, c) {
      c = c || zeileFarbe(z);
      z._zeigt = c;
      const bild = z.querySelector('.fmnv-p3d__sf-img');
      bild.style.backgroundImage = `url('${c.tile || c.swatch}')`;
      bild.setAttribute('aria-label', `${z._familie.name} in ${c.label} wählen`);
      z.querySelector('.fmnv-p3d__sf-name').textContent = `${c.label} · ${c.code}`;
    }
    // Markiert wird erst nach einem bewussten Klick — die Vorbelegung beim
    // Laden hat der Kunde nicht gewählt.
    function markiereStoffFarben() {
      famEl.querySelectorAll('.fmnv-p3d__sf').forEach((z) => {
        z.classList.toggle('is-current', farbeBestaetigt && z._familie === family);
        z.querySelectorAll('.fmnv-p3d__sf-color').forEach((b) => {
          const an = farbeBestaetigt && b._farbe === color;
          b.classList.toggle('is-active', an);
          b.setAttribute('aria-checked', String(an));
        });
        zeigeInZeile(z);
      });
      markiereBestseller();
      // Erst nach dem Start: platziereMusterknopf braucht musterHeimat, das
      // weiter unten im Skript entsteht.
      if (startFertig) platziereMusterknopf();
    }

    /* Farbkreise so groß, wie der Platz es zulässt (Marc, 2026-09-15).

       Nach einem Farbfilter stehen je Stoff oft nur ein bis drei Farben da —
       als 40-px-Punkte neben einer großen Probe wirkten sie verloren. Gewählt
       wird die größte Stufe, bei der auch der Stoff mit den meisten sichtbaren
       Farben noch neben seine Probe passt. Einheitlich für die ganze Liste:
       unterschiedlich große Kreise von Zeile zu Zeile sähen unruhig aus.
       Gemessen statt gerechnet — Spaltenbreite, Probenhöhe und Abstände kommen
       aus dem Layout, damit es mobil (Raster) wie am Schreibtisch (Umbruch)
       stimmt. Die kleinste Stufe ist die bisherige Größe. */
    const FARBSTUFEN = [64, 56, 48, 40, 36];
    function passeZeilenFarbenAn() {
      const zeilen = [...famEl.querySelectorAll('.fmnv-p3d__sf')];
      const probe = zeilen[0];
      const reihe = probe?.querySelector('.fmnv-p3d__sf-colors');
      const bild = probe?.querySelector('.fmnv-p3d__sf-img');
      // Im geschlossenen Schritt hat nichts eine Breite.
      if (!reihe || !bild || !reihe.clientWidth) return;
      const mindest = matchMedia('(max-width: 989px)').matches ? 40 : 36;
      const cs = getComputedStyle(reihe);
      const spalte = parseFloat(cs.columnGap) || 8;
      const zeile = parseFloat(cs.rowGap) || 8;
      const breite = reihe.clientWidth;
      const hoehe = bild.getBoundingClientRect().height;
      const meiste = Math.max(...zeilen.map((z) => z._farben.length));
      let wahl = mindest;
      for (const s of FARBSTUFEN) {
        if (s < mindest) break;
        const proReihe = Math.max(1, Math.floor((breite + spalte) / (s + spalte)));
        const reihen = Math.ceil(meiste / proReihe);
        if (reihen * (s + zeile) - zeile <= hoehe) { wahl = s; break; }
      }
      zeilen.forEach((z) => z.style.setProperty('--p3d-sf-farbe', wahl + 'px'));
    }
    (() => {
      let warBreite = innerWidth;
      addEventListener('resize', () => {
        if (innerWidth === warBreite) return;
        warBreite = innerWidth;
        requestAnimationFrame(passeZeilenFarbenAn);
      });
    })();

    /* Lupe: der Stoff der Zeile im Vollbild, in der Farbe, die die Probe
       gerade zeigt. <dialog> liegt in der obersten Ebene — über Viewer,
       Kaufleiste und Shopify-Leiste — und schließt mit Esc. Zusätzlich
       schließt jeder Tipp: aufs Kreuz, aufs Bild oder daneben. Wer ein
       Vollbild öffnet, will nur schauen; ein Schließen, das man suchen
       muss, wäre hier die Hürde. */
    const lupeEl = root.querySelector('[data-p3d-lupe]');
    function zeigeLupe(z) {
      if (!lupeEl || !z._zeigt) return;
      const c = z._zeigt, f = z._familie;
      const art = f.type && f.type.toLowerCase() !== f.name.toLowerCase() ? ` ${f.type}` : '';
      const bild = lupeEl.querySelector('img');
      bild.src = c.preview || c.tile || c.swatch;
      bild.alt = `${f.name} ${c.label}`;
      lupeEl.querySelector('[data-p3d-lupe-text]').textContent = `${f.name}${art} · ${c.label} ${c.code}`;
      document.documentElement.classList.add('fmnv-p3d-lupe-offen');
      lupeEl.showModal();
      // Einziger Aufrufer ist der Lupen-Knopf einer Stoffzeile.
      melde('konfigurator', 'stoff_lupe', `${f.name} ${c.label}`);
    }
    lupeEl?.addEventListener('click', () => lupeEl.close());
    // Auch Esc schließt — dann muss die Scrollsperre ebenso gehen.
    lupeEl?.addEventListener('close', () => document.documentElement.classList.remove('fmnv-p3d-lupe-offen'));

    /* Die Stoffkarte so hoch wie der Platz zwischen angeheftetem Viewer und
       fixierter Kaufleiste — nicht höher.

       Mit dem festen 4:3-Bild war die Karte auf einem iPhone 272 px hoch, der
       Streifen dazwischen bot 251: Der Knopf „Auswählen" stand unter der
       Kaufleiste, und wer den Stoff wählen wollte, musste erst scrollen und
       verlor dabei das Sofa. Gemessen wird in der Arbeitsposition (Viewer
       oben, Reiter darunter), unabhängig davon, wo die Seite gerade steht:
       Abstand Panel→Reihe ist scrollfest, die Stagehöhe wird gemessen.
       Nur das Bild gibt nach; Name, Farbzahl und Knopf bleiben,
       wie sie sind. Auf hohen Telefonen deckelt 4:3 — breiter als hoch soll
       die Probe nicht werden, sonst ist die Struktur nicht mehr zu beurteilen.

       Wächst das Fenster (Adressleiste fährt ein), bleibt die Karte stehen:
       Sonst atmete sie bei jeder Scrollbewegung mit. Schrumpft es oder wechselt
       die Breite, wird neu gemessen. */
    const STOFFBILD_MIN = 110;
    let stoffkartenBasis = 0;
    function passeStoffkartenAn() {
      if (!famEl) return;
      const schmal = innerWidth <= 989;
      const karte = famEl.querySelector('.fmnv-p3d__fabric');
      const bild = karte?.querySelector('.fmnv-p3d__fabric-img');
      if (!schmal || !karte || !bild || !famEl.offsetParent) {
        famEl.style.removeProperty('--p3d-stoffbild-h');
        stoffkartenBasis = 0;
        return;
      }
      const panel = famEl.closest('.fmnv-p3d__panel');
      const kauf = root.querySelector('.fmnv-p3d__buy');
      if (!panel) return;
      /* Direkt gemessen statt aus --p3d-stage-h gelesen: Beim ersten Aufbau
         steht der Stoffschritt schon offen, bevor der Beobachter die
         Stagehöhe eingetragen hat. Ohne Anheften (Querformat) zählt sie
         nicht — dann scrollt die Seite ohnehin frei. */
      const stage = root.querySelector('.fmnv-p3d__stage');
      const stageH = stage && getComputedStyle(stage).position === 'sticky'
        ? stage.getBoundingClientRect().height : 0;
      const kaufH = kauf && getComputedStyle(kauf).position === 'fixed'
        ? kauf.getBoundingClientRect().height : 0;
      const reiheOben = stageH + (famEl.getBoundingClientRect().top - panel.getBoundingClientRect().top);
      // 12 px Luft, damit die Karte nicht an der Kaufleiste klebt.
      const platz = innerHeight - kaufH - reiheOben - 12;
      // Was die Karte außer dem Bild noch braucht.
      const rest = karte.getBoundingClientRect().height - bild.getBoundingClientRect().height;
      const breite = bild.getBoundingClientRect().width;
      const h = Math.round(Math.max(STOFFBILD_MIN, Math.min(platz - rest, breite * 3 / 4)));
      famEl.style.setProperty('--p3d-stoffbild-h', h + 'px');
      stoffkartenBasis = innerHeight;
    }
    (() => {
      let warBreite = innerWidth;
      addEventListener('resize', () => {
        const breiteNeu = innerWidth !== warBreite;
        warBreite = innerWidth;
        if (breiteNeu || (stoffkartenBasis && innerHeight < stoffkartenBasis - 8)) {
          requestAnimationFrame(passeStoffkartenAn);
        }
      });
    })();

    /* Die Kacheln wechselten früher alle drei Sekunden die Farbe. Das las
       sich als „hier wird die Farbe gewählt" — Kunden warteten auf ihre Farbe
       oder klickten sie an. Die Karten stehen jetzt still; die Farbauswahl
       zeigen die Punkte darunter. */

    /* Zwei Schritte statt einer langen Liste.

       Der Farbblock bleibt gesperrt, bis der Stoff steht — bei 17 Stoffen und
       181 Farben ist beides gleichzeitig zu viel. Beim Weitergehen klappt der
       Stoffblock zu und gibt dem Farbblock die Fläche, die er braucht. */
    const stepEls = {};
    root.querySelectorAll('[data-p3d-step]').forEach((el) => { stepEls[el.dataset.p3dStep] = el; });

    /* Reiterleiste. Sie zeigt den Titel jedes Schritts und, sobald etwas
       gewählt ist, die Auswahl darunter — so bleibt sichtbar, was in den
       geschlossenen Schritten steht. Gesperrte Reiter sind erkennbar, aber
       nicht anklickbar. */
    function renderTabs() {
      const el = root.querySelector('[data-p3d-tabs]');
      if (!el) return;
      /* Die Reiter werden bei fast jeder Eingabe neu gebaut. Wer per Tastatur
         auf einem stand, verlor den Fokus an <body> und begann oben auf der
         Seite. Deshalb merken, welcher Reiter fokussiert war. */
      const fokusNr = el.contains(document.activeElement)
        ? document.activeElement.closest('.fmnv-p3d__tab')?.dataset.nr : null;
      el.innerHTML = '';
      Object.entries(stepEls).forEach(([nr, step]) => {
        const gesperrt = step.classList.contains('is-locked');
        const aktiv = step.classList.contains('is-open');
        const titel = step.querySelector('.fmnv-p3d__step-title')?.textContent || '';
        const wert = step.querySelector('.fmnv-p3d__step-value')?.textContent || '';
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__tab' + (aktiv ? ' is-active' : '') + (gesperrt ? ' is-locked' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', String(aktiv));
        b.dataset.nr = nr;
        b.disabled = gesperrt;
        b.innerHTML = `<span class="fmnv-p3d__tab-num">${nr}</span>` +
                      `<span class="fmnv-p3d__tab-text"><strong>${titel.replace(/ wählen$/, '')}</strong>` +
                      (wert ? `<em>${wert}</em>` : '') + '</span>';
        b.addEventListener('click', () => { if (!gesperrt) { openStep(nr); rasteEin(); } });
        el.appendChild(b);
      });
      if (fokusNr) el.querySelector(`.fmnv-p3d__tab[data-nr="${fokusNr}"]:not([disabled])`)?.focus();
    }

    /* Hinweise beim Erreichen des Farbschritts.

       Beide laufen genau einmal je Seitenaufruf. Ein Hinweis, der bei jedem
       Zurückspringen erneut pulsiert, wird vom Kunden als Störung gelesen —
       und nach dem zweiten Mal ohnehin übersehen. */
    let hinweiseGezeigt = false;

    function schliesseTip() {
      root.querySelector('[data-p3d-add-sample]')?.classList.remove('is-pulsing');
    }

    function zeigeHinweise() {
      if (hinweiseGezeigt) return;
      hinweiseGezeigt = true;
      const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;

      const cta = root.querySelector('[data-p3d-add-sample]');
      if (cta && !ruhig) cta.classList.add('is-pulsing');

      // Das Herz führt einmal vor, was ein Klick bewirkt — es wird kurz rot
      // und geht zurück. Gemerkt wird dabei nichts; das bleibt dem Kunden.
      const fav = root.querySelector('[data-p3d-fav]');
      if (fav && !ruhig && fav.getAttribute('aria-pressed') !== 'true') {
        fav.classList.add('is-pulsing');
        setTimeout(() => {
          fav.classList.add('is-demo');
          setTimeout(() => fav.classList.remove('is-demo'), 900);
        }, 600);
        setTimeout(() => fav.classList.remove('is-pulsing'), 4000);
      }
    }

    let offenerSchritt = null;
    function openStep(nr) {
      // In Stoff & Farbe wählt man nur noch über die Liste — das Bild hört auf zu wechseln (Marc, 2026-10-20).
      if (String(nr) === '2') rotationStopp();
      // Neuer Schritt, neuer Inhalt: Im Konfigurier-Bildschirm beginnt die
      // Liste oben. Nur beim echten Wechsel, sonst spränge sie beim erneuten
      // Öffnen desselben Schritts zurück.
      if (String(nr) !== offenerSchritt && imBildschirm()) {
        root.querySelector('.fmnv-p3d__steps').scrollTop = 0;
      }
      offenerSchritt = String(nr);
      Object.entries(stepEls).forEach(([k, el]) => {
        const auf = k === String(nr);
        el.classList.toggle('is-open', auf);
        el.querySelector('[data-p3d-step-toggle]')?.setAttribute('aria-expanded', String(auf));
      });
      renderTabs();
      /* Der Musterknopf erscheint erst im Farbschritt. Vorher steht die
         Farbe noch nicht fest, und ein Muster ohne Farbe zu bestellen wäre
         sinnlos — sichtbar wäre der Knopf nur eine frühe Ablenkung. */
      const musterKnopf = root.querySelector('[data-p3d-add-sample]');
      if (musterKnopf) musterKnopf.hidden = String(nr) !== '2';
      if (String(nr) === '2') zeigeHinweise();
      // Test: Keine breite Materialprobe mehr — die Stoffzeilen tragen ihre
      // eigene große Probe, und neben der Farbwahl zählt das Modell.
      // Erst mit dem geöffneten Schritt hat die Farbfläche eine Höhe, an der
      // sich die Kreisgröße überhaupt bemessen lässt.
      if (String(nr) === '3') requestAnimationFrame(passeFarbgroesseAn);
      if (String(nr) === '2') requestAnimationFrame(() => { passeStoffkartenAn(); passeZeilenFarbenAn(); });
      syncKauf();
    }
    /* Die Arbeitsposition anfahren: Modellspalte oben, Reiter direkt darunter,
       die Auswahl des offenen Schritts darunter im Bild. Nur beim Wechsel des
       Schritts und nur auf dem Telefon — und nie beim Laden, sonst öffnete die
       Seite mitten im Konfigurator. Bewusst kein CSS scroll-snap: Das griff in
       jede Wischbewegung ein und ließ die Seite festhängen. */
    /* Konfigurier-Bildschirm (Test 2026-09-15): Auf dem Telefon im Hochformat
       ist der Konfigurator genau einen Bildschirm hoch, und nur die
       Schrittliste scrollt in sich (CSS am Ende von fmnv-pdp-3d.css). Erkannt
       am CSS selbst, damit Skript und Media Query nicht auseinanderlaufen. */
    function imBildschirm() {
      const steps = root.querySelector('.fmnv-p3d__steps');
      return innerWidth <= 989 && !!steps && getComputedStyle(steps).overflowY === 'auto';
    }

    function rasteEin() {
      if (root.classList.contains('is-mobile-workspace')) return;
      if (innerWidth > 989) return;
      // Im Konfigurier-Bildschirm ist der Seitenanfang die Arbeitsposition.
      if (imBildschirm()) {
        if (scrollY > 4) scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      const panel = root.querySelector('.fmnv-p3d__panel');
      const stage = root.querySelector('.fmnv-p3d__stage');
      if (!panel || !stage) return;
      if (getComputedStyle(stage).position !== 'sticky') return;
      const ziel = Math.max(0, Math.round(
        scrollY + panel.getBoundingClientRect().top - stage.getBoundingClientRect().height));
      // Steht die Seite schon dort, nicht noch einmal anfahren.
      if (Math.abs(ziel - scrollY) < 8) return;
      scrollTo({ top: ziel, behavior: 'smooth' });
    }

    function unlockFabrics() {
      stepEls['2']?.classList.remove('is-locked');
      renderTabs();
      openStep(2);
      rasteEin();
    }


    /* Ein Knopf, der in den offenen Schritt umzieht, statt zwei gleichlautende
       im Markup. Zwei Knöpfe müssten dieselbe Beschriftung und denselben
       Sperrzustand doppelt führen — und liefen beim nächsten Eingriff
       auseinander. Am Schreibtisch geht er in sein Zuhause zurück; dort trägt
       ihn die Kaufleiste, und der Schrittkörper endet mit der Auswahl. */
    const weiterInlineEl = root.querySelector('[data-p3d-advance-inline]');
    const weiterInlineHeimat = weiterInlineEl?.parentElement;
    function platziereWeiterknopf(nr) {
      if (!weiterInlineEl) return;
      const ziel = innerWidth <= 989 && (String(nr) === '1' || String(nr) === '2')
        ? root.querySelector(`[data-p3d-step="${nr}"] .fmnv-p3d__step-body`)
        : weiterInlineHeimat;
      if (ziel && weiterInlineEl.parentElement !== ziel) ziel.appendChild(weiterInlineEl);
    }

    /* Die Kaufzone folgt dem Schritt.

       Bei der Stoffwahl steht dort der Weiter-Knopf, danach die bestätigte
       Auswahl. Der Warenkorb bleibt gesperrt, bis eine Farbe wirklich
       angeklickt wurde — und sagt bis dahin, was noch fehlt. */
    function syncKauf() {
      const atcEl = root.querySelector('[data-p3d-atc]');
      const atcTextEl = root.querySelector('[data-p3d-atc-text]');
      const weiterEl = root.querySelector('[data-p3d-advance]');
      const weiterTextEl = root.querySelector('[data-p3d-advance-text]');
      const schritt = Object.entries(stepEls)
        .find(([, el]) => el.classList.contains('is-open'))?.[0] || '1';

      /* An der Stelle des Warenkorbs steht immer genau ein Knopf. Der Kunde
         soll nie zwischen „weiter" und „kaufen" wählen müssen — was als
         Nächstes dran ist, ergibt sich aus dem Schritt. */
      /* Ohne passende Variante kein Warenkorb. Die Preisgruppe des Stoffs muss
         als Variantentitel am Konfigurationsprodukt existieren; fehlt sie,
         ging bisher die zuerst gelistete Variante mit — also der falsche,
         meist zu niedrige Preis. Ein gesperrter Knopf ist der bessere Fehler,
         und im Theme-Editor fällt die Lücke damit sofort auf. */
      const variante = aktuelleVariante();
      // Test: Schritt 2 ist der letzte — Stoff und Farbe in einem.
      const fertig = farbeBestaetigt && schritt === '2' && !!variante;
      /* Das Kleingedruckte gehört zum Kaufpreis. Solange der Weiter-Knopf
         steht, gibt es keinen — auf dem Telefon blendet das Stylesheet es
         dann aus. */
      root.querySelector('.fmnv-p3d__buy')?.classList.toggle('zeigt-weiter', !fertig);
      const bereit = schritt === '1';
      /* Was der Knopf gerade sagt. Im Farbschritt gibt es kein „weiter" mehr —
         dort nennt er, was noch fehlt: die Farbe, oder eben ein Preis zu dieser
         Kombination. Gesperrt im Stoffschritt sagt er die Handlung, nicht das
         Ziel: Wer nichts ausgewählt hat, braucht keinen Hinweis auf die
         Farben, sondern den auf die Struktur. */
      const weiterText =
        schritt === '1'
          ? 'Weiter zu Stoff & Farbe'
          : (farbeBestaetigt ? 'Diese Kombination ist nicht bestellbar' : 'Wähle Stoff und Farbe');

      /* Derselbe Weg, nur an der Stelle, an der der Kunde ihn sucht: unter der
         Auswahl des offenen Schritts. Am Schreibtisch steht der Knopf im
         Kaufbereich direkt darunter und ist nicht zu übersehen; auf dem Telefon
         liegt der Kaufbereich als eigene Leiste am Bildschirmrand, hinter der
         Vertrauensleiste — und wird dort nicht mehr als Fortsetzung des
         Schritts gelesen.

         Er steht in beiden Auswahlschritten und immer, auch gesperrt: Ein
         Knopf, der erst nach der richtigen Handlung erscheint, kann sie nicht
         erklären. Im Farbschritt übernimmt der Warenkorb dieselbe Stelle. */
      const inlineEl = root.querySelector('[data-p3d-advance-inline]');
      const inlineDran = !!inlineEl && innerWidth <= 989 && schritt === '1';
      if (inlineEl) {
        inlineEl.hidden = !inlineDran;
        inlineEl.disabled = !bereit;
        const t = inlineEl.querySelector('[data-p3d-advance-inline-text]');
        if (t) t.textContent = weiterText;
      }
      platziereWeiterknopf(schritt);

      /* Der Warenkorb unter den Farben — dieselbe Stelle, an der in den
         Schritten davor der Weiter-Knopf stand. Auch er steht immer und sagt
         gesperrt, was noch fehlt. */
      const atcInlineEl = root.querySelector('[data-p3d-atc-inline]');
      const atcInlineNoteEl = root.querySelector('[data-p3d-atc-inline-note]');
      const atcInlineDran = !!atcInlineEl && innerWidth <= 989 && schritt === '2';
      if (atcInlineEl) {
        atcInlineEl.hidden = !atcInlineDran;
        atcInlineEl.disabled = !fertig;
      }
      // Die Pflichtangaben nur da, wo auch ein Preis steht.
      if (atcInlineNoteEl) atcInlineNoteEl.hidden = !(atcInlineDran && fertig);

      /* Die Kaufleiste bleibt unabhängig davon stehen, was im Schritt steht.

         Ein früherer Versuch ließ sie zurücktreten, solange der Knopf im
         Schritt im Bild war (IntersectionObserver). Das war eine Rückkopplung:
         Die Leiste ist fixiert, ihr Verschwinden ändert die Seitenhöhe, das
         verschiebt den beobachteten Knopf, der Beobachter meldet erneut — beim
         Scrollen schaukelte sich das auf, bis die Seite stand und der
         WebGL-Kontext wegbrach. Nichts an der Sichtbarkeit der Leiste darf von
         der Scrollposition abhängen. */
      if (weiterEl) {
        weiterEl.hidden = fertig;
        weiterEl.disabled = !bereit;
        if (weiterTextEl) weiterTextEl.textContent = weiterText;
      }
      if (atcEl) {
        atcEl.hidden = !fertig;
        atcEl.disabled = !fertig;
      }

      /* Zwei Zeilen: die Handlung, darunter knapp die Konfiguration. Der
         Farbcode steht schon am Swatch und an der Auswahl — im Knopf trägt
         er nichts bei und macht ihn nur voll. */
      const atcInlineTextEl = root.querySelector('[data-p3d-atc-inline-text]');
      if (fertig) {
        const ausfuehrung = konfig
          ? konfig.name + seiteZusatz(konfig) + (konfig.schlaf ? ' mit ' + FUNKTION : '')
          : '';
        const detail = [ausfuehrung, `${family.name} ${color.label}`]
          .filter(Boolean).join(' · ');
        /* Der Preisplatzhalter trägt eine Kennung, und zwei Elemente mit
           derselben wären eine Falle. Der Knopf in der Leiste behält sie —
           `preisAnzeigen` schreibt dorthin; der Knopf im Schritt bekommt seine
           eigene und wird gleich mitbefüllt. */
        const bau = (preisAttr) =>
          '<span class="fmnv-p3d__atc-haupt">In den Warenkorb</span>' +
          `<span class="fmnv-p3d__atc-detail">${detail}` +
            `<span class="fmnv-p3d__atc-preis" ${preisAttr}></span></span>`;
        if (atcTextEl) atcTextEl.innerHTML = bau('data-p3d-atc-preis');
        if (atcInlineTextEl) atcInlineTextEl.innerHTML = bau('data-p3d-atc-inline-preis');
      } else if (atcInlineTextEl) {
        atcInlineTextEl.textContent = weiterText;
      }
      preisAnzeigen();
      root.dispatchEvent(new Event('p3d:mobile-state'));
    }
    /* Auf- und Zuklappen über die gemessene Höhe: `auto` lässt sich nicht
       animieren, ein fester Wert wäre bei unterschiedlich vielen Zeilen falsch. */
    (() => {
      const knopf = root.querySelector('[data-p3d-info-toggle]');
      const box = root.querySelector('[data-p3d-infobox]');
      if (!knopf || !box) return;
      knopf.addEventListener('click', () => {
        const auf = knopf.getAttribute('aria-expanded') === 'true';
        // Nur beim Öffnen melden, nicht beim Schließen desselben Klicks.
        if (!auf) meldeEinmal3d('info', family.name);
        knopf.setAttribute('aria-expanded', String(!auf));
        knopf.classList.toggle('is-auf', !auf);
        // Aufgeklappt ist es ein Schließen-Knopf — „Weitere Informationen"
        // über den bereits sichtbaren Informationen wäre eine Lüge.
        const text = knopf.querySelector('[data-p3d-info-text]');
        if (text) text.textContent = auf ? 'Weitere Informationen' : 'Stoffdaten schließen';
        // Die Spalte wird breiter und die Probe kleiner — beides zusammen
        // schafft den Platz für die Tabelle.
        root.querySelector('.fmnv-p3d__layout')?.classList.toggle('is-stoffinfo', !auf);
        root.querySelector('.fmnv-p3d__preview')?.classList.toggle('is-info', !auf);
        if (auf) {
          box.classList.remove('is-da');
          setTimeout(() => { box.hidden = true; }, 290);
        } else {
          box.hidden = false;
          requestAnimationFrame(() => box.classList.add('is-da'));
        }
      });
    })();

    root.querySelectorAll('[data-p3d-step-toggle]').forEach((b) => {
      b.addEventListener('click', () => {
        const nr = b.dataset.p3dStepToggle;
        if (stepEls[nr]?.classList.contains('is-locked')) return;
        openStep(stepEls[nr]?.classList.contains('is-open') ? 0 : nr);
      });
    });
    root.querySelectorAll('[data-p3d-advance], [data-p3d-advance-inline]').forEach((knopf) => {
      knopf.addEventListener('click', () => {
        const schritt = Object.entries(stepEls)
          .find(([, el]) => el.classList.contains('is-open'))?.[0] || '1';
        if (schritt === '1') unlockFabrics();
      });
    });
    // Wer selbst ein Muster bestellt, braucht den Hinweis nicht mehr.
    root.querySelector('[data-p3d-add-sample]')?.addEventListener('click', schliesseTip);
    /* Startzustand ausdrücklich setzen. Sich auf die Klassen im Markup zu
       verlassen hat sich als unzuverlässig erwiesen — der Schritt „Stoff"
       stand nach dem Laden gelegentlich offen, ohne dass er freigeschaltet
       worden wäre. Hier ist der Zustand eindeutig. */
    /* Auf dem Telefon entfällt die Stoffvorschau — mit ihr aber auch der
       Musterknopf, der darin sitzt. Statt ihn zu verdoppeln, wandert er in
       den Farbschritt und beim Verbreitern wieder zurück. */
    const musterHeimat = root.querySelector('[data-p3d-add-sample]')?.parentElement;
    function platziereMusterknopf() {
      const b = root.querySelector('[data-p3d-add-sample]');
      const schmal = innerWidth <= 989;
      const mobileSlot = root.querySelector('[data-mobile-sample-slot]');
      if (b && mobileSlot && root.classList.contains('is-mobile-workspace')) {
        if (b.parentElement !== mobileSlot) mobileSlot.appendChild(b);
        return;
      }
      /* Test: Mobil steht das Muster direkt unter den Farben des gewählten
         Stoffs — am Ende der langen Liste gehörte es sichtbar zu nichts. Zieht
         der Knopf aus einer Zeile weiter oben weg, rückt alles darunter nach
         oben; die Seite rollt um genau diesen Betrag mit, damit die gerade
         angetippte Zeile unter dem Finger stehen bleibt. */
      const zeile = schmal ? famEl.querySelector('.fmnv-p3d__sf.is-current') : null;
      if (b && zeile) {
        if (b.parentElement !== zeile) {
          const vor = zeile.getBoundingClientRect().top;
          zeile.appendChild(b);
          const versatz = zeile.getBoundingClientRect().top - vor;
          // Im Konfigurier-Bildschirm scrollt die Liste, nicht die Seite.
          const scroller = imBildschirm() ? root.querySelector('.fmnv-p3d__steps') : window;
          if (Math.abs(versatz) > 1) scroller.scrollBy(0, versatz);
        }
        return;
      }
      const ziel = schmal
        ? root.querySelector('[data-p3d-step="2"] .fmnv-p3d__step-body')
        : musterHeimat;
      if (!b || !ziel) return;
      /* Der Warenkorb steht zuunterst, das Gratis-Muster darüber: Der Kauf ist
         der Abschluss des Schritts, und die Pflichtangaben hängen an ihm — mit
         dem Musterknopf dazwischen bezögen sie sich scheinbar auf den. */
      const kauf = schmal ? ziel.querySelector(':scope > [data-p3d-atc-inline]') : null;
      if (kauf) {
        if (b.nextElementSibling !== kauf) ziel.insertBefore(b, kauf);
      } else if (b.parentElement !== ziel) {
        ziel.appendChild(b);
      }
    }
    platziereMusterknopf();
    addEventListener('resize', platziereMusterknopf);

    /* Tidio-Chatknopf mobil über die Kaufleiste heben (Test 2026-09-15).

       Der Knopf lag unten rechts auf dem Warenkorb. Offizieller Weg laut
       Tidio-Hilfe „Widget Position": tidioChatApi.adjustStyles mit
       `#tidio { bottom … !important }`; der zurückgegebene styleHash nimmt
       die Regel per removeStyles wieder heraus. Geöffnet steht der Chat ohne
       Versatz — sonst schnitte er am oberen Rand ab. Die Breite prüft die
       Seite selbst: Eine Media Query in der Regel gälte im iframe des
       Widgets, nicht für die Seite. Nur auf dieser Section, also nur dort,
       wo die Kaufleiste existiert. */
    (() => {
      const kauf = root.querySelector('.fmnv-p3d__buy');
      if (!kauf) return;
      const schmal = matchMedia('(max-width: 989px)');
      let api = null, hash = null, offen = false;
      const setze = () => {
        if (!api) return;
        // removeStyles steht in der Tidio-Hilfe, fehlt aber im Platzhalter,
        // den Tidio vor dem Laden bereitstellt — nie ungeprüft aufrufen.
        if (hash && typeof api.removeStyles === 'function') api.removeStyles(hash);
        hash = null;
        if (offen || !schmal.matches || getComputedStyle(kauf).position !== 'fixed') return;
        const hoehe = Math.round(kauf.getBoundingClientRect().height);
        hash = api.adjustStyles(`#tidio { bottom: ${hoehe + 8}px !important; }`);
      };
      const bereit = () => {
        api = window.tidioChatApi;
        if (!api || typeof api.adjustStyles !== 'function') return;
        api.on('open', () => { offen = true; setze(); });
        api.on('close', () => { offen = false; setze(); });
        setze();
        new ResizeObserver(setze).observe(kauf);
        schmal.addEventListener('change', setze);
      };
      // Dasselbe Muster wie in der Tidio-Doku und in fmnv-tidio-hours.liquid.
      if (window.tidioChatApi) window.tidioChatApi.on('ready', bereit);
      else document.addEventListener('tidioChat-ready', bereit);
    })();
    /* Nur beim echten Wechsel der Breite reagieren, nicht bei jedem
       resize-Ereignis: Auf dem Telefon feuert es beim Scrollen laufend, weil
       die Adressleiste ein- und ausfährt. Ein syncKauf() daran zu hängen hieß,
       bei jeder Scrollbewegung das Layout anzufassen. */
    let warSchmal = innerWidth <= 989;
    addEventListener('resize', () => {
      const schmal = innerWidth <= 989;
      if (schmal === warSchmal) return;
      warSchmal = schmal;
      syncKauf();
    });

    /* Schritt 2 ist von Anfang an offen: Die Ausführung steht durch die
       Vorauswahl bereits fest, also gibt es nichts freizuschalten. Wer nicht
       über den Weiter-Knopf gehen will, kommt so auch über den Reiter zum
       Stoff. Nur die Farben bleiben gesperrt — ohne Stoff gibt es keine. */
    stepEls['2']?.classList.remove('is-locked');
    stepEls['3']?.classList.add('is-locked');
    renderKonfigs();

    // Filterleiste über den Stoffkarten. Zeigt nur Arten, die es auch gibt,
    // und die Anzahl je Art — sonst klickt man ins Leere.
    function renderFabFilter() {
      const fabFilterEl = root.querySelector('[data-p3d-fabfilter]');
      if (!fabFilterEl) return;
      // Der Alle-wählen-Knopf sitzt in derselben Zeile. Vor dem Leeren
      // herausnehmen und danach wieder anhängen — als dasselbe Element,
      // damit sein Klick-Listener erhalten bleibt.
      const selall = fabFilterEl.querySelector('[data-p3d-selall]');
      fabFilterEl.innerHTML = '';

      MERKMALE.forEach((m) => {
        m.werte.forEach(([wert, label]) => {
          // Merkmale ohne einen einzigen gepflegten Stoff gar nicht anbieten.
          if (!bestellbareFamilien().some((f) => f[m.id] === wert)) return;

          // Wie viele Stoffe blieben übrig, wenn genau dieses Kästchen
          // umgestellt wird? Die Zahl zeigt damit das Ergebnis des Klicks.
          const probe = new Set(filter[m.id]);
          probe.has(wert) ? probe.delete(wert) : probe.add(wert);
          const anzahl = bestellbareFamilien().filter((f) => MERKMALE.every((x) => {
            const menge = x.id === m.id ? probe : filter[x.id];
            return !menge.size || menge.has(f[x.id]);
          })).length;

          const an = filter[m.id].has(wert);
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'fmnv-p3d__fabchip' + (an ? ' is-active' : '');
          b.setAttribute('role', 'checkbox');
          b.setAttribute('aria-checked', String(an));
          b.disabled = !an && anzahl === 0;
          b.innerHTML =
            `<span class="fmnv-p3d__box" aria-hidden="true">
               <svg viewBox="0 0 24 24" width="11" height="11"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
             </span>${label}`;
          b.setAttribute('aria-label', `${label} — ${anzahl} ${anzahl === 1 ? 'Stoff' : 'Stoffe'}`);
          b.addEventListener('click', () => {
            an ? filter[m.id].delete(wert) : filter[m.id].add(wert);
            renderFabFilter();
            renderTones();
            renderFamilies();
          });
          fabFilterEl.appendChild(b);
        });
      });
      // Denselben Knopf wieder anhängen, nicht neu bauen — so bleibt sein
      // Klick-Listener erhalten.
      if (selall) fabFilterEl.appendChild(selall);
    }

    // Ein Schalter für beides: sind alle sichtbaren Stoffe gewählt, wählt er
    // ab — sonst wählt er sie zu. Zwei getrennte Knöpfe wären hier nur
    // doppelte Fläche für dieselbe Absicht.
    function syncSelAll() {
      const btn = root.querySelector('[data-p3d-selall]');
      if (!btn) return;
      const vis = visibleFamilies();
      const allOn = vis.length > 0 && vis.every((f) => chosen.has(f));
      btn.textContent = allOn ? 'Alle abwählen' : 'Alle wählen';
      btn.dataset.mode = allOn ? 'off' : 'on';
    }

    root.querySelector('[data-p3d-selall]')?.addEventListener('click', (e) => {
      const off = e.currentTarget.dataset.mode === 'off';
      visibleFamilies().forEach((f) => (off ? chosen.delete(f) : chosen.add(f)));
      // Hängt die dargestellte Farbe an einem abgewählten Stoff, bleibt sie
      // im Modell stehen — sie ist die einzige Auskunft darüber, was das
      // Sofa gerade trägt.
      renderFamilies(); renderTones(); renderColors(); syncLabels();
    });

    function renderTones() {
      const present = new Set();
      // Test: Farbtöne aller sichtbaren Stoffe — es gibt keine Vorauswahl mehr.
      visibleFamilies().forEach((f) => f.colors.forEach((c) => present.add(c.tone)));
      const order = COLOR_RULES.map(([k]) => k).filter((k) => present.has(k));
      // Ein einzelner Filter, der ohnehin alles zeigt, ist keine Auswahl.
      if (order.length < 2) { moodEl.innerHTML = ''; tone.clear(); syncMoodToggle(); return; }
      // Farbtöne, die es nach einem Stoffwechsel nicht mehr gibt, fallen
      // still heraus — sonst bliebe eine Auswahl aktiv, die nichts mehr zeigt.
      [...tone].forEach((k) => { if (!present.has(k)) tone.delete(k); });
      moodEl.innerHTML = '';
      order.forEach((key) => {
        const an = tone.has(key);
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__mood' + (an ? ' is-active' : '');
        b.innerHTML = `<i class="fmnv-p3d__tone fmnv-p3d__tone--${key}" aria-hidden="true"></i>${TONE_LABEL[key]}`;
        b.setAttribute('role', 'checkbox');
        b.setAttribute('aria-checked', String(an));
        b.addEventListener('click', () => {
          // Mehrere Farbtöne zugleich: Die Auswahl wirkt als Oder, leere
          // Auswahl heißt keine Einschränkung.
          an ? tone.delete(key) : tone.add(key);
          melde('konfigurator', 'farbton', TONE_LABEL[key]);
          renderTones(); renderColors(); renderFamilies();
        });
        moodEl.appendChild(b);
      });

      /* Gewählte Töne nach vorn. In einer wischbaren Reihe verschwindet ein
         aktiver Filter sonst nach rechts aus dem Bild, und man sieht nicht
         mehr, wonach gerade gefiltert wird. */
      [...moodEl.querySelectorAll('.fmnv-p3d__mood.is-active')]
        .reverse().forEach((b) => moodEl.prepend(b));

      // Zurücksetzen nur anbieten, wenn es etwas zurückzunehmen gibt.
      if (tone.size) {
        const r = document.createElement('button');
        r.type = 'button';
        r.className = 'fmnv-p3d__moodreset';
        r.textContent = 'Zurücksetzen';
        r.addEventListener('click', () => { tone.clear(); renderTones(); renderColors(); renderFamilies(); });
        moodEl.appendChild(r);
      }
      syncFarbansicht();
      ruesteWischreihe(moodEl);
    }

    /* Der Filter ist zugeklappt, bis jemand ihn braucht.

       Die Zahl im Knopf nennt die aktiven Filter — ohne sie filterte man
       zugeklappt unbemerkt weiter und wunderte sich über fehlende Farben. */
    function syncMoodToggle() {
      const t = root.querySelector('[data-p3d-moodtoggle]');
      const z = root.querySelector('[data-p3d-moodcount]');
      if (!t) return;
      // Gibt es gar nichts zu filtern, verschwindet auch der Knopf.
      t.hidden = !moodEl.children.length;
      if (z) {
        z.hidden = !tone.size;
        z.textContent = tone.size;
      }
    }

    /* Ablauf im Farbschritt: erst filtern, dann zeigen.

       Beim Aufklappen des Schritts stehen die Filter offen und die Swatches
       sind noch verborgen — bei bis zu 181 Farben ist die ungefilterte Fläche
       keine Auswahl, sondern eine Wand. „Auswahl anzeigen" klappt die Filter
       zu und gibt die Farben frei. */
    function syncFarbansicht() {
      const tog = root.querySelector('[data-p3d-moodtoggle]');
      const btn = root.querySelector('[data-p3d-show-colors]');
      const txt = root.querySelector('[data-p3d-show-colors-text]');
      const offen = !moodEl.hidden;
      if (tog) {
        tog.setAttribute('aria-expanded', String(offen));
        tog.classList.toggle('is-open', offen);
      }
      // Die Farben bleiben verborgen, solange die Filter offen stehen und
      // noch nichts bestätigt wurde.
      colEl.hidden = offen && !farbenGezeigt;
      root.querySelectorAll('.fmnv-p3d__colorgroup, .fmnv-p3d__colorset')
        .forEach((e) => { e.hidden = colEl.hidden; });
      if (btn) btn.hidden = !offen;
      if (txt) {
        const n = visibleColors().length;
        txt.textContent = tone.size
          ? `${n} ${n === 1 ? 'Farbe' : 'Farben'} anzeigen`
          : 'Alle Farben anzeigen';
      }
    }

    root.querySelector('[data-p3d-moodtoggle]')?.addEventListener('click', () => {
      moodEl.hidden = !moodEl.hidden;
      syncFarbansicht();
    });
    root.querySelector('[data-p3d-show-colors]')?.addEventListener('click', () => {
      farbenGezeigt = true;
      moodEl.hidden = true;
      syncFarbansicht();
    });

    // Farben aller gewählten Stoffe, in der Reihenfolge der Stoffliste.
    const allColors = () => bestellbareFamilien().filter((f) => chosen.has(f)).flatMap((f) => f.colors);

    const visibleColors = () =>
      !tone.size ? allColors() : allColors().filter((c) => tone.has(c.tone));

    /* Wischstand über einen Neuaufbau retten.

       Ein Neuaufbau setzt jede gescrollte Reihe auf Anfang zurück: Wer sich
       ans Ende gewischt hat und dort etwas antippt, steht danach wieder ganz
       links. Die Reihen selbst überleben den Neuaufbau — ersetzt wird nur ihr
       Inhalt —, die Stoffgruppen darin nicht; die werden über ihre Reihenfolge
       wiedergefunden. */
    function merkeWischstand(el) {
      if (!el) return null;
      return {
        el,
        aussen: el.scrollLeft,
        innen: [...el.querySelectorAll('.fmnv-p3d__colorset')].map((r) => r.scrollLeft),
      };
    }
    function stelleWischstandHer(stand) {
      if (!stand) return;
      const setze = () => {
        stand.el.scrollLeft = stand.aussen;
        const reihen = [...stand.el.querySelectorAll('.fmnv-p3d__colorset')];
        stand.innen.forEach((v, i) => { if (reihen[i]) reihen[i].scrollLeft = v; });
      };
      setze();
      // Nach dem Neuaufbau steht die Breite erst im nächsten Bild fest; ohne
      // die Wiederholung landet der Wert auf einer noch leeren Reihe.
      requestAnimationFrame(setze);
    }

    function renderColors() {
      // Immer alle Farben der Auswahl. Bei vielen Stoffen wird die Fläche
      // scrollbar statt die Liste zu kürzen — eine versteckte Farbe wird
      // nicht gewählt.
      const wischstand = merkeWischstand(colEl);
      colEl.innerHTML = '';
      if (!chosen.size) {
        const p = document.createElement('p');
        p.className = 'fmnv-p3d__empty';
        p.textContent = 'Wähle oben mindestens einen Stoff, um seine Farben zu sehen.';
        colEl.appendChild(p);
        return;
      }
      // Nach Stoff gruppieren. Bei mehreren Stoffen liefen die Farben sonst
      // in einer einzigen Fläche zusammen und man sähe nicht mehr, wo der
      // eine Stoff aufhört und der nächste beginnt.
      let letzterStoff = null;
      let gruppe = colEl;
      // Ob nach Stoffen gruppiert wird, entscheidet mobil über die Anordnung:
      // gruppiert stapeln sich die Reihen, ungruppiert ist colEl selbst die Reihe.
      colEl.classList.toggle('has-groups', chosen.size > 1);
      /* Die Zeile mit dem Stoffnamen steht jetzt auch bei einem einzelnen
         Stoff — sie trägt den Aufpreis, und der soll hier in jedem Fall zu
         sehen sein. Die Farbkreise bleiben bei einem Stoff wie bisher direkt
         in colEl; nur bei mehreren bekommt jeder Stoff seine eigene Reihe. */
      visibleColors().forEach((c) => {
        if (c.fam !== letzterStoff) {
          letzterStoff = c.fam;
          const kopf = document.createElement('div');
          kopf.className = 'fmnv-p3d__colorgroup';
          kopf.innerHTML = `<span>${c.fam.name}</span>${aufpreisAbzeichen(c.fam)}`;
          /* Wer mehrere Stoffe in die Auswahl genommen hat, merkt hier, dass
             einer doch nicht gefällt — dann soll er ihn auch hier loswerden,
             ohne zurück in den Stoffschritt zu müssen. */
          const weg = document.createElement('button');
          weg.type = 'button';
          weg.className = 'fmnv-p3d__groupremove';
          weg.setAttribute('aria-label', `${c.fam.name} aus der Auswahl nehmen`);
          weg.title = 'Aus der Auswahl nehmen';
          weg.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true">'
            + '<path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
          const dieserStoff = c.fam;
          weg.addEventListener('click', () => toggleFamily(dieserStoff));
          kopf.appendChild(weg);
          colEl.appendChild(kopf);
          if (chosen.size > 1) {
            gruppe = document.createElement('div');
            gruppe.className = 'fmnv-p3d__colorset';
            colEl.appendChild(gruppe);
          } else {
            gruppe = colEl;
          }
        }
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__color' + (c === color ? ' is-active' : '');
        b.dataset.key = sampleKey(c.fam, c);
        /* Die Farbe am Knopf selbst, nicht nur ihr Schlüssel: Zwei gewählte
           Stoffe können denselben Farbcode führen, dann markierte der
           Schlüssel beide. */
        b._farbe = c;
        /* Die große Kachel als Quelle, nicht der kleine Swatch: Der Kreis
           zeigt einen stark vergrößerten Ausschnitt, damit neben der Farbe
           auch die Struktur zu erkennen ist — dafür reichen 120 px nicht. */
        b.style.backgroundImage = `url('${c.tile || c.swatch}')`;
        b.title = chosen.size > 1 ? `${c.fam.name} ${c.label} · ${c.code}` : `${c.label} · ${c.code}`;
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', String(c === color));
        b.setAttribute('aria-label', `${c.fam.name} ${c.label} (${c.code})`);
        b.addEventListener('pointerenter', () => { prefetch(c.tex); vorladenStruktur(c.fam); });
        b.addEventListener('pointerdown', () => { if (!slowConn) texture(c.tex); }, { passive: true });
        b.addEventListener('click', () => selectColor(c));

        /* Herz in der Ecke: Eine Farbe merken, ohne sie erst auswählen zu
           müssen. Ein eigener Knopf statt einer Ecke im Farbknopf — ein Knopf
           im Knopf ist kein gültiges HTML und mit der Tastatur nicht
           erreichbar. */
        const huelle = document.createElement('span');
        huelle.className = 'fmnv-p3d__colorwrap';
        huelle.appendChild(b);
        const herz = document.createElement('button');
        herz.type = 'button';
        herz.className = 'fmnv-p3d__colorfav';
        herz.dataset.key = favIdVon(c.fam, c);
        herz.setAttribute('aria-label', `${c.fam.name} ${c.label} merken`);
        herz.innerHTML = '<svg viewBox="0 0 24 24" width="11" height="11" aria-hidden="true">'
          + '<path d="M12 20.3l-1.5-1.35C5.4 14.36 2 11.28 2 7.5 2 4.42 4.42 2 7.5 2c1.74 0 3.41.81 4.5 2.09C13.09 2.81 14.76 2 16.5 2 19.58 2 22 4.42 22 7.5c0 3.78-3.4 6.86-8.5 11.45L12 20.3z"'
          + ' fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/></svg>';
        herz.addEventListener('click', () => {
          if (!window.FmnvFavoriten) return;
          favUmschalten(c.fam, c).then(() => {
            markiereFavoriten();
            syncFav();
          });
        });
        huelle.appendChild(herz);
        gruppe.appendChild(huelle);
      });
      markSampled();
      markiereFavoriten();
      markiereWischbar();
      passeFarbgroesseAn();
      stelleWischstandHer(wischstand);
    }

    /* Nur die Markierung umsetzen, statt die Reihe neu zu bauen.

       Ein Klick auf eine Farbe ändert an der Liste nichts — dieselben Farben
       in derselben Reihenfolge, nur eine andere ist markiert. Der Neuaufbau
       war deshalb nicht nur unnötig, er warf den Wischstand weg: Wer die
       letzte Farbe einer langen Reihe antippte, stand danach wieder vorn. */
    function markiereAktiveFarbe() {
      colEl.querySelectorAll('.fmnv-p3d__color').forEach((b) => {
        const an = b._farbe === color;
        b.classList.toggle('is-active', an);
        b.setAttribute('aria-checked', String(an));
      });
    }

    /* Die Farbkreise so groß machen, wie die freie Fläche es zulässt.

       Wer zwei Farben gefiltert hat, sah bisher zwei kleine Punkte über einer
       leeren Fläche; wer achtzig sieht, braucht sie klein, um sie zu
       überblicken. Statt einer festen Größe wird die größte gesucht, mit der
       alle Kreise noch in den Platz passen — gemessen statt gerechnet, weil
       Stoffüberschriften und Umbrüche sonst einzeln nachzubilden wären. */
    const FARBE_MIN = 40;   // heutige Größe — die Untergrenze bei vielen Farben
    const FARBE_MAX = 84;
    const FARBE_STUFE = 4;
    function passeFarbgroesseAn() {
      // Mobil sind die Farben eine einzeilige Wischreihe fester Größe.
      if (!matchMedia('(min-width: 990px)').matches) {
        colEl.style.removeProperty('--p3d-swatch');
        colEl.style.removeProperty('max-height');
        return;
      }
      // Im geschlossenen Schritt hat nichts eine Höhe — dann gäbe es nichts
      // zu messen und das Ergebnis wäre Unsinn.
      if (!colEl.offsetParent || !colEl.querySelector('.fmnv-p3d__color')) return;
      const flaeche = colEl.closest('.fmnv-p3d__panel');
      const koerper = colEl.closest('.fmnv-p3d__step-body');
      if (!flaeche || !koerper) return;
      const oben = colEl.getBoundingClientRect().top;
      // Was unter der Farbfläche noch im Schrittkörper steht, bleibt beim
      // Wachsen gleich und muss vom Platz abgezogen werden.
      const unten = koerper.getBoundingClientRect().bottom - colEl.getBoundingClientRect().bottom;
      // Die Panelunterkante liegt unter dem sichtbaren Boden der Schrittliste —
      // die rollt ja selbst. Nur nach dem Panel gemessen bekäme die Farbfläche
      // mehr Höhe, als zu sehen ist, und die Schrittliste liefe über: zwei
      // Rollbalken nebeneinander. Es zählt, was von beiden zuerst endet.
      const roller = colEl.closest('.fmnv-p3d__steps');
      const boden = Math.min(
        flaeche.getBoundingClientRect().bottom,
        roller ? roller.getBoundingClientRect().bottom : Infinity);
      const platz = Math.max(200, boden - oben - unten - 8);
      /* `platz` ist die Zielhöhe für die Suche nach der Kreisgröße — aber
         keine Deckelung der Fläche.

         Vorher stand hier zusätzlich `colEl.style.maxHeight = platz`. Solange
         die Kreise passten, fiel das nicht auf. Passte die Liste auch bei der
         kleinsten Größe nicht mehr (viele Stoffe, viele Farben), blieb die
         Deckelung stehen, während die Farben weiterliefen: Die Fläche rollt
         seit dem 31.08.2026 nicht mehr selbst, also lief der Inhalt sichtbar
         über seinen Kasten hinaus. Die Unterkante des Schritts liegt dann
         mitten in den Farbkreisen — und weil der Schritt eine Trennlinie
         trägt, zog eine Linie quer durch die Auswahl, an einer Stelle, die
         mit keiner Stoffzeile zu tun hatte.

         Ohne Deckelung wächst der Schritt mit dem Inhalt, und es rollt wie
         vorgesehen nur die Schrittliste. */
      colEl.style.removeProperty('max-height');
      for (let s = FARBE_MAX; s >= FARBE_MIN; s -= FARBE_STUFE) {
        colEl.style.setProperty('--p3d-swatch', s + 'px');
        if (colEl.scrollHeight <= platz) break;
      }
    }
    addEventListener('resize', passeFarbgroesseAn);

    // Häkchen auf jedem Farbkreis, für den bereits eine Probe gemerkt ist.
    // Läuft über die Codes statt über einen Neuaufbau der Liste, damit beim
    // Merken kein Flackern entsteht.
    function markSampled() {
      // Die Liste mischt mehrere Stoffe — der Code allein reicht als
      // Schlüssel nicht, sonst markiert eine Probe gleichnamige Codes
      // anderer Stoffe mit.
      const picked = new Set(samples.map((s) => s.key));
      colEl.querySelectorAll('.fmnv-p3d__color').forEach((b) => {
        const on = picked.has(b.dataset.key);
        b.classList.toggle('is-sampled', on);
        const base = b.getAttribute('aria-label')?.replace(/ · Muster gemerkt$/, '') || '';
        b.setAttribute('aria-label', on ? `${base} · Muster gemerkt` : base);
      });
      /* Stoff-und-Farbe-Liste und Bestseller (2026-10-06): Häkchen auf jedem
         Farbkreis und jeder Bestseller-Kachel, deren Muster im Warenkorb liegt;
         die Stoffzeile nennt, wie viele es von ihr sind. */
      const markiere = (b, an) => {
        b.classList.toggle('is-sampled', an);
        const basis = (b.getAttribute('aria-label') || '').replace(/ · Muster im Warenkorb$/, '');
        b.setAttribute('aria-label', an ? `${basis} · Muster im Warenkorb` : basis);
      };
      famEl.querySelectorAll('.fmnv-p3d__sf').forEach((z) => {
        let n = 0;
        z.querySelectorAll('.fmnv-p3d__sf-color').forEach((b) => {
          const an = picked.has(`${b._farbe.fam.name}|${b._farbe.code}`);
          if (an) n += 1;
          markiere(b, an);
        });
        z.classList.toggle('hat-muster', n > 0);
        const tag = z.querySelector('.fmnv-p3d__sf-muster');
        if (tag) { tag.hidden = n === 0; tag.textContent = n === 1 ? '✓ 1 Muster im Warenkorb' : `✓ ${n} Muster im Warenkorb`; }
      });
      bsRow?.querySelectorAll('.fmnv-p3d__bs-item').forEach((b) => {
        markiere(b, picked.has(`${b._farbe.fam.name}|${b._farbe.code}`));
      });
    }

    /* Kennwerte des gezeigten Stoffs. Zeilen ohne Wert fallen weg, statt mit
       einem Strich dazustehen — eine leere Angabe ist keine Information. Fehlt
       alles, verschwindet auch der Aufklapper. */
    const INFO_ZEILEN = [
      ['typ',      'Stoffart'],
      ['material', 'Zusammensetzung'],
      ['scheuer',  'Scheuerbeständigkeit'],
      ['licht',    'Lichtechtheit'],
    ];
    function fuelleStoffdaten() {
      const knopf = root.querySelector('[data-p3d-info-toggle]');
      const liste = root.querySelector('[data-p3d-infoliste]');
      if (!knopf || !liste) return;
      const d = family.daten || {};
      const zeilen = INFO_ZEILEN.filter(([k]) => (d[k] || '').trim());
      liste.innerHTML = zeilen
        .map(([k, titel]) => `<dt>${titel}</dt><dd>${d[k]}</dd>`)
        .join('');
      knopf.hidden = !zeilen.length;
      const text = knopf.querySelector('[data-p3d-info-text]');
      if (text) {
        text.textContent = knopf.getAttribute('aria-expanded') === 'true'
          ? 'Stoffdaten schließen' : 'Weitere Informationen';
      }
    }

    /* Hat die Farbe ein Video, teilt sich die Probe: oben das Standbild, unten
       die Bewegung. Ohne Video bleibt alles wie bisher — die Teilung darf nicht
       zur leeren Fläche werden. */
    const videoEl = root.querySelector('[data-p3d-preview-video]');
    function zeigeStoffvideo() {
      if (!videoEl || !previewEl) return;
      const quelle = VIDEOS[(color.code || '').toUpperCase()];
      previewEl.classList.toggle('is-geteilt', !!quelle);
      if (!quelle) {
        videoEl.hidden = true;
        videoEl.pause?.();
        return;
      }
      // Nur bei echtem Wechsel neu laden, sonst startet das Video bei jedem
      // Beschriftungslauf von vorn.
      const abs = quelle.replace(/^\/\//, location.protocol + '//');
      if (videoEl.dataset.quelle !== abs) {
        videoEl.dataset.quelle = abs;
        videoEl.src = abs;
      }
      videoEl.hidden = false;
      videoEl.play?.().catch(() => { /* Autoplay verweigert — dann steht es still */ });
    }

    /* Zustand der Herzen an den Farbkreisen. Läuft über die Kennungen statt
       über einen Neuaufbau der Liste, damit beim Merken nichts flackert. */
    function markiereFavoriten() {
      if (!window.FmnvFavoriten) return;
      const gemerkt = new Set(window.FmnvFavoriten.alle().map((e) => e.id));
      colEl.querySelectorAll('.fmnv-p3d__colorfav').forEach((h) => {
        const an = gemerkt.has(h.dataset.key);
        h.classList.toggle('is-an', an);
        h.setAttribute('aria-pressed', String(an));
      });
    }

    function syncLabels() {
      root.dataset.mobileSelection = `${family.name} · ${color.label}`;
      root.dataset.mobileSwatch = color.swatch || '';
      root.dispatchEvent(new Event('p3d:mobile-selection'));
      curFamEls.forEach((el) => { el.textContent = family.name; });
      /* Der Reiter „Stoff" nennt, was gewählt wurde — leer, solange nichts
         gewählt ist. Bei mehreren Stoffen den gezeigten und die Zahl der
         übrigen: Alle Namen nebeneinander sprengen den Reiter. */
      const stoffWert = root.querySelector('[data-p3d-chosen-fabrics]');
      if (stoffWert) {
        stoffWert.textContent = farbeBestaetigt ? `${family.name} ${color.label}` : '';
      }
      curColEls.forEach((el) => {
        el.textContent = chosen.size > 1 ? `${family.name} ${color.label}` : color.label;
      });
      prevNameEls.forEach((el) => { el.textContent = `${family.name} ${color.label}`.toUpperCase(); });
      fuelleStoffdaten();
      if (previewEl) previewEl.style.backgroundImage = `url('${color.preview}')`;
      zeigeStoffvideo();
      const badge = root.querySelector('[data-p3d-preview-badge]');
      if (badge) badge.hidden = !family.popular;

      // Die gewählte Kombination steht im Titel statt in einer eigenen Zeile
      // — dieselbe Angabe, die gleich als Warenkorb-Eigenschaft mitgeht.
      /* Im Schaufenster bleibt der reine Produktname stehen: Der Stoff ist
         dort nur vorbelegt, und eine Überschrift, die „in Cord Glacier B049"
         behauptet, während das Foto einen anderen Stoff zeigt, ist schlicht
         falsch. Den Stoff nennt das Abzeichen am Bild. */
      const titel = root.querySelector('[data-p3d-title]');
      if (titel && !showroomAktiv) {
        const basis = titel.dataset.basis || titel.textContent;
        titel.textContent = `${basis} in ${family.name} ${color.label} ${color.code}`;
      }

      syncFav();

      const set = (sel, val) => root.querySelectorAll(sel).forEach((i) => { i.value = val; });
      // Bei „Cord – Cord" trägt der Produkttitel die Stoffart doppelt.
      const famType = family.type && family.type.toLowerCase() !== family.name.toLowerCase() ? ` ${family.type}` : '';
      set('[data-p3d-prop-family]', `${family.name}${famType}`);
      set('[data-p3d-prop-color]', `${color.label} (${color.code})`);
      set('[data-p3d-prop-code]', color.code);
      katPlane();

      // Config-ID ist der Variantentitel ohne die Stoffgruppe am Ende —
      // dieselbe Zerlegung wie gruppeAus(), nur andersherum.
      const av = aktuelleVariante();
      const configId = av && av.titel ? String(av.titel).split('_').slice(0, -1).join('_') : '';
      set('[data-p3d-prop-artikel]', configId ? `${configId}_${color.code}` : '');

      syncSampleButton();

      const url = new URL(location.href);
      /* Nur eine gewählte Farbe gehört in die Adresse: ?stoff= gilt beim Laden als Wahl und
         hielte die Topseller-Rotation an einer Farbe fest, die niemand ausgesucht hat. */
      if (farbeBestaetigt) url.searchParams.set('stoff', color.code.toLowerCase());
      else url.searchParams.delete('stoff');
      /* Die ganze Stoffauswahl, nicht nur die gezeigte Farbe. Ohne sie stand
         nach einem Neuladen nur noch der zuletzt betrachtete Stoff in der
         Auswahl — alle anderen Haken waren weg. */
      if (chosen.size > 1) {
        url.searchParams.set('stoffe',
          [...chosen].map((f) => f.slug || f.name).join(',').toLowerCase());
      } else {
        url.searchParams.delete('stoffe');
      }
      /* Der Pfad gehört der Ausführung, die Parameter tragen Stoff und Farbe.
         Jede Ausführung ist ein eigenes Produkt mit eigener Modellnummer —
         dann soll sie auch eine eigene, teilbare und verlinkbare Adresse
         haben, statt als Parameter an einer fremden Seite zu hängen. */
      /* Im Schaufenster bleibt die Adresse, wie sie ist: Ein hineingeschriebener
         Stoff samt `schritt` würde beim nächsten Laden den Konfigurator öffnen
         und das Schaufenster überspringen, das niemand angefasst hat. */
      if (!startFertig || showroomAktiv) return;
      if (konfig && konfig.handle) url.pathname = '/products/' + konfig.handle;
      const offen = Object.entries(stepEls)
        .find(([, el]) => el.classList.contains('is-open'))?.[0];
      if (offen) url.searchParams.set('schritt', offen);
      url.searchParams.delete('variante');
      history.replaceState(null, '', url);
      merkeZuletzt(url);
      renderTabs();
    }

    /* „Zuletzt konfiguriertes Sofa" auf Startseite, Übersicht und im Sofa-Dropdown
       (snippets/fmnv-zuletzt-sofa.liquid) liest dieses Cookie. Nicht technisch
       notwendig (TTDSG §25) — deshalb nur mit Einwilligung in Präferenzen. */
    let zlApiGeladen = false;
    function merkeZuletzt(url) {
      if (!selbstGewaehlt) return;
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) {
        if (zlApiGeladen || !window.Shopify || !window.Shopify.loadFeatures) return;
        zlApiGeladen = true;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
          (err) => { if (!err) merkeZuletzt(url); });
        return;
      }
      if (!cp.preferencesProcessingAllowed()) return;
      let bild = '';
      try { bild = (freistellerFuer(konfig, color.code)[1] || {}).u || ''; } catch (e) {}
      const wert = {
        u: url.pathname + url.search,
        t: (konfig && konfig.titel) || PRODUKT_TITEL,
        s: `${family.name} ${color.label}`,
        b: bild.replace(/width=\d+/, 'width=600'),
        e: String(color.swatch || '').replace(/^\/\//, 'https://'),
      };
      // Bis zu 3, neueste zuerst, je Ausführung (Pfad) nur die zuletzt gewählte Farbe.
      let liste = [];
      try { liste = JSON.parse(decodeURIComponent((document.cookie.match(/(?:^|;\s*)fmnv_zl=([^;]*)/) || [])[1] || '[]')); } catch (e) {}
      if (!Array.isArray(liste)) liste = [];
      liste = [wert].concat(liste.filter((x) => x && typeof x.u === 'string' && x.u.split('?')[0] !== url.pathname)).slice(0, 3);
      document.cookie = `fmnv_zl=${encodeURIComponent(JSON.stringify(liste))};path=/;max-age=2592000;SameSite=Lax;Secure`;
    }

    /* ------------------------ Preisgruppen ------------------------
       S1 kostet nichts extra. Für die übrigen Gruppen stehen die Beträge
       noch nicht fest — deshalb nennt der Hinweis die Gruppe und, sobald
       hinterlegt, den Betrag. Eine erfundene Zahl steht dort nie. */
    /* Auflösung Konfiguration + Preisgruppe → Variante.

       Der Preis steht in der Variante, nicht in einer Rechnung: Shopify nimmt
       im Checkout immer den Variantenpreis, und ohne Plus lässt er sich dort
       nicht überschreiben. Was der Kunde sieht, muss deshalb dieselbe Variante
       sein, die in den Warenkorb geht. */
    function aktuelleVariante() {
      if (!konfig) return null;
      const gruppe = family.gruppe;
      return konfig.preise.find((p) => gruppe && p.gruppe === gruppe)
          // Fehlt die Gruppe an dieser Konfiguration, ist die Kombination
          // nicht bestellbar. Dann lieber nichts als eine falsche Variante.
          || null;
    }

    function guenstigsteVariante() {
      if (!konfig || !konfig.preise.length) return null;
      return konfig.preise.reduce((a, b) => (b.cent < a.cent ? b : a));
    }

    function setzeKonfiguration(k) {
      konfig = k;
      // Jede Konfiguration hat ihr eigenes Modell — ein 2-Sitzer ist nicht der
      // beschnittene 3-Sitzer.
      // Shopify liefert Asset-URLs protokollrelativ; über http scheitert der
      // Abruf still — dieselbe Falle wie bei HDRI und Nap. setzeGlb räumt das
      // auf und hält das Modell zurück, solange das Schaufenster vorn ist.
      if (k.glb) setzeGlb(k.glb);
      /* Andere Ausführung, andere Preisgruppen: Stoffe ohne Variante fallen
         aus der Auswahl, das Modell wechselt notfalls auf einen bestellbaren. */
      const stoffGewechselt = sichereStoffwahl();
      /* Die Überschrift folgt der Ausführung.

         Bisher blieb sie auf dem Produkt stehen, mit dem die Seite geladen
         wurde: Wer vom 2-Sitzer auf den 3-Sitzer wechselte, las weiter
         „2-Sitzer mit Schlaffunktion", während Adresse, Preis und Maße längst
         zum 3-Sitzer gehörten. Der angehängte Stoff („… in Cord Glacier
         B049") bleibt dabei stehen — syncLabels() setzt ihn gleich neu, aber
         nur, wenn schon ein Stoff gewählt ist. */
      const titelEl = root.querySelector('[data-p3d-title]');
      if (titelEl && !titelEl.hasAttribute('data-p3d-title-fest') && k.titel) {
        const alt = titelEl.dataset.basis || '';
        const anhang = alt && titelEl.textContent.startsWith(alt)
          ? titelEl.textContent.slice(alt.length) : '';
        titelEl.dataset.basis = k.titel;
        titelEl.textContent = k.titel + anhang;
      }

      renderKonfigs(); syncLabels(); preisAnzeigen(); syncKauf();
      // Der Aufpreis auf den Stoffkacheln misst sich am Grundpreis dieser
      // Ausführung — mit ihr ändert er sich mit.
      renderFamilies();
      if (stoffGewechselt) { renderTones(); renderColors(); paint(); }
      // Andere Ausführung heißt andere Modellnummer — und damit andere Fotos.
      setzeFotos();

      /* Der Textteil unter dem Konfigurator ist eine eigene Section und kann
         nicht in diese Closure greifen. Statt beide zu verkoppeln, meldet der
         Konfigurator die gewählte Ausführung an das Dokument; wer die Maße
         braucht, hört zu. Ohne Zuhörer kostet das nichts.

         Der Stand wird zusätzlich hinterlegt, weil die erste Meldung schon
         beim Aufbau des Konfigurators fällt — da steht der Abschnitt darunter
         noch gar nicht und könnte sie nicht hören. Er liest sie dann nach. */
      const stand = { name: k.name, seite: k.seite || '', seiteLabel: seiteLabel(k), titel: k.titel,
                      schlaf: !!k.schlaf, masse: k.masse || '' };
      document.fmnvKonfiguration = stand;
      document.dispatchEvent(new CustomEvent('fmnv:konfiguration', { detail: stand }));
    }

    /* Zwei Achsen statt einer Kachelliste.

       Größe und Schlaffunktion sind für den Kunden getrennte Entscheidungen;
       vier gemischte Kacheln zwingen ihn, die Kombinationen selbst im Kopf zu
       bilden. Nicht angebotene Kombinationen bleiben sichtbar, aber gesperrt —
       so sieht man, dass es sie gibt, und nicht nur, dass etwas fehlt. */
    // Funktionsdeklarationen, nicht const: renderKonfigs läuft schon beim
    // ersten Zeichnen und käme sonst in die tote Zone.
    function groessen() { return [...new Set(CONFIGS.map((k) => k.name))]; }
    // seite undefined = beliebig; '' = ausdrücklich ohne Seite.
    function findeKonfig(name, schlaf, seite) {
      return CONFIGS.find((k) => k.name === name && !!k.schlaf === !!schlaf
        && (seite === undefined || (k.seite || '') === seite));
    }
    /* Die Seite heißt nie nackt „links": Der Kunde soll lesen, was links
       steht. Bei der Wohnlandschaft sind es beide Elemente, von links nach
       rechts gelesen, wie das Sofa vor einem steht — das gespeicherte Feld
       meint dort die Récamiere, die Ottomane sitzt zwangsläufig gegenüber. */
    // Funktionsdeklaration mit Literal statt const: wird vor dieser Stelle gerufen.
    function seiteLabel(k, seite) {
      const RECAMIERE = 'Récamiere';
      const s = seite === undefined ? (k.seite || '') : seite;
      if (!s) return '';
      const n = k.name || '';
      if (/wohnlandschaft/i.test(n)) {
        return s === 'links' ? `${RECAMIERE} links · Ottomane rechts` : `Ottomane links · ${RECAMIERE} rechts`;
      }
      if (/ottomane/i.test(n)) return `Ottomane ${s}`;
      const m = n.match(/R[ée]camiere|Rekamiere/);
      // Gerades Sofa ohne Element im Namen: neutral „Links"/„Rechts".
      if (!m) return s === 'links' ? 'Links' : 'Rechts';
      return `${m[0]} ${s}`;
    }
    /* Im Fließtext (Kopf, Kaufknopf) nicht doppeln: „Ecksofa mit Récamiere
       rechts" statt „Ecksofa mit Récamiere, Récamiere rechts". Nur die
       Wohnlandschaft braucht das volle Label, weil ihr Name kein Element nennt. */
    function seiteZusatz(k) {
      const s = k.seite || '';
      if (!s) return '';
      if (/R[ée]camiere|Rekamiere|Ottomane/i.test(k.name || '') && !/wohnlandschaft/i.test(k.name || '')) return ' ' + s;
      return ', ' + seiteLabel(k);
    }

    function renderKonfigs() {
      if (!konfig) return;
      const abPreis = (k) => k.preise.reduce((a, x) => (x.cent < a.cent ? x : a), k.preise[0]);
      /* „ab“ nur, wenn die Stoffgruppen dieser Form wirklich unterschiedlich kosten.
         Kostet jeder Stoff gleich viel, ist „ab 1.519 €“ schlicht falsch und weckt den
         Verdacht, der echte Preis komme erst später (Marc, 2026-09-16). */
      const preisSpanne = (k) => k.preise.some((p) => p.cent !== abPreis(k).cent);

      const achse = (el, eintraege, aktion) => {
        if (!el) return;
        el.innerHTML = '';
        eintraege.forEach(({ label, zusatz, ziel, an }) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'fmnv-p3d__cfg' + (an ? ' is-active' : '');
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', String(an));
          b.disabled = !ziel;
          b.innerHTML = `<strong>${label}</strong>` +
            (zusatz ? `<em>${zusatz}</em>` : '');
          // melde() hier, nicht in setzeKonfiguration: Die läuft auch beim
          // Start und bei der Wiederherstellung aus der Adresse.
          if (ziel) b.addEventListener('click', () => { melde('konfigurator', aktion, label); setzeKonfiguration(ziel); });
          el.appendChild(b);
        });
      };

      // Form: Einstiegspreis je Form, damit der Unterschied sofort sichtbar ist.
      const seiteJetzt = konfig.seite || '';
      achse(root.querySelector('[data-p3d-axis-size]'), groessen().map((n) => {
        const ziel = findeKonfig(n, konfig.schlaf, seiteJetzt) || findeKonfig(n, konfig.schlaf)
          || findeKonfig(n, !konfig.schlaf, seiteJetzt) || findeKonfig(n, !konfig.schlaf);
        return { label: n, ziel, an: n === konfig.name,
                 zusatz: ziel ? `${preisSpanne(ziel) ? 'ab ' : ''}${geld(abPreis(ziel).cent)}` : 'nicht verfügbar' };
      }), 'form');

      /* Funktion: nicht der Gesamtpreis, sondern der Unterschied. „ab 1.399 €"
         neben „ab 1.199 €" zwingt zum Kopfrechnen; „+ 200 €" beantwortet die
         Frage, die hier tatsächlich ansteht. */
      /* Seite: sichtbar, sobald die Serie irgendwo eine Seite kennt — auch
         beim geraden Sofa, dort dann beide gesperrt. So sieht man, dass es
         die Wahl gibt, und nicht nur, dass etwas fehlt (Marc, 2026-09-09).
         Gleicher Preis links wie rechts, deshalb ohne Preiszusatz. */
      const seiteGruppe = root.querySelector('[data-p3d-seite-group]');
      const seiteEl = root.querySelector('[data-p3d-axis-seite]');
      const hatSeite = CONFIGS.some((k) => k.seite);
      if (seiteGruppe) seiteGruppe.hidden = !hatSeite;
      if (hatSeite) {
        achse(seiteEl, ['links', 'rechts'].map((s) => {
          const ziel = findeKonfig(konfig.name, konfig.schlaf, s) || findeKonfig(konfig.name, !konfig.schlaf, s);
          return { label: seiteLabel(konfig, s), ziel, an: s === seiteJetzt,
                   zusatz: ziel ? '' : 'nicht verfügbar' };
        }), 'seite');
      } else if (seiteEl) {
        seiteEl.innerHTML = '';
      }

      const gruppe = root.querySelector('[data-p3d-sleep-group]');
      const sleepEl = root.querySelector('[data-p3d-axis-sleep]');
      // Nur zeigen, wenn diese Form eine Schlaf-Ausführung hat — ein gesperrtes
      // „Mit Schlaffunktion" beim 2,5-Sitzer verspricht, was es nicht gibt (Marc, 2026-11-02).
      const hatSchlaf = CONFIGS.some((k) => k.schlaf && k.name === konfig.name);
      if (gruppe) gruppe.hidden = !hatSchlaf;
      if (hatSchlaf) {
        const ohne = findeKonfig(konfig.name, false, seiteJetzt);
        const mit  = findeKonfig(konfig.name, true, seiteJetzt);
        const diff = ohne && mit ? abPreis(mit).cent - abPreis(ohne).cent : 0;
        achse(sleepEl, [
          { label: 'Ohne ' + FUNKTION, ziel: ohne, an: !konfig.schlaf },
          { label: 'Mit ' + FUNKTION, ziel: mit, an: !!konfig.schlaf,
            zusatz: mit ? (diff > 0 ? `+ ${geld(diff)}` : '') : 'nicht verfügbar' },
        ], 'funktion');
      } else if (sleepEl) {
        sleepEl.innerHTML = '';
      }

      /* Maße der gewählten Ausführung. Sie ändern sich mit Form und Funktion —
         ein Schlafsofa misst anders als dasselbe Modell ohne. */
      const zeilen = (konfig.masse || '').split(';')
        .map((z) => z.split('|').map((x) => x.trim()))
        .filter((t) => t[0] && t[1]);

      const box = root.querySelector('[data-p3d-specbox]');
      if (box) {
        box.hidden = !zeilen.length;
        box.innerHTML = zeilen
          .map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join('');
      }

      /* Dieselben Werte oben im Kopf. Dort standen sie bisher als fest
         gepflegte Blöcke — für alle vier Ausführungen dieselben, also beim
         3-Sitzer schlicht falsch: „183 × 97 cm" im Kopf über „Breite 274 cm"
         im Konfigurator. Eine Angabe, eine Quelle. */
      /* Die Höhen stehen seit 2026-10-05 in den Maßen (für die Liste und die
         Maßtabelle unten), im Kopf aber nicht: Vier Angaben brechen dort
         schon um. */
      const kopfMasse = root.querySelector('[data-p3d-headspecs]');
      if (kopfMasse && zeilen.length) {
        kopfMasse.innerHTML = zeilen
          .filter(([k]) => !k.startsWith('Höhe'))
          .map(([k, v]) => `<span class="fmnv-p3d__spec">${k} ${v}</span>`).join('');
      }

      const kopf = root.querySelector('[data-p3d-current-config]');
      if (kopf) kopf.textContent = konfig.name + seiteZusatz(konfig) + (konfig.schlaf ? ' · ' + FUNKTION : '');
      renderTabs();
    }

    // Bewusst Funktionsdeklarationen: preisAnzeigen läuft schon beim ersten
    // Zeichnen, und const-Pfeilfunktionen wären zu dem Zeitpunkt noch nicht
    // initialisiert.
    function geld(cent) {
      return (cent / 100).toLocaleString('de-DE', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 2,
      });
    }

    /* Aufpreis eines Stoffs — ausgerechnet, nicht gepflegt.

       Die Aufpreise stecken bereits in den Verkaufspreisen der Varianten: Die
       günstigste Preisgruppe dieser Ausführung ist der Grundpreis, alles
       darüber ist der Aufpreis dieses Stoffs. Es gibt deshalb bewusst kein
       Feld „Aufpreis in Euro" — eine zweite Zahl könnte vom Preis abweichen,
       und der Preis gewinnt immer. Dieselbe Rechnung wie beim „+ 200 €" der
       Schlaffunktion. */
    function aufpreisCent(f) {
      if (!konfig) return 0;
      const v = konfig.preise.find((p) => p.gruppe === (f.gruppe || ''));
      const guenstigste = guenstigsteVariante();
      if (!v || !guenstigste) return 0;
      return Math.max(0, v.cent - guenstigste.cent);
    }

    /* Auf der Stoffkachel, über der Stoffprobe: Der Aufpreis gehört an die
       Stelle, an der man die Stoffe vergleicht — nicht erst hinter die
       Entscheidung. */
    function aufpreisHinweis(f) {
      const mehr = aufpreisCent(f);
      if (!mehr) return '';
      return `<span class="fmnv-p3d__fabric-extra">+ ${geld(mehr)}</span>`;
    }

    /* Derselbe Aufpreis noch einmal im Farbschritt, neben dem Stoffnamen.
       Auf der Stoffkachel steht er zwar schon, aber wer dort weitergeklickt
       hat, vergleicht hier nur noch Farben — und sähe den Aufschlag sonst
       erst wieder im Preis. Andere Stelle, andere Form: Die Kachelfassung
       liegt absolut über der Stoffprobe und taugt in einer Zeile nicht. */
    function aufpreisAbzeichen(f) {
      const mehr = aufpreisCent(f);
      if (!mehr) return '';
      return `<span class="fmnv-p3d__groupextra">+ ${geld(mehr)}</span>`;
    }

    /* Der höchste Aufpreis unter den gewählten Stoffen. Solange die Farbe
       nicht feststeht, steht nicht fest, welcher Stoff es wird — der Preis
       beginnt deshalb beim günstigsten und wird als „ab" ausgewiesen. */
    function preisAnzeigen() {
      const el = root.querySelector('[data-p3d-price]');
      const labelEl = root.querySelector('[data-p3d-price-label]');
      if (!el) return;

      const v = aktuelleVariante();
      const guenstigste = guenstigsteVariante();
      // Vor der Farbwahl steht der Einstiegspreis, danach der Preis der
      // Variante, die tatsächlich in den Warenkorb geht.
      const zeigen = farbeBestaetigt && v ? v : guenstigste;
      if (zeigen) el.textContent = geld(zeigen.cent);
      // Streichpreis nur, wenn die Variante einen höheren Vergleichspreis trägt.
      const streich = zeigen && zeigen.streich > zeigen.cent ? zeigen.streich : 0;
      const oldEl = root.querySelector('[data-p3d-price-old]');
      if (oldEl) {
        oldEl.hidden = !streich;
        if (streich) oldEl.textContent = geld(streich);
      }
      // Nach der Farbwahl steht der Preis für sich — ein Etikett davor
      // („Gesamtpreis") sagte nichts, was die Zahl nicht selbst sagt.
      if (labelEl) {
        labelEl.textContent = farbeBestaetigt && v ? '' : 'Preis ab';
        labelEl.hidden = !!(farbeBestaetigt && v);
      }
      /* Die Ratenzahlung rechnet mit demselben Betrag, der gerade als Preis
         steht. Das PayPal-SDK beobachtet das Attribut und rendert neu. */
      const paypalEl = root.querySelector('[data-p3d-paypal]');
      if (paypalEl && zeigen) paypalEl.setAttribute('data-pp-amount', (zeigen.cent / 100).toFixed(2));

      /* Auf dem Telefon steht der Preis im Knopf statt darüber — eine
         eigene Zeile dafür kostete dort ein Sechstel der Bildhöhe. Am
         Schreibtisch blendet das Stylesheet ihn wieder aus. */
      if (zeigen) {
        root.querySelectorAll('[data-p3d-atc-preis], [data-p3d-atc-inline-preis]')
          .forEach((p) => {
            p.innerHTML = ' · ' + (streich ? `<s class="fmnv-p3d__atc-preis-alt">${geld(streich)}</s> ` : '')
              + geld(zeigen.cent);
          });
      }

      // Die Varianten-ID des Formulars muss immer die gezeigte sein.
      if (v) {
        root.querySelectorAll('[data-p3d-variant-id]').forEach((i) => { i.value = v.vid; });
      }
    }

    /* Pfeile an wischbaren Reihen.

       Die Ausblendung am Rand allein reicht nicht: Sie sagt, dass etwas
       abgeschnitten ist, aber nicht, dass man wischen kann — und mit der Maus
       geht Wischen ohnehin nicht. Die Pfeile erscheinen nur, solange es in
       ihre Richtung weitergeht. */
    function ruesteWischreihe(reihe) {
      if (!reihe || reihe._wischPfeile) return;
      reihe._wischPfeile = true;
      const huelle = document.createElement('div');
      huelle.className = 'fmnv-p3d__wisch';
      reihe.parentNode.insertBefore(huelle, reihe);
      huelle.appendChild(reihe);

      const mach = (richtung) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__wischpfeil fmnv-p3d__wischpfeil--' + richtung;
        b.setAttribute('aria-label', richtung === 'links' ? 'Zurück' : 'Weiter');
        b.innerHTML = `<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="${
          richtung === 'links' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'
        }" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        b.addEventListener('click', () => {
          reihe.scrollBy({ left: (richtung === 'links' ? -1 : 1) * reihe.clientWidth * 0.8,
                           behavior: 'smooth' });
        });
        huelle.appendChild(b);
        return b;
      };
      const links = mach('links'), rechts = mach('rechts');

      const pruefe = () => {
        const mehr = reihe.scrollWidth - reihe.clientWidth;
        links.hidden = reihe.scrollLeft <= 4;
        rechts.hidden = !(mehr > 4 && reihe.scrollLeft < mehr - 4);
      };
      reihe.addEventListener('scroll', pruefe, { passive: true });
      new ResizeObserver(pruefe).observe(reihe);
      pruefe();
      requestAnimationFrame(pruefe);
    }

    /* Zeigt an, dass eine Reihe weitergeht.

       Ohne Hinweis wirkt eine gefüllte Reihe abgeschlossen — man kommt nicht
       auf die Idee zu wischen. Die Klassen steuern eine Ausblendung an den
       Rändern; zusätzlich fängt ein Mausrad-Zuhörer das senkrechte Rollen ab
       und macht daraus waagerechtes, weil es am Schreibtisch keine
       Wischgeste gibt. */
    function markiereWischbar() {
      const reihen = [...root.querySelectorAll('.fmnv-p3d__colorset')];
      if (!reihen.length) reihen.push(colEl);
      reihen.forEach((r) => {
        const pruefe = () => {
          const mehr = r.scrollWidth - r.clientWidth;
          r.classList.toggle('kann-links', r.scrollLeft > 4);
          r.classList.toggle('kann-rechts', mehr > 4 && r.scrollLeft < mehr - 4);
        };
        if (!r._wischHorcht) {
          r._wischHorcht = true;
          r.addEventListener('scroll', pruefe, { passive: true });
          // Beim ersten Zeichnen steht die Breite noch nicht fest; ohne diese
          // Nachmessung fehlte der Hinweis ausgerechnet beim Ankommen.
          new ResizeObserver(pruefe).observe(r);
          r.addEventListener('wheel', (e) => {
            if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
            const mehr = r.scrollWidth - r.clientWidth;
            if (mehr <= 0) return;
            e.preventDefault();
            r.scrollLeft += e.deltaY;
          }, { passive: false });
        }
        pruefe();
        requestAnimationFrame(pruefe);
        ruesteWischreihe(r);
      });
    }

    /* ------------------------- Merkliste -------------------------
       Gemerkt wird die Kombination, nicht das Produkt: Dasselbe Sofa in Cord
       Glacier und in Velvet Mustard sind zwei Einträge. Die Kennung baut auf
       Stoff und Farbcode auf, damit ein Eintrag nach einem Neuladen wieder
       derselbe ist. */
    const favIdVon = (fam, col) =>
      `${PRODUKT_HANDLE}:${fam.name}:${col.code}`.toLowerCase();
    const favId = () => favIdVon(family, color);

    function favEintragVon(fam, col) {
      const url = new URL(location.href);
      url.search = '';
      url.searchParams.set('stoff', String(col.code || '').toLowerCase());
      return {
        id: favIdVon(fam, col),
        titel: `${PRODUKT_TITEL} in ${fam.name} ${col.label}`,
        code: col.code,
        stoff: fam.name,
        farbe: col.label,
        bild: col.swatch,
        // Variante des Stoffmuster-Produkts: Ohne sie ließe sich aus der
        // Merkliste heraus kein Muster bestellen.
        vid: col.vid,
        /* Und die Variante der Ausführung, damit sich das Sofa selbst aus der
           Merkliste in den Warenkorb legen lässt. Preisgruppe und damit
           Variante hängen am Stoff — deshalb wird sie hier festgehalten und
           nicht später aus dem Namen abgeleitet. */
        sofaVid: (function () {
          const gruppe = fam.gruppe;
          const v = konfig && gruppe && konfig.preise.find((x) => x.gruppe === gruppe);
          return v ? v.vid : null;
        })(),
        // Genau die Werte, die auch das Formular schreibt.
        propStoff: fam.name + (fam.type && fam.type.toLowerCase() !== fam.name.toLowerCase() ? ' ' + fam.type : ''),
        propFarbe: `${col.label} (${col.code})`,
        url: url.pathname + url.search,
      };
    }
    const favEintrag = () => favEintragVon(family, color);

    /* Beim Merken das Sofa in dieser Farbe abbilden statt nur den Stoff.
       Das geht nur für die Kombination, die der Viewer gerade zeigt; ein
       Herz an einer anderen Farbe behält das Stoffbild. */
    async function favUmschalten(fam, col) {
      const e = favEintragVon(fam, col);
      if (!window.FmnvFavoriten.enthaelt(e.id) && e.id === favId()) {
        e.bild = (await sofaVorschau()) || e.bild;
      }
      window.FmnvFavoriten.umschalten(e);
    }

    function syncFav() {
      const b = root.querySelector('[data-p3d-fav]');
      if (!b || !window.FmnvFavoriten) return;
      const an = window.FmnvFavoriten.enthaelt(favId());
      b.setAttribute('aria-pressed', String(an));
      b.setAttribute('aria-label', an ? 'Aus Favoriten entfernen' : 'Favorisieren');
      const t = b.querySelector('[data-p3d-fav-text]');
      if (t) t.textContent = an ? 'Favorisiert' : 'Favorisieren';
    }

    root.querySelector('[data-p3d-fav]')?.addEventListener('click', () => {
      if (!window.FmnvFavoriten) return;
      favUmschalten(family, color).then(() => {
        syncFav();
        preisAnzeigen();
      });
    });
    // Auch auf Änderungen aus der Kopfzeile hören — dort lässt sich ein
    // Eintrag entfernen, während dieselbe Kombination gerade angezeigt wird.
    window.FmnvFavoriten?.beiAenderung(() => { syncFav(); markiereFavoriten(); });

    function toggleFamily(f) {
      if (chosen.has(f)) {
        chosen.delete(f);
        // Hing die dargestellte Farbe an diesem Stoff, auf einen anderen
        // gewählten Stoff ausweichen. Ist keiner mehr übrig, bleibt sie
        // stehen — sonst wüsste niemand mehr, was das Modell gerade trägt.
        if (color.fam === f) {
          const next = bestellbareFamilien().find((x) => chosen.has(x));
          if (next) { family = next; color = next.colors[0]; }
        }
      } else {
        chosen.add(f);
        // Neu dazugewählter Stoff wird gleich im Modell gezeigt — sonst ist
        // nicht erkennbar, was der Klick bewirkt hat.
        const same = f.colors.find((c) => c.label.toLowerCase() === color.label.toLowerCase());
        color = same || zeigefarbe(f);
        family = f;
      }
      // Beide Aufrufer (Kästchen, „aus der Auswahl nehmen") sind Klicks.
      melde('konfigurator', 'stoff_gewaehlt', f.name);
      renderFamilies(); renderTones(); renderColors(); syncLabels(); paint(); setzeFotos();
    }

    function selectColor(c) {
      rotationStopp(false);
      color = c;
      family = c.fam;
      // Erst ein bewusster Klick auf eine Farbe gibt den Warenkorb frei. Die
      // Vorbelegung beim Laden zählt nicht — sie hat der Kunde nie gewählt.
      farbeBestaetigt = true;
      selbstGewaehlt = true;
      melde('konfigurator', 'farbe', c.label);
      // Test: Gewählt ist genau der Stoff dieser Farbe — keine Vorauswahl mehr.
      chosen.clear();
      chosen.add(c.fam);
      /* Kein Neuaufbau: Nur die Markierung wechselt — sonst verschöbe sich
         die Liste unter dem Finger. */
      markiereStoffFarben();
      markiereAktiveFarbe();
      syncLabels(); paint(); syncKauf(); setzeFotos();
    }

    /* ------------------------- Musterleiste -------------------------
       Gesammelte Gratismuster. Der Shop deckelt sie bei fünf Stück; das
       spiegelt die Leiste, statt den Kunden erst im Warenkorb auflaufen
       zu lassen.
    ---------------------------------------------------------------- */
    const MAX_SAMPLES = D.maxSamples;
    let samples = [];
    /* Ein Riegel für alle Warenkorb-Schreibzugriffe: Zwei schnelle Klicks
       hätten sonst beide gegen denselben alten Stand geprüft und wären zu
       zweit am Deckel vorbeigekommen. */
    let musterBusy = false;
    const barEl = root.querySelector('[data-p3d-samplebar]');
    const barSwatchesEl = root.querySelector('[data-p3d-samplebar-swatches]');
    const barLabelEl = root.querySelector('[data-p3d-samplebar-label]');
    const addSampleEl = root.querySelector('[data-p3d-add-sample]');
    const addSampleTextEl = root.querySelector('[data-p3d-add-sample-text]');
    const orderEl = root.querySelector('[data-p3d-order-samples]');

    const sampleKey = (fam, col) => `${fam.name}|${col.code}`;
    const hasSample = (fam, col) => samples.some((s) => s.key === sampleKey(fam, col));

    /* Der Warenkorb ist die einzige Stelle, die den Musterstand über Seiten,
       Reiter und Sitzungen hinweg kennt. Solange die Leiste ihre eigene Liste
       führte, begann der Deckel bei jedem neuen Durchlauf wieder bei null:
       fünf Muster bestellen, Seite neu aufrufen, nochmal fünf. Deshalb hält
       sie nichts mehr selbst — sie spiegelt /cart.js, und jeder Klick geht
       sofort dorthin. Damit zeigt die Leiste auch die Muster, die anderswo im
       Shop dazugekommen sind. */
    const vidIndex = new Map();
    FAMILIES.forEach((f) => f.colors.forEach((c) => { if (c.vid) vidIndex.set(Number(c.vid), c); }));

    const istMuster = (it) => it && it.properties && it.properties._sample === '1';
    const musterAnzahl = () => samples.reduce((n, s) => n + s.menge, 0);

    async function ladeMuster() {
      let korb;
      try {
        const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        korb = await r.json();
      } catch (e) {
        console.warn('[fmnv-p3d] Warenkorb nicht lesbar', e);
        return samples;
      }
      samples = (korb.items || []).filter(istMuster).map((it) => {
        /* Muster aus diesem Konfigurator lassen sich auf Stoff und Farbe
           zurückführen und markieren dort den Farbkreis. Die aus anderen
           Seiten kennen wir nicht — die stehen mit ihrem Warenkorbnamen in
           der Leiste und zählen genauso gegen den Deckel. */
        const c = vidIndex.get(Number(it.variant_id));
        return {
          key: c ? sampleKey(c.fam, c) : 'korb|' + it.key,
          korbKey: it.key,
          menge: it.quantity || 1,
          swatch: c ? c.swatch : (it.image || ''),
          label: c
            ? `${c.fam.name} ${c.label}`
            : String(it.variant_title || it.product_title || 'Muster').replace(/_/g, ' '),
        };
      });
      return samples;
    }

    /* Der Zähler am Warenkorbsymbol wird serverseitig gerendert; nach einem
       Klick hier wäre er sonst bis zum nächsten Seitenaufruf falsch. */
    function frischeWarenkorbIcon() {
      return fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          const el = document.getElementById('cart-icon-bubble');
          const html = data['cart-icon-bubble'];
          if (!el || !html) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          el.innerHTML = parsed ? parsed.innerHTML : html;
        })
        .catch(() => {});
    }

    async function zeichneMusterstand() {
      await ladeMuster();
      renderSampleBar();
      syncSampleButton();
      markSampled();
    }

    /* Auf dem Telefon wird die Musterleiste eine Zeile *innerhalb* der
       Kaufleiste, statt als zweite Leiste darüber zu schweben.

       Vorher hingen zwei fixierte Leisten über einen gemessenen Abstand
       aneinander (`--p3d-buy-h`). Jede Höhenänderung der Kaufleiste musste
       nachgemessen werden, und in iOS Safari passiert genau das ständig:
       Beim Ein- und Ausfahren der Toolbar ändert sich das Polster für den
       Home-Bereich, und fixierte Elemente werden erst am Ende der
       Scrollbewegung neu gesetzt. In dem Versatz klaffte die Lücke. Als eine
       gemeinsame Leiste gibt es keinen Abstand, der auseinanderlaufen kann.

       Am Schreibtisch bleibt sie, wo sie ist: Dort ist die Kaufleiste nicht
       fixiert, die Musterleiste steht allein am unteren Rand. */
    const leisteHeimat = barEl?.parentElement;
    function platziereMusterleiste() {
      if (!barEl) return;
      const kauf = root.querySelector('.fmnv-p3d__buy');
      const ziel = innerWidth <= 989 ? kauf : leisteHeimat;
      if (!ziel || barEl.parentElement === ziel) return;
      ziel === kauf ? ziel.prepend(barEl) : ziel.appendChild(barEl);
      messeKaufleiste();
    }

    /* Die Musterleiste legt sich über die Kaufleiste, statt sie zu ersetzen.
       Beide sind fixiert; ohne gemessene Höhe würde die eine die andere
       verdecken. Bisher wurde die Kaufleiste dafür ausgeblendet — damit war
       der Warenkorb weg, sobald man ein Muster gemerkt hatte. */
    function messeKaufleiste() {
      const kauf = root.querySelector('.fmnv-p3d__buy');
      const h = kauf && getComputedStyle(kauf).position === 'fixed'
        ? Math.round(kauf.getBoundingClientRect().height) : 0;
      root.style.setProperty('--p3d-buy-h', h + 'px');
    }
    addEventListener('resize', messeKaufleiste);
    /* Die Kaufleiste wechselt ihre Höhe im Betrieb: Der Weiter-Knopf ist
       einzeilig, der Warenkorb zweizeilig plus Pflichtangaben. Gemessen wurde
       bisher nur bei Ereignissen der Musterleiste — dazwischen stand die
       Musterleiste auf einem alten Wert und ließ eine Lücke zur Kaufleiste.
       Der Beobachter meldet jede Änderung, egal wer sie auslöst. */
    (() => {
      const kauf = root.querySelector('.fmnv-p3d__buy');
      if (kauf && window.ResizeObserver) new ResizeObserver(messeKaufleiste).observe(kauf);
    })();

    /* Höhe der angehefteten Modellspalte. Die Rasterstellung der Seite braucht
       sie als Abstand von oben, und 34vh minus Kartenrand lässt sich in CSS
       nicht ausdrücken. */
    (() => {
      const stage = root.querySelector('.fmnv-p3d__stage');
      if (!stage) return;
      const messe = () => {
        const angeheftet = getComputedStyle(stage).position === 'sticky';
        root.style.setProperty('--p3d-stage-h',
          angeheftet ? Math.round(stage.getBoundingClientRect().height) + 'px' : '0px');
      };
      if (window.ResizeObserver) new ResizeObserver(messe).observe(stage);
      addEventListener('resize', messe);
      messe();
    })();

    /* Auf dem Telefon nur der Zähler: Ausgeschrieben belegte die Beschriftung
       eine eigene Zeile, und die Leiste wuchs damit auf drei. Kurz gefasst
       teilt sie sich die Zeile mit den Proben. */
    function barLabelText() {
      const knapp = innerWidth <= 749;
      const n = musterAnzahl();
      const voll = n >= MAX_SAMPLES;
      if (knapp) return `${n}/${MAX_SAMPLES}${voll ? ' — voll' : ' Muster'}`;
      return `Deine Gratis-Muster (${n}/${MAX_SAMPLES}${voll ? ' — voll' : ''})`;
    }
    platziereMusterleiste();
    addEventListener('resize', () => {
      platziereMusterleiste();
      if (barLabelEl) barLabelEl.textContent = barLabelText();
      // Beim Verbreitern zurück in den offenen Zustand: Der Knopf zum
      // Aufklappen verschwindet dort, der Zustand wäre sonst nicht mehr
      // umkehrbar.
      if (innerWidth > 989 && barZu) { barZu = false; syncSampleBarZustand(); }
    });

    /* Zugeklappt hält die Leiste nur noch ihre Zeile. Der Zustand gilt für den
       Seitenaufruf: Wer sich ein weiteres Muster merkt, soll die Rückmeldung
       sehen — deshalb klappt sie dabei wieder auf. */
    let barZu = false;
    const barToggleEl = root.querySelector('[data-p3d-samplebar-toggle]');

    /* Offen räumt die Leiste ein Viertel des Bildschirms — nach der
       Rückmeldung „ist gemerkt" braucht sie den Platz nicht mehr. Sie klappt
       deshalb von selbst zu. Jede Berührung bricht das ab: Wer gerade eine
       Probe wieder entfernt oder auf „anfordern" zielt, soll den Knopf nicht
       unter dem Finger verlieren. */
    const AUTO_ZU_MS = 5000;
    let autoZuTimer = null;

    function stoppeAutoZu() {
      if (autoZuTimer) { clearTimeout(autoZuTimer); autoZuTimer = null; }
    }

    function planeAutoZu() {
      stoppeAutoZu();
      // Am Schreibtisch bleibt die Leiste offen: Sie steht dort in einer Zeile
      // und nimmt niemandem Platz weg.
      if (innerWidth > 989 || barZu || !samples.length) return;
      autoZuTimer = setTimeout(() => {
        autoZuTimer = null;
        barZu = true;
        syncSampleBarZustand();
      }, AUTO_ZU_MS);
    }

    // pointerdown statt click: Auch ein Wisch durch die Probenreihe zählt als
    // Benutzung, und der löst nie ein click aus.
    ['pointerdown', 'focusin'].forEach((ev) => barEl?.addEventListener(ev, stoppeAutoZu));

    function syncSampleBarZustand() {
      if (!barEl) return;
      barEl.classList.toggle('ist-zu', barZu);
      if (barToggleEl) {
        barToggleEl.setAttribute('aria-expanded', String(!barZu));
        barToggleEl.setAttribute('aria-label', barZu ? 'Musterleiste aufklappen' : 'Musterleiste zuklappen');
      }
      messeKaufleiste();
    }

    barToggleEl?.addEventListener('click', () => {
      barZu = !barZu;
      // Nur melden, wenn der Klick die Leiste öffnet (barZu jetzt false).
      if (!barZu) melde('musterleiste', 'geoeffnet');
      stoppeAutoZu();
      syncSampleBarZustand();
    });

    /* Zugeklappt ist die ganze Leiste der Weg zurück: Sie ist dann eine
       coralfarbene Zeile und liest sich als Knopf, nicht als Beschriftung. */
    barEl?.addEventListener('click', (e) => {
      if (!barZu || e.target.closest('[data-p3d-samplebar-toggle]')) return;
      barZu = false;
      stoppeAutoZu();
      syncSampleBarZustand();
    });

    /* Stand für die Blöcke unter dem Konfigurator (Marc, 2026-10-20): gewählter Stoff fürs
       Muster, Raumbilder dieser Ausführung in anderen Farben (Bestseller zuerst) und das
       Maßblatt. Gemeldet wie fmnv:konfiguration; der Musterknopf dort nutzt denselben Pfad
       wie „Muster merken“ hier, damit Fünfer-Deckel und Warenkorb-Spiegel gelten. */
    function meldeAuswahl() {
      if (!color || !family) return;
      const nr = konfigNummer(konfig);
      const farben = [...new Set(bestsellerFarben().concat(bestellbareFamilien().flatMap((f) => f.colors)))]
        .filter((c) => c.available !== false).slice(0, 16)
        .map((c) => ({ code: c.code, name: `${c.fam.name} ${c.label}`,
                       u: nr ? `${DATEIEN}F-${nr}_${c.code}_raum_01.jpg?width=700` : '' }));
      document.fmnvAuswahl = { stoff: `${family.name} ${color.label}`, swatch: color.swatch || '',
        imKorb: hasSample(family, color), voll: musterAnzahl() >= MAX_SAMPLES,
        massblatt: (konfig && konfig.massblatt) || '', farben };
      document.dispatchEvent(new CustomEvent('fmnv:auswahl', { detail: document.fmnvAuswahl }));
    }
    document.fmnvMusterMerken = () => {
      // Wer das Muster der gezeigten Farbe will, hat sie gewählt: Rotation anhalten wie bei einem Klick ins Bild.
      rotationStopp();
      if (hasSample(family, color)) { (window.fmnvMusterZurKasse || (() => { location.href = '/cart'; }))(); return; }
      addSampleEl?.click();
    };

    function renderSampleBar() {
      messeKaufleiste();
      if (!barEl) return;
      barEl.hidden = samples.length === 0;
      document.body.classList.toggle('fmnv-p3d-has-samplebar', samples.length > 0);
      if (orderEl) orderEl.disabled = samples.length === 0;
      syncSampleBarZustand();
      planeAutoZu();
      meldeAuswahl();

      if (barLabelEl) barLabelEl.textContent = barLabelText();
      if (barSwatchesEl) {
        barSwatchesEl.innerHTML = '';
        samples.forEach((s) => {
          /* Farbpunkt allein sagt nicht, welcher Stoff gemeint ist — bei
             181 Farben über 17 Stoffe sehen sich viele zum Verwechseln
             ähnlich. Name dazu, sonst ist die Liste nicht nachvollziehbar. */
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'fmnv-p3d__samplebar-eintrag';
          b.title = `${s.label} entfernen`;
          b.setAttribute('aria-label', `${s.label} aus den Mustern entfernen`);
          b.innerHTML =
            `<span class="fmnv-p3d__samplebar-swatch" style="background-image:url('${s.swatch}')"></span>` +
            `<span class="fmnv-p3d__samplebar-name">${s.label}</span>` +
            `<span class="fmnv-p3d__samplebar-weg" aria-hidden="true">&times;</span>`;
          b.addEventListener('click', () => entferneMuster(s.korbKey, b));
          barSwatchesEl.appendChild(b);
        });
      }
    }

    let musterFehlerBis = 0;
    function syncSampleButton() {
      if (!addSampleTextEl) return;
      if (!musterBusy && musterFehlerBis > Date.now()) {
        addSampleEl.disabled = true;
        addSampleEl.classList.remove('is-frage');
        addSampleTextEl.textContent = 'Muster gerade nicht bestellbar';
        return;
      }
      const picked = hasSample(family, color);
      const full = musterAnzahl() >= MAX_SAMPLES;
      // Vergriffene Probe gar nicht erst aufnehmen — Shopify weist den Aufruf
      // sonst zurück, und der Kunde steht vor einer Fehlermeldung, die er
      // nicht auflösen kann.
      const leer = !picked && color && color.available === false;
      addSampleEl.classList.toggle('is-picked', picked);
      /* Voll (fünf Muster im Korb, diese Farbe nicht dabei): Der Knopf bleibt
         anklickbar und führt in den Warenkorb (Marc, 2026-10-06) — gesperrt sah er
         nur kaputt aus, dabei ist der nächste Schritt klar. */
      const voll = !picked && full && !leer;
      addSampleEl.classList.toggle('is-voll', voll);
      addSampleEl.disabled = musterBusy || leer;
      /* Mobil steht der Knopf neben „In den Warenkorb“ (Kaufleiste) und nennt
         den Stoff, den er meint: Farbprobe, „Gratis Muster von“, Stoff · Farbe.
         Ist das Muster schon im Warenkorb, steht das grün darauf. */
      if (root.classList.contains('is-mobile-workspace') && color) {
        const name = `${family.name} · ${color.label}`;
        const [z1, z2] = picked ? ['✓ Im Warenkorb', name]
          : leer ? ['Vergriffen', name]
          : full ? [`Alle ${MAX_SAMPLES} Muster gewählt`, 'Zum Warenkorb →']
          : ['Gratis Muster von', name];
        const punkt = document.createElement('span');
        punkt.className = 'fmnv-p3d__sample-dot';
        if (color.swatch) punkt.style.backgroundImage = `url("${color.swatch}")`;
        /* Grundzustand (Marc, 2026-10-14): Farbprobe + „Gratis Muster +“ auf heller
           Koralle; die Frage „Stoff erst fühlen?“ darüber setzt fmnv-p3d-layouts.css. */
        const frage = !picked && !leer && !full;
        addSampleEl.classList.toggle('is-frage', frage);
        if (frage) {
          const label = document.createElement('strong');
          label.className = 'fmnv-p3d__sample-label';
          label.textContent = 'Gratis Muster';
          const plus = document.createElement('span');
          plus.className = 'fmnv-p3d__sample-plus';
          plus.setAttribute('aria-hidden', 'true');
          plus.textContent = '+';
          addSampleEl.setAttribute('aria-label', `Gratis Muster ${name} in den Warenkorb`);
          addSampleTextEl.replaceChildren(punkt, label, plus);
          return;
        }
        addSampleEl.removeAttribute('aria-label');
        const text = document.createElement('span');
        text.className = 'fmnv-p3d__sample-text';
        const k = document.createElement('span'); k.textContent = z1;
        const n = document.createElement('strong'); n.textContent = z2;
        text.append(k, n);
        addSampleTextEl.replaceChildren(punkt, text);
        return;
      }
      addSampleEl.classList.remove('is-frage');
      addSampleTextEl.textContent = picked
        ? 'Muster gemerkt — entfernen'
        : leer
          ? 'Alle Muster derzeit vergriffen'
          : full
            ? `Alle ${MAX_SAMPLES} Muster gewählt — zum Warenkorb`
            : 'Gratis Stoffmuster bestellen';
    }

    /* Anstellen statt verwerfen.

       Vorher stand hier `if (musterBusy) return;` — ein Klick, der während
       eines laufenden Warenkorb-Aufrufs kam, fiel lautlos unter den Tisch.
       Seit die Leiste den Warenkorb spiegelt, dauert jede Änderung einen
       Netzwerk-Umlauf (`/cart/change.js`, dann `/cart.js`, dann das
       Warenkorb-Symbol). Wer zwei Muster hintereinander wegtippte, verlor den
       zweiten Tipp — die Leiste liess sich nicht leeren. `entferneMuster`
       blendete den Eintrag ausserdem schon vor der Prüfung ab, es sah also
       aus, als passiere etwas.

       Die Kette hält die Aufrufe auseinander und behält damit auch den Grund
       für den alten Riegel: Es läuft weiter nur einer zur Zeit, und jeder
       sieht dank `zeichneMusterstand()` den frischen Stand seines Vorgängers.
       Deshalb wird `anfrage()` erst beim Ausführen aufgerufen — sie darf
       `null` liefern, wenn die Änderung sich inzwischen erübrigt hat. */
    let musterKette = Promise.resolve();

    function schreibeMuster(anfrage) {
      musterKette = musterKette.then(async () => {
        musterBusy = true;
        syncSampleButton();
        // Ergebnis für den Aufrufer: true = geändert, false = Fehler,
        // null = nichts zu tun. Mobil hängt der Hinweis von oben daran.
        let erfolg = false;
        try {
          const req = anfrage();
          // Nichts mehr zu tun: Der Vorgänger hat den Fall schon erledigt.
          if (!req) return null;
          const res = await req;
          if (!res.ok) throw new Error(await res.text());
          erfolg = true;
        } catch (err) {
          /* Bisher nur in der Konsole: Der Knopf sprang stumm zurück, als
             wäre nichts gewesen — etwa wenn die Farbe seit dem Seitenaufruf
             vergriffen ist (Shopify antwortet 422). Vier Sekunden sagen, was
             los ist, dann den normalen Stand zeigen. */
          console.error('[fmnv-p3d] Warenkorb nicht geändert', err);
          musterFehlerBis = Date.now() + 4000;
          setTimeout(syncSampleButton, 4100);
        } finally {
          musterBusy = false;
        }
        await zeichneMusterstand();
        frischeWarenkorbIcon();
        return erfolg;
      });
      return musterKette;
    }

    function entferneMuster(korbKey, knopf) {
      // Beide Aufrufer (Leisten-Kreuz, „Muster gemerkt — entfernen") sind
      // Klicks; vorher lesen, weil `samples` erst nach dem Umlauf aktualisiert.
      const s = samples.find((x) => x.korbKey === korbKey);
      melde('musterleiste', 'muster_entfernt', s ? s.label : '');
      if (knopf) knopf.style.opacity = '.4';
      return schreibeMuster(() => {
        // Zwischenzeitlich schon weg (Doppeltipp, anderer Reiter)? Dann nicht
        // erneut löschen — sonst träfe der Aufruf eine fremde Zeile.
        if (!samples.some((s) => s.korbKey === korbKey)) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: korbKey, quantity: 0 }),
        });
      }).then((ok) => {
        if (ok && s) zeigeMusterHinweis(s.label, s.swatch, 'weg');
        return ok;
      });
    }

    addSampleEl?.addEventListener('click', () => {
      const vorhanden = samples.find((x) => x.key === sampleKey(family, color));
      if (vorhanden) { entferneMuster(vorhanden.korbKey); return; }

      // Voll: Der Knopf führt in den Warenkorb statt ein sechstes Muster zu versuchen.
      if (musterAnzahl() >= MAX_SAMPLES) {
        melde('musterleiste', 'voll_zum_warenkorb', MAX_SAMPLES);
        location.href = '/cart';
        return;
      }
      if (color.available === false) return;
      if (!color.vid) {
        console.warn('[fmnv-p3d] Keine Varianten-ID für', sampleKey(family, color));
        return;
      }
      // Ein neues Muster ist die Rückmeldung wert, auf die die Leiste
      // zugeklappt gerade verzichtet.
      barZu = false;
      // Nur der echte Hinzufügen-Pfad — der Entfernen-Pfad oben meldet sich
      // schon über entferneMuster().
      melde('musterleiste', 'muster_hinzugefuegt', musterAnzahl() + 1);
      // Farbe festhalten: Bis die Kette hier ankommt, kann der Kunde längst
      // eine andere gewählt haben — sonst landete die falsche im Warenkorb.
      const vid = Number(color.vid);
      const schluessel = sampleKey(family, color);
      const hinweisTitel = `${family.name} ${color.label}`;
      const hinweisBild = color.swatch;
      schreibeMuster(() => {
        /* Der Deckel wird hier ein zweites Mal geprüft, nicht nur beim Klick:
           Angestellte Aufrufe haben beim Klicken alle denselben alten Stand
           gesehen und kämen sonst zu zweit am Fünfer-Limit vorbei. Genau davor
           schützte früher der Riegel, der die Klicks verwarf. */
        if (musterAnzahl() >= MAX_SAMPLES) return null;
        if (samples.some((s) => s.key === schluessel)) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // Der Shop erkennt Muster am Line-Item-Marker _sample.
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _sample: '1', _quelle: 'konfigurator', ...musterSofa() } }] }),
        });
      }).then((ok) => { if (ok) zeigeMusterHinweis(hinweisTitel, hinweisBild, 'dazu'); });
    });

    /* Die Muster liegen bereits im Warenkorb — hier geht es nur noch an die
       Kasse. fmnvMusterZurKasse merkt vorher das konfigurierte Sofa und nimmt
       es heraus; ohne das nähme die Kasse den ganzen Warenkorb mit. */
    orderEl?.addEventListener('click', () => {
      if (!samples.length || !window.fmnvMusterZurKasse) return;
      melde('musterleiste', 'bestellen', musterAnzahl());
      const orderTextEl = orderEl.querySelector('span');
      const orderText = orderTextEl.textContent;
      orderEl.disabled = true;
      window.fmnvMusterZurKasse().catch((err) => {
        /* Wie beim Merken-Knopf: Der Fehler steht vier Sekunden im Knopf
           selbst. Der Hinweis von oben ist mobil, die Leiste steht aber nur
           am Schreibtisch — dort käme die Meldung nie an. */
        console.error('[fmnv-p3d] Muster nicht zur Kasse', err);
        orderTextEl.textContent = err.message;
        zeichneMusterstand();
        setTimeout(() => {
          orderTextEl.textContent = orderText;
          orderEl.disabled = !samples.length;
        }, 4000);
      });
    });

    /* Hinweis von oben statt Musterleiste (mobil, Test 2026-09-15).

       Das Muster liegt ab dem Tipp im Warenkorb; der Hinweis bestätigt das
       und nennt den Stand am Fünfer-Deckel. Er geht nach vier Sekunden von
       selbst. Solange der Finger darauf liegt, bleibt er — wer gerade auf
       „Zum Warenkorb" zielt, soll ihn nicht unter dem Finger verlieren.
       Nach oben wischen oder das Kreuz schließt ihn sofort. Am Schreibtisch
       bleibt es bei der Leiste, sie steht dort in einer Zeile. */
    const hinweisEl = root.querySelector('[data-p3d-musterinfo]');
    const HINWEIS_MS = 4000;
    let hinweisTimer = null;
    let hinweisStartY = null;

    function schliesseMusterHinweis() {
      clearTimeout(hinweisTimer);
      hinweisTimer = null;
      hinweisEl?.classList.remove('ist-offen');
      hinweisEl?.setAttribute('aria-hidden', 'true');
    }

    function planeHinweisZu(ms) {
      clearTimeout(hinweisTimer);
      hinweisTimer = setTimeout(schliesseMusterHinweis, ms);
    }

    function zeigeMusterHinweis(label, swatch, art) {
      if (!hinweisEl || innerWidth > 989) return;
      const n = musterAnzahl();
      // Kurz halten: Neben Knopf und Kreuz bleiben auf 390 px rund 150 px
      // Text — der ganze Satz brach um und schnitt den Stoffnamen ab.
      hinweisEl.querySelector('[data-p3d-musterinfo-titel]').textContent = label;
      hinweisEl.querySelector('[data-p3d-musterinfo-zahl]').textContent =
        `${art === 'weg' ? 'entfernt' : 'im Warenkorb'} · ${n} von ${MAX_SAMPLES}`;
      hinweisEl.querySelector('[data-p3d-musterinfo-swatch]').style.backgroundImage =
        swatch ? `url(${JSON.stringify(swatch)})` : '';
      // Ohne Muster im Korb führt der Knopf ins Leere.
      hinweisEl.querySelector('[data-p3d-musterinfo-korb]').hidden = n === 0;
      hinweisEl.setAttribute('aria-hidden', 'false');
      hinweisEl.classList.add('ist-offen');
      planeHinweisZu(HINWEIS_MS);
    }

    hinweisEl?.addEventListener('pointerdown', (e) => {
      clearTimeout(hinweisTimer);
      hinweisStartY = e.clientY;
    });
    ['pointerup', 'pointercancel'].forEach((ev) => hinweisEl?.addEventListener(ev, (e) => {
      const hoch = hinweisStartY !== null && e.clientY - hinweisStartY < -25;
      hinweisStartY = null;
      if (hoch) schliesseMusterHinweis();
      else if (hinweisEl.classList.contains('ist-offen')) planeHinweisZu(2000);
    }));
    hinweisEl?.querySelector('[data-p3d-musterinfo-zu]')?.addEventListener('click', schliesseMusterHinweis);
    hinweisEl?.querySelector('[data-p3d-musterinfo-korb]')?.addEventListener('click', () => {
      melde('musterleiste', 'bestellen', musterAnzahl());
    });

    /* Beim Aufruf der Seite den Stand aus dem Warenkorb übernehmen: Wer im
       vorigen Durchlauf schon vier Muster gewählt hat, sieht sie hier wieder
       und bekommt nur noch eines dazu. */
    zeichneMusterstand();
    // Der Warenkorb kann sich in einem anderen Reiter geändert haben.
    addEventListener('pageshow', (e) => { if (e.persisted) zeichneMusterstand(); });


    /* -------------------- Vorschaubild für den Warenkorb --------------------
       Das Rohbild des Viewers ist gut ein halbes Megabyte. Auf 900 px und
       JPEG heruntergerechnet bleiben rund 40 KB — genug für Warenkorb,
       Bestätigungsmail und Fertigung, ohne den Kauf aufzuhalten. Der
       Alphakanal wird gegen den Bühnenhintergrund gelegt, sonst füllt JPEG
       die transparenten Flächen schwarz.
    ---------------------------------------------------------------------- */
    const SHOT_WIDTH = 900;
    const shotInput = root.querySelector('[data-p3d-shot]');
    const shotForm = root.querySelector('.fmnv-p3d__form');
    let shotDone = false;

    async function buildShot() {
      const raw = await mv.toBlob({ idealAspect: true });
      const bmp = await createImageBitmap(raw);
      const w = Math.min(SHOT_WIDTH, bmp.width);
      const h = Math.round((bmp.height * w) / bmp.width);
      const cv = document.createElement('canvas');
      cv.width = w;
      cv.height = h;
      const cx = cv.getContext('2d');
      cx.fillStyle = '#f4f2ef';
      cx.fillRect(0, 0, w, h);
      cx.drawImage(bmp, 0, 0, w, h);
      bmp.close?.();
      const blob = await new Promise((res) => cv.toBlob(res, 'image/jpeg', 0.85));
      const name = `${family.name}-${color.code}`.toLowerCase().replace(/[^a-z0-9-]+/g, '-');
      const dt = new DataTransfer();
      dt.items.add(new File([blob], `cappa-${name}.jpg`, { type: 'image/jpeg' }));
      shotInput.files = dt.files;
    }

    /* Bild des Sofas in der gerade gezeigten Farbe, als data-URL für den
       localStorage. Favoriten: 240 px, rund 4 KB — sechzig passen weit in den
       Speicher. Gemerktes Sofa: Warenkorbgröße wie buildShot, weil es beim
       Zurücklegen als _konfig_bild mitgeht. Leer, wenn der Viewer nichts
       hergibt; dann bleibt das Stoffbild. */
    async function sofaVorschau(breite = 240) {
      try {
        if (!mv || !fabricMat) return '';
        const bmp = await createImageBitmap(await mv.toBlob({ idealAspect: true }));
        const w = Math.min(breite, bmp.width);
        const h = Math.round((bmp.height * w) / bmp.width);
        const cv = document.createElement('canvas');
        cv.width = w;
        cv.height = h;
        const cx = cv.getContext('2d');
        cx.fillStyle = '#f4f2ef';
        cx.fillRect(0, 0, w, h);
        cx.drawImage(bmp, 0, 0, w, h);
        bmp.close?.();
        return cv.toDataURL('image/jpeg', 0.8);
      } catch (err) {
        return '';
      }
    }

    /* ---------------- Muster-Hinweis vor dem Warenkorb ----------------
       Wer auf „In den Warenkorb“ tippt, bekommt höchstens einmal je Sitzung
       das Gratis-Muster der gewählten Farbe angeboten — bevor das Sofa im
       Warenkorb liegt. Muster aus einer gemischten Bestellung gehen erst mit
       dem Sofa raus; deshalb wird das Sofa bei „Muster zuerst“ nicht bestellt,
       sondern gemerkt. Dieselbe Merkliste wie die Karte auf der
       Warenkorbseite (snippets/fmnv_muster-vorschlag.liquid, localStorage
       fmnv_geparktes_sofa), dort liegt es mit einem Klick wieder im Korb.
       Muss VOR dem Vorschaubild-Handler stehen: Beide hören in der
       Capture-Phase auf das Formular, und der erste hält das Absenden an. */
    const kpEl = root.querySelector('[data-p3d-kp]');
    const KP_NEIN = 'fmnv_kaufpopup_nein';
    const KP_MERK = 'fmnv_geparktes_sofa';
    let kpNein = false;
    let kpSubmitter = null;
    try { kpNein = !!sessionStorage.getItem(KP_NEIN); } catch (e) {}

    function kpZeigen() {
      if (!kpEl || kpNein || !shotForm || typeof kpEl.showModal !== 'function') return false;
      if (!color || !color.vid || color.available === false) return false;
      if (hasSample(family, color) || musterAnzahl() >= MAX_SAMPLES) return false;
      return true;
    }

    function kpAbsenden() {
      if (shotForm.requestSubmit) shotForm.requestSubmit(kpSubmitter);
      else shotForm.submit();
    }

    function kpNeinSagen(kaufen) {
      kpNein = true;
      try { sessionStorage.setItem(KP_NEIN, '1'); } catch (e) {}
      if (kpEl.open) kpEl.close();
      if (kaufen) kpAbsenden();
    }

    function kpMusterZuerst(btn) {
      const ziel = btn.dataset.ziel || '/checkout';
      const fehlerEl = kpEl.querySelector('[data-p3d-kp-fehler]');
      const knoepfe = kpEl.querySelectorAll('button');
      knoepfe.forEach((b) => { b.disabled = true; });
      fehlerEl.hidden = true;
      // Stand von jetzt festhalten — die Kette läuft asynchron.
      const fam = family, col = color;
      const fd = new FormData(shotForm);
      const props = {};
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        // Das Vorschaubild (Datei) lässt sich nicht merken; der Rest schon.
        if (m && typeof v === 'string' && v !== '') props[m[1]] = v;
      }
      const sofa = {
        id: Number(fd.get('id')),
        quantity: Number(fd.get('quantity')) || 1,
        properties: props,
        titel: D.produktTitelRein,
        bild: col.swatch || '',
      };
      // Jetzt abgreifen, solange der Viewer noch genau diese Farbe zeigt.
      const bildVersprechen = sofaVorschau(SHOT_WIDTH);
      schreibeMuster(() => {
        if (hasSample(fam, col) || musterAnzahl() >= MAX_SAMPLES) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(col.vid), quantity: 1, properties: { _sample: '1', _quelle: 'kauf-popup', ...musterSofa() } }] }),
        });
      })
        .then(async () => {
          if (!hasSample(fam, col)) throw new Error('Das Muster ließ sich gerade nicht in den Warenkorb legen. Bitte versuch es gleich nochmal.');
          sofa.bild = (await bildVersprechen) || sofa.bild;
          let alt = null;
          try { alt = JSON.parse(localStorage.getItem(KP_MERK)); } catch (e) {}
          /* Je Produkt nur die zuletzt gewählte Konfiguration: Wer mehrere
             Farben durchprobiert und jedes Mal ein Muster bestellt, will
             nicht alle Sofas zurück in den Warenkorb bekommen. */
          const liste = (alt && Array.isArray(alt.items) ? alt.items : [])
            .filter((it) => it.titel !== sofa.titel);
          liste.push(sofa);
          try { localStorage.setItem(KP_MERK, JSON.stringify({ ts: Date.now(), items: liste })); } catch (e) {}
          /* Liegt außer Mustern noch etwas im Warenkorb (ein anderes Sofa),
             ginge das Muster wieder erst mit diesem raus. Dann entscheidet
             die Warenkorbseite, die genau dafür die Karte zeigt. */
          const korb = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const gemischt = (korb.items || []).some((it) => !istMuster(it));
          location.href = ziel === '/checkout' && gemischt ? '/cart' : ziel;
        })
        .catch((err) => {
          melde('popup', 'fehler', err && err.message);
          knoepfe.forEach((b) => { b.disabled = false; });
          fehlerEl.textContent = err.message;
          fehlerEl.hidden = false;
        });
    }

    // Katalog-Retargeting: Sofa mit genau dieser Farbe in den Warenkorb (Capture, läuft vor dem Popup).
    shotForm?.addEventListener('submit', () => katFeuer('AddToCart', katId()), true);

    shotForm?.addEventListener('submit', (e) => {
      if (!kpZeigen()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      kpSubmitter = e.submitter || null;
      kpEl.querySelector('[data-p3d-kp-swatch]').style.backgroundImage = color.swatch ? `url('${color.swatch}')` : '';
      kpEl.querySelector('[data-p3d-kp-name]').textContent = `${family.name} · ${color.label}`;
      // Derselbe Preis wie im Kaufbereich — das Skript hält ihn je Ausführung und Stoff aktuell.
      kpEl.querySelector('[data-p3d-kp-preis]').textContent = (root.querySelector('[data-p3d-price]')?.textContent || '').trim();
      kpEl.querySelector('[data-p3d-kp-fehler]').hidden = true;
      kpEl.querySelectorAll('button').forEach((b) => { b.disabled = false; });
      kpEl.showModal();
      melde('popup', 'angezeigt', `${family.name} · ${color.label}`);
    }, true);

    kpEl?.addEventListener('click', (e) => {
      const los = e.target.closest('[data-p3d-kp-los]');
      if (los) {
        melde('popup', los.dataset.ziel === '/checkout' ? 'muster_bestellen' : 'muster_aussuchen');
        kpMusterZuerst(los);
        return;
      }
      // Der Kaufknopf im Popup: Der Kunde bleibt bei seiner Entscheidung.
      if (e.target.closest('[data-p3d-kp-kaufen]')) { melde('popup', 'warenkorb'); kpNeinSagen(true); return; }
      // × oder Tipp neben das Fenster (der Dialog selbst hat kein Padding,
      // ein Treffer auf ihn ist also der abgedunkelte Hintergrund).
      if (e.target.closest('[data-p3d-kp-zu]') || e.target === kpEl) {
        melde('popup', 'geschlossen', e.target === kpEl ? 'hintergrund' : 'x');
        kpNeinSagen(false);
      }
    });
    kpEl?.addEventListener('cancel', (e) => { e.preventDefault(); melde('popup', 'geschlossen', 'esc'); kpNeinSagen(false); });

    // Absenden einmal anhalten, Bild erzeugen, dann erneut absenden. So
    // bleibt die Warenkorb-Logik des Themes unangetastet.
    shotForm?.addEventListener('submit', (e) => {
      if (shotDone || !shotInput || !mv || !fabricMat) return;
      e.preventDefault();
      e.stopPropagation();
      buildShot()
        .catch((err) => console.warn('[fmnv-p3d] Vorschaubild nicht erzeugbar', err))
        .finally(() => {
          shotDone = true;
          const btn = shotForm.querySelector('[name="add"]');
          if (shotForm.requestSubmit) shotForm.requestSubmit(btn);
          else shotForm.submit();
          // Der nächste Kauf soll wieder ein frisches Bild bekommen.
          setTimeout(() => { shotDone = false; }, 0);
        });
    }, true);

    /* ------------------- Kamera: Pfeile + Dots ------------------- */
    // Je Aktion nur die erste Meldung im Seitenaufruf — sonst würde jedes
    // Ziehen am Modell erneut zählen.
    const dreiDGemeldet = new Set();
    function meldeEinmal3d(aktion, detail) {
      if (dreiDGemeldet.has(aktion)) return;
      dreiDGemeldet.add(aktion);
      melde('3d', aktion, detail);
    }
    /* Eine 3D-Ansicht (Marc, 2026-10-06): „Seite“ und „Hinten“ sind raus — Drehen
       geht per Ziehen am Sofa, die beiden Kacheln kosteten nur Platz neben den
       Fotos. Die Liste bleibt eine Liste, weil goToView/Fotos auf VIEWS.length
       rechnen. */
    const VIEWS = [
      { label: '3D-Ansicht', theta: '0deg', phi: '85deg' },
    ];
    // Startansicht: die Front. Bei fünf Winkeln war es die Schrägansicht.
    let viewIdx = 0;
    // Abstand in Metern. model-viewer rechnet Prozentangaben nur beim Setzen
    // um und liefert beim Lesen immer Meter — in einer Einheit zu bleiben
    // erspart die Rückrechnung.
    let radius = null;
    let radiusMin = 0, radiusMax = Infinity;

    /* Nahgrenze der Kamera. Sie steht an zwei Stellen: unsere Zoomknöpfe
       rechnen mit `radiusMin`, Mausrad und Zwei-Finger-Geste gehen an ihnen
       vorbei und halten sich allein an `min-camera-orbit`. Beide müssen
       denselben Wert sehen, sonst zoomt die Geste ins Sofa hinein, während
       der Knopf davor stehen bleibt.

       Der senkrechte Anteil wechselt mit dem Anheften der Bühne (weiter
       unten), der Abstand mit dem geladenen Modell — deshalb beides hier
       zusammensetzen statt an zwei Stellen Zeichenketten zu flicken.
       Vor dem Laden ist die Modellgröße unbekannt; dann bleibt die
       Prozentangabe aus dem Markup stehen. */
    let minAbstand = null;
    let minPhi = 'auto';
    /* Zuletzt geschriebener Wert. Das Setzen von min-camera-orbit löst selbst
       ein camera-change aus, und dort steht der Aufruf hierher — ohne diesen
       Vergleich ruft sich die Grenze über das eigene Ereignis endlos selbst
       auf, solange die Maße noch fehlen, und friert die Seite ein, bevor das
       Modell fertig laden kann. */
    let minOrbitWert = null;
    function setzeMinOrbit() {
      if (!mv) return;
      /* Die Grenze wird hier hergeleitet, nicht übergeben: Die Maße stehen
         erst mit dem geladenen Modell fest, und wann das ist, hängt an
         Zwischenfassung (-lite), Cache und Ausführungswechsel. Wer immer
         zuerst vorbeikommt — Ladeereignis, Anheften, erste Geste — rechnet
         sie aus; die späteren finden sie fertig vor. */
      if (minAbstand === null) {
        const masse = mv.getDimensions?.();
        const huelle = masse ? Math.hypot(masse.x, masse.y, masse.z) / 2 : 0;
        if (huelle > 0) {
          minAbstand = huelle * 1.1;
          radiusMin = minAbstand;
        }
      }
      const wert = `auto ${minPhi} ${minAbstand === null ? '35%' : `${minAbstand}m`}`;
      if (wert === minOrbitWert) return;
      minOrbitWert = wert;
      // Eigenschaft und Attribut: model-viewer liest die Eigenschaft, das
      // Attribut hält den Zustand für den nächsten Leser sichtbar.
      mv.minCameraOrbit = wert;
      mv.setAttribute('min-camera-orbit', wert);
    }

    const ZOOM_STEP = 0.85;   // ein Klick = 15 % näher bzw. weiter weg

    // Zoom über den Perspektivwechsel hinweg halten — sonst springt die
    // Ansicht bei jedem Klick auf einen Punkt wieder heraus.
    function applyCamera() {
      if (!mv) return;
      const v = VIEWS[viewIdx - vorne()] || VIEWS[0];
      mv.cameraOrbit = radius === null ? `${v.theta} ${v.phi} auto` : `${v.theta} ${v.phi} ${radius}m`;
    }

    /* ------------------------- Fotos zur Farbe -------------------------

       Der Katalog benennt seine Bilder F-<Modellnummer>_<Farbcode>_<Art>_<Nr>.
       Damit hängt jedes Foto ohne weitere Pflege an genau einer Stofffarbe:
       wechselt der Kunde die Farbe, wechselt die Galerie mit.

       „content“ bleibt außen vor — das sind quadratische Grafiken für
       Anzeigen, keine Produktansichten. */
    /* Reihenfolge wie im Katalog: erst das Sofa freigestellt, dann im Raum,
       dann die Maße und zuletzt die Vorteile. Die letzten drei hängen am
       Modell, nicht an der Farbe — sie bleiben beim Farbwechsel stehen. */
    const FOTO_ARTEN = {
      freisteller: { label: 'Freisteller', rang: 0 },
      funktion:  { label: 'Schlaffunktion', rang: 1.5 },
      m:         { label: 'Wohnbild',    rang: 2 },
      lifestyle: { label: 'Wohnbild',    rang: 2 },
      raum:      { label: 'Raumbild',    rang: -1 },  // Hauptbild vor dem Freisteller (Marc, 2026-10-15)
      video:     { label: 'Video',       rang: 6 },  // immer letzte Kachel (Marc, 2026-10-14)
      produkt:   { label: 'Details',     rang: 3 },    // Form, Sitzkomfort (Marc, 2026-10-20)
      spec:      { label: 'Maße',        rang: 4 },
      kauf:      { label: 'Service',     rang: 4.5 },  // Stoffmuster, Lieferung, Sicherheit
      usp:       { label: 'Vorteile',    rang: 5 },
    };
    /* Studio-Freisteller frontal + diagonal je Ausführung und Farbe (Marc, 2026-10-12).
       Sie liegen nicht als Produktmedien (höchstens 250 je Produkt, gebraucht wären 340),
       sondern unter festem Namen in Inhalte → Dateien: F-<Konfig-Nr>_<Farbcode>_freisteller_05
       (frontal) und _06 (diagonal), auch für gespiegelte und Schlaf-Ausführungen unter deren
       eigener Nummer. Die Nummer steckt im Variantentitel (F-MM11887_1S). Fehlt eine Datei,
       fällt die Kachel still weg; die alten Freisteller aus den Produktmedien bleiben Ersatz. */
    const DATEIEN = 'https://cdn.shopify.com/s/files/1/0974/7673/9459/files/';
    const fehlendeFreisteller = new Set();
    const gepruefteFreisteller = new Set();
    const konfigNummer = (k) => {
      const p = k && (k.preise || []).find((x) => /^F-[A-Z0-9]+_/.test(x.sku || x.gruppe || ''));
      return p ? (p.sku || p.gruppe).match(/^F-([A-Z0-9]+)_/)[1] : '';
    };
    /* Schlaf-Ausführungen dürfen zusätzlich die Funktion zeigen (ausgezogenes Bett), benannt wie im
       Render-Matcher: _cutout_function_01 (frontal) und _02 (diagonal) — Marc, 2026-10-12: nur dort,
       nie an der Ausführung ohne Schlaffunktion. */
    function freistellerFuer(k, code) {
      const nr = konfigNummer(k);
      if (!nr || !code) return [];
      // Raumbild je Ausführung und Farbe (Marc, 2026-10-15): F-<Konfig-Nr>_<Farbcode>_raum_01, hinten
      // angehängt, damit [1] weiter der diagonale Freisteller bleibt (Zuletzt-konfiguriert-Bild).
      const arten = [['freisteller_05', 'freisteller'], ['freisteller_06', 'freisteller']]
        .concat(k.schlaf ? [['cutout_function_01', 'funktion'], ['cutout_function_02', 'funktion']] : [])
        .concat([['raum_01', 'raum']]);
      return arten.map(([endung, art], i) => ({ code, art, ord: i,
        datei: `F-${nr}_${code}_${endung}.jpg` }))
        .filter((f) => !fehlendeFreisteller.has(f.datei))
        .map((f) => ({ ...f, u: DATEIEN + f.datei + '?width=1400' }));
    }
    function pruefeFreisteller(liste) {
      liste.forEach((f) => {
        if (gepruefteFreisteller.has(f.datei)) return;
        gepruefteFreisteller.add(f.datei);
        const img = new Image();
        img.onerror = () => { fehlendeFreisteller.add(f.datei); setzeFotos(); };
        img.src = f.u.replace(/width=\d+/, 'width=200');  // dieselbe URL wie die Kachel
      });
    }
    const fotoEl = root.querySelector('[data-p3d-foto]');
    const pdpVideoEl = root.querySelector('[data-p3d-video]');
    const fotoHinweisEl = root.querySelector('[data-p3d-foto-hinweis]');
    let fotos = [];
    let raumStartGeprueft = false;

    /* Reihenfolge der Leiste (Marc, 2026-10-08): Die Freisteller stehen vor dem
       3D-Modell, danach die übrigen Fotos. `fotos` ist nach Rang sortiert, die
       Freisteller (Rang 0) liegen also vorn — die ersten `vorne()` Plätze sind
       Freisteller, dann folgen die VIEWS, dann der Rest. */
    const vorne = () => { let n = 0; while (fotos[n]?.art === 'freisteller' || fotos[n]?.art === 'raum') n++; return n; };
    // Foto an Platz i der Leiste, undefined = 3D-Ansicht.
    const fotoAn = (i) => (i < vorne() ? fotos[i] : fotos[i - VIEWS.length]);
    const istFotoPlatz = (i) => i < vorne() || i >= vorne() + VIEWS.length;
    const platzVonFoto = (n) => (n < vorne() ? n : n + VIEWS.length);
    const platzVon3d = (i) => vorne() + i;

    /* Ersatz, wenn die gewählte Farbe kein Wohnbild hat — bei den meisten
       Farben der Fall. Ohne Raumaufnahme fehlt dem Kunden der Maßstab, wie
       das Sofa im Zimmer wirkt; ein Foto in anderem Stoff beantwortet das
       trotzdem, solange dabeisteht, welcher Stoff zu sehen ist.
       Reihenfolge: derselbe Stoff in anderer Farbe (gleiche Struktur), dann
       irgendeine Farbe dieser Ausführung (gleiche Form), zuletzt das
       Serienbild. */
    const istWohnbild = (b) => b.art === 'm' || b.art === 'lifestyle';
    function beispielWohnbilder(liste) {
      const wohn = liste.filter((b) => istWohnbild(b) && b.code);
      const imStoff = new Set(family.colors.map((c) => c.code));
      const code = (wohn.find((b) => imStoff.has(b.code)) || wohn[0] || {}).code;
      if (code) return wohn.filter((b) => b.code === code).map((b) => ({ ...b, beispiel: true }));
      if (!SERIENBILD) return [];
      // Das Metafeld hält teils die volle Adresse, teils nur den Dateinamen.
      let u = SERIENBILD.includes('/') ? SERIENBILD
        : 'https://cdn.shopify.com/s/files/1/0974/7673/9459/files/' + SERIENBILD;
      if (!/width=\d+/.test(u)) u += (u.includes('?') ? '&' : '?') + 'width=1400';
      const datei = u.split('?')[0].split('/').pop();
      const teile = datei.split('_');
      const bildCode = teile.length > 2 && teile[0].startsWith('F-') ? teile[1] : '';
      return [{ art: 'lifestyle', code: bildCode, datei, u, beispiel: true }];
    }
    const beispielFarbe = (f) => (f.code && FAMILIES.flatMap((x) => x.colors).find((x) => x.code === f.code)) || null;
    function beispielText(f) {
      const c = beispielFarbe(f);
      // Ohne Code im Dateinamen ist der Stoff unbekannt — nichts behaupten.
      return c ? `Foto zeigt Stoff ${c.fam.name} in ${c.label}` : 'Beispielfoto aus der Serie';
    }
    /* Hinweis als kleine Karte: Stoffprobe des gezeigten Stoffs plus Name —
       die Probe sagt schneller als der Text, dass hier ein anderer Stoff
       liegt. Unbekannter Stoff: Bildsymbol statt Probe. */
    function zeigeHinweis(foto) {
      if (!fotoHinweisEl) return;
      const an = !!(foto && foto.beispiel);
      fotoHinweisEl.hidden = !an;
      if (!an) return;
      const c = beispielFarbe(foto);
      const probe = fotoHinweisEl.querySelector('[data-p3d-foto-hinweis-probe]');
      probe.classList.toggle('ist-leer', !c);
      probe.style.backgroundImage = c && c.swatch
        ? `url('${c.swatch.replace(/^\/\//, location.protocol + '//')}')` : '';
      fotoHinweisEl.querySelector('[data-p3d-foto-hinweis-label]').textContent = c ? 'Abgebildet' : 'Beispielfoto';
      fotoHinweisEl.querySelector('[data-p3d-foto-hinweis-name]').textContent = c ? `${c.fam.name} · ${c.label}` : 'aus der Serie';
      fotoHinweisEl.setAttribute('aria-label', beispielText(foto));
    }

    function setzeFotos() {
      // Was gerade im Bild steht, bevor die Liste neu sortiert wird (die Indizes verschieben sich).
      const vorher = istFotoPlatz(viewIdx) ? fotoAn(viewIdx) : null;
      // Index in `fotos` bzw. in VIEWS — die Plätze verschieben sich mit der Zahl der Freisteller.
      const fotoNrVorher = vorher ? fotos.indexOf(vorher) : -1;
      const ansichtVorher = vorher ? 0 : viewIdx - vorne();
      const liste = (konfig && konfig.bilder) || [];
      const eigene = freistellerFuer(konfig, color.code);
      pruefeFreisteller(eigene);
      let auswahl = liste
        // Freisteller aus den Produktmedien nur noch, wenn es keine aus den Dateien gibt.
        .filter((b) => !(b.art === 'freisteller' && eigene.some((e) => e.art === 'freisteller')))
        // Leerer Code heißt: gehört zum Modell und gilt für jede Farbe.
        .filter((b) => FOTO_ARTEN[b.art] && (b.code === color.code || b.code === ''))
        .concat(eigene);
      if (!auswahl.some(istWohnbild)) auswahl = auswahl.concat(beispielWohnbilder(liste));
      /* Produktionsvideo als letzte Kachel (Marc, 2026-10-14). Gehört zu keiner Farbe;
         `u` ist das Standbild für die Kachel. */
      if (PDP_VIDEO && pdpVideoEl) auswahl = auswahl.concat({ art: 'video', code: '', datei: 'pdp-video', u: PDP_VIDEO.poster, alt: PDP_VIDEO.alt });
      /* Raumbilder der Serie (fmnv_raumbilder) sind raus (Marc, 2026-10-08): Jedes zeigt
         nur einen Stoff und stand so bei allen Farben gleich da. */
      fotos = auswahl
        .sort((a, b) => (FOTO_ARTEN[a.art].rang - FOTO_ARTEN[b.art].rang)
                        || ((a.ord || 0) - (b.ord || 0))
                        || a.datei.localeCompare(b.datei))
        // Shopify liefert protokollrelativ; über http scheitert das still.
        .map((b) => ({ ...b, u: b.u.replace(/^\/\//, location.protocol + '//')
          // USP-Grafik am 2026-10-12 unter gleicher URL ersetzt; Browser cachen ein Jahr → neue Adresse.
          + (b.art === 'usp' ? '&v=20261012' : '') }));
      zeichneFotokacheln();
      /* Raumbild für „Das Sofa“ unter dem Konfigurator (Marc, 2026-10-20) — gemeldet wie
         fmnv:konfiguration, hinterlegt für einen Abschnitt, der später zuhört. */
      const raumbild = fotos.find((f) => f.art === 'raum') || fotos.find((f) => f.art === 'freisteller');
      if (raumbild && raumbild.u !== document.fmnvRaumbild) {
        document.fmnvRaumbild = raumbild.u;
        document.dispatchEvent(new CustomEvent('fmnv:raumbild', { detail: raumbild.u }));
      }
      meldeAuswahl();
      /* Zurück auf das Modell, sobald das gezeigte Bild die neue Farbe nicht
         zeigt: Es gibt keine, wenn das Foto zum Modell gehört (Maße, Vorteile)
         oder gar nicht mehr existiert. Ohne das klickt man Farben durch und
         sieht weiter dasselbe Bild — der Viewer wirkt eingefroren. Ein
         Ersatzfoto bleibt stehen: Es trägt den Hinweis, welchen Stoff es zeigt. */
      const gezeigt = vorher ? fotos[fotoNrVorher] : null;
      /* Stand ein Raumbild im Bild und wechselt die Farbe (Marc, 2026-10-06): Gibt es ein
         Raumbild in der neuen Farbe, zeigt der Viewer dieses — sonst das 3D-Modell in der
         neuen Farbe. Ein fremdes Raumbild stehen zu lassen hieße, die gewählte Farbe nicht
         zu zeigen. */
      if (vorher && vorher.art === 'raum') {
        const ri = fotos.findIndex((f) => f.art === 'raum' && !f.beispiel);
        // Ohne Raumbild (auch: Datei fehlt, 404) zeigt der Freisteller die neue Farbe, sonst das Modell.
        goToView(ri >= 0 ? platzVonFoto(ri) : vorne() ? 0 : platzVon3d(0));
      }
      else if (vorher && !(gezeigt && (gezeigt.code || gezeigt.beispiel))) goToView(platzVon3d(0));
      else if (vorher) goToView(platzVonFoto(fotoNrVorher));
      // Steht das Modell im Bild, bleibt die Kamera, wo sie ist — sonst dreht
      // ein Farbwechsel das von Hand gedrehte Sofa sichtbar zurück. Nur der
      // Platz in der Leiste rückt mit der Zahl der Freisteller.
      else { viewIdx = platzVon3d(ansichtVorher); markiereAnsicht(); }
      /* Beim ersten Aufbau: Zeigt ein Raumbild genau den vorgewählten Stoff in dieser Farbe,
         ist es das Hauptbild statt des 3D-Viewers (Marc, 2026-10-06). Danach nie wieder von
         selbst — wer eine Farbe wählt, will sie am 3D-Modell sehen. */
      /* Gibt es einen Freisteller der Farbe, ist er das Hauptbild (Marc, 2026-10-08) —
         er steht an erster Stelle der Leiste. */
      if (!raumStartGeprueft) {
        raumStartGeprueft = true;
        const ri = fotos.findIndex((f) => f.art === 'raum' && !f.beispiel);
        if (vorne() && !istFotoPlatz(viewIdx)) goToView(0);
        else if (ri >= 0 && !istFotoPlatz(viewIdx)) goToView(platzVonFoto(ri));
      }
    }

    function zeichneFotokacheln() {
      const kacheln = root.querySelector('[data-p3d-thumbs]');
      if (!kacheln) return;
      kacheln.querySelectorAll('[data-p3d-fotokachel]').forEach((b) => b.remove());
      fotos.forEach((f, n) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.p3dFotokachel = '';
        b.className = 'fmnv-p3d__thumb fmnv-p3d__thumb--foto' + (f.art === 'video' ? ' fmnv-p3d__thumb--video' : '');
        b.setAttribute('role', 'tab');
        // Zwei Freisteller derselben Farbe wären sonst gleich benannt und
        // per Vorlesen nicht unterscheidbar. Modellbilder zeigen keine
        // bestimmte Farbe — sie bekommen den Farbnamen auch nicht angehängt.
        const gleiche = fotos.filter((x) => x.art === f.art);
        const nr = gleiche.length > 1 ? ` ${gleiche.indexOf(f) + 1}` : '';
        b.setAttribute('aria-label',
          `${FOTO_ARTEN[f.art].label}${nr}${f.beispiel ? ', ' + beispielText(f) : f.code ? ' ' + color.label : ''}`);
        // Dieselbe Datei, nur klein ausgeliefert — Shopify skaliert über den
        // Parameter, das spart einen zweiten Satz Bilder.
        b.style.backgroundImage = `url('${f.u.replace(/width=\d+/, 'width=200')}')`;
        b.addEventListener('click', () => {
          // Nur das Wohnbild zählt als Raumansicht — Maße und Vorteile sind
          // keine Raumaufnahmen.
          if (f.art === 'm' || f.art === 'lifestyle' || f.art === 'raum') meldeEinmal3d('raumansicht', FOTO_ARTEN[f.art].label);
          goToView(platzVonFoto(n));
        });
        // Raumbild und Freisteller (die ersten vorne() Fotos) vor die 3D-Kachel, alles andere dahinter.
        if (n < vorne() && thumbBtns[0]) kacheln.insertBefore(b, thumbBtns[0]);
        else kacheln.appendChild(b);
      });
      // Neue Kacheln tragen die Markierung noch nicht.
      markiereAnsicht();
    }

    function goToView(i) {
      const gesamt = VIEWS.length + fotos.length;
      viewIdx = (i + gesamt) % gesamt;
      let foto = istFotoPlatz(viewIdx) ? fotoAn(viewIdx) : null;
      // Das Video liegt im eigenen Element über dem Modell; das Foto bleibt dann aus.
      const video = foto && foto.art === 'video' ? foto : null;
      // Für CSS: Video und Vorteile zeigen keinen Stoff, die Stoffkarte bleibt dort aus.
      root.dataset.fotoArt = foto ? foto.art : '';
      // Topseller-Leiste nur am ersten Bild, an den Freistellern und am 3D-Modell (Marc, 2026-10-20).
      root.toggleAttribute('data-bsbar-aus', !!foto && foto !== fotos[0] && foto.art !== 'freisteller');
      if (pdpVideoEl) {
        if (video) {
          if (!pdpVideoEl.src) { pdpVideoEl.poster = PDP_VIDEO.poster; pdpVideoEl.src = PDP_VIDEO.src; }
          pdpVideoEl.setAttribute('aria-label', video.alt);
        } else pdpVideoEl.pause();
        pdpVideoEl.hidden = !video;
      }
      if (video) foto = null;
      if (fotoEl) {
        if (foto) {
          // Raumbilder füllen den Viewer (cover), Freisteller/Maße bleiben ganz sichtbar (contain).
          fotoEl.classList.toggle('ist-raum', foto.art === 'raum');
          // Freisteller liegen auf der Viewer-Farbe; weiße Ränder beim Einpassen wären sichtbar.
          fotoEl.classList.toggle('ist-freisteller', foto.art === 'freisteller' || foto.art === 'funktion');
          /* Fotos in Viewer-Breite laden statt immer 1400 px (Marc, 2026-10-08: schneller laden):
             Handy mit 2× lädt so ~800 px (≈ 18 statt 48 KB WebP). Raumbilder (cover), Maße und
             Vorteile (Text) behalten 1400 px. */
          let fotoU = foto.u;
          if (['freisteller', 'funktion', 'm', 'lifestyle'].includes(foto.art)) {
            const breite = (fotoEl.parentElement?.clientWidth || 0) * (window.devicePixelRatio || 1);
            // Freisteller liegen in 2400 px vor und dürfen auf großen Retina-Schirmen voll laden.
            const grenze = foto.art === 'freisteller' || foto.art === 'funktion' ? 2400 : 1400;
            if (breite) fotoU = fotoU.replace(/width=\d+/, 'width=' + Math.min(grenze, Math.max(400, Math.ceil(breite / 200) * 200)));
          }
          fotoEl.src = fotoU;
          fotoEl.alt = foto.beispiel
            ? `${PRODUKT_TITEL || 'Sofa'} — ${FOTO_ARTEN[foto.art].label}, ${beispielText(foto)}`
            : foto.code
            ? `${family.name} ${color.label} — ${FOTO_ARTEN[foto.art].label}`
            : `${PRODUKT_TITEL || 'Sofa'} — ${FOTO_ARTEN[foto.art].label}`;
        }
        fotoEl.hidden = !foto;
      }
      zeigeHinweis(foto);
      if (!foto && !video) applyCamera();
      markiereAnsicht();
    }

    function markiereAnsicht() {
      // Punkte gibt es nur für die VIEWS, die Leiste trägt alle Plätze.
      dotsEl?.querySelectorAll('button').forEach((d, n) => {
        d.classList.toggle('is-active', platzVon3d(n) === viewIdx);
        d.setAttribute('aria-selected', String(platzVon3d(n) === viewIdx));
      });
      root.querySelector('[data-p3d-thumbs]')?.querySelectorAll('button').forEach((d, n) => {
        d.classList.toggle('is-active', n === viewIdx);
        d.setAttribute('aria-selected', String(n === viewIdx));
      });
    }

    function zoomBy(dir) {
      if (!mv || radius === null) return;
      // Die Knöpfe rechnen mit radiusMin — der steht erst, wenn die Grenze
      // einmal hergeleitet wurde. Nach dem ersten Mal kostet das nichts.
      if (minAbstand === null) setzeMinOrbit();
      const factor = dir < 0 ? ZOOM_STEP : 1 / ZOOM_STEP;
      radius = Math.min(radiusMax, Math.max(radiusMin, radius * factor));
      applyCamera();
    }
    root.querySelectorAll('[data-p3d-zoom]').forEach((btn) => {
      btn.addEventListener('click', () => {
        meldeEinmal3d('zoom', Number(btn.dataset.p3dZoom) < 0 ? 'vergroessern' : 'verkleinern');
        zoomBy(Number(btn.dataset.p3dZoom));
      });
    });

    // Rad und Zwei-Finger-Geste zoomen an unseren Knöpfen vorbei. Den Wert
    // mitlesen, damit der nächste Perspektivklick den Zoom nicht verwirft.
    if (mv) {
      mv.addEventListener('camera-change', (e) => {
        /* Vor der Weiche: Auch die Kamerafahrten der Seite selbst (Aufwärmen,
           Kachel-Abgriff) zählen als Gelegenheit, die Nahgrenze zu setzen.
           Beim Ladeereignis sind die Maße nicht immer schon da — hier sind
           sie es, und zwar lange bevor jemand zoomt. */
        if (minAbstand === null) setzeMinOrbit();
        if (e.detail?.source !== 'user-interaction') return;
        // Deckt Ziehen ebenso ab wie Mausrad/Pinch — beides „von Hand".
        meldeEinmal3d('drehen', 'ziehen');
        const r = mv.getCameraOrbit?.().radius;
        if (Number.isFinite(r)) radius = r;
      });
    }
    // Perspektiv-Punkte nur, wenn es mehr als eine Perspektive gibt.
    if (dotsEl && VIEWS.length > 1) {
      VIEWS.forEach((v, i) => {
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'fmnv-p3d__dot';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-label', v.label);
        d.addEventListener('click', () => { meldeEinmal3d('perspektive', v.label); goToView(platzVon3d(i)); });
        dotsEl.appendChild(d);
      });
    }

    /* ------------------------ Vorschaubilder ------------------------
       Aus dem geladenen Modell gerendert: die Kamera springt kurz durch
       alle Perspektiven, jedes Bild wird abgegriffen, danach steht die
       Ansicht wieder wie zuvor. Das ist der einzige Weg, der bei 181
       Stoffen dauerhaft stimmt — vorgerenderte Bilder wären nach dem
       ersten Stoffwechsel falsch.
    ---------------------------------------------------------------- */
    const thumbsEl = root.querySelector('[data-p3d-thumbs]');
    let thumbBtns = [];
    let shooting = false;

    function buildThumbs() {
      if (!thumbsEl || thumbBtns.length) return;
      thumbBtns = VIEWS.map((v, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'fmnv-p3d__thumb fmnv-p3d__thumb--3d' + (platzVon3d(i) === viewIdx ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', v.label);
        b.addEventListener('click', () => { meldeEinmal3d('perspektive', v.label); goToView(platzVon3d(i)); });
        thumbsEl.appendChild(b);
        return b;
      });
      // Die Fotokacheln neu anhängen: Sie müssen hinter den Ansichten stehen,
      // sonst zeigt der Index auf die falsche Kachel.
      zeichneFotokacheln();
    }

    /* Wartet, bis die Kamera den Zielwinkel erreicht hat — höchstens eine
       halbe Sekunde, damit ein hängender Kameraflug nicht die ganze
       Aufnahme blockiert. Verglichen wird auf kürzestem Weg, sonst gälten
       -170° und 190° als weit auseinander. */
    /* Nichts im Abgriff darf unbegrenzt warten: Bleibt eine Zusage aus,
       hängt der Standbildschleier über dem Viewer und der Kunde sieht bis
       zum nächsten Klick sein Sofa nicht mehr. */
    const mitZeitgrenze = (zusage, ms) =>
      Promise.race([zusage, new Promise((r) => setTimeout(r, ms))]);

    async function warteAufWinkel(gradZiel) {
      const ziel = (gradZiel * Math.PI) / 180;
      // Mit abgeschalteter Kamerainterpolation steht das Bild nach ein bis
      // zwei Frames; zwölf sind der Sicherheitsrahmen, nicht die Regel.
      for (let n = 0; n < 12; n++) {
        await new Promise((r) => requestAnimationFrame(r));
        const t = mv.getCameraOrbit?.().theta;
        if (!Number.isFinite(t)) return;
        const d = Math.abs(Math.atan2(Math.sin(t - ziel), Math.cos(t - ziel)));
        if (d < 0.004) return;
      }
    }

    async function shootThumbs() {
      if (!mv || shooting || !thumbBtns.length) return;
      /* Nicht abgreifen, was niemand sieht.

         Auf dem Telefon ist die Kachelleiste ausgeblendet — der Flug durch die
         drei Ansichten lief trotzdem, nach jedem Stoff- und Farbwechsel. Zu
         sehen war davon nur das Standbild, das sich währenddessen über die
         ganze Bühne legt: Das Sofa blitzte bei jedem Klick einmal auf, ohne
         dass sich etwas geändert hätte. Gemessen wechselte im ersten Sechstel
         nach dem Klick die gesamte Bühne statt nur der Stofffläche.

         `offsetParent` statt einer Breitenabfrage: Es fragt, ob das Element
         tatsächlich dargestellt wird — unabhängig davon, welche Regel es
         gerade verbirgt. */
      const kachelleiste = root.querySelector('.fmnv-p3d__thumbs');
      if (!kachelleiste || kachelleiste.offsetParent === null) return;
      shooting = true;
      const keepIdx = viewIdx, keepRadius = radius;
      const orbitVorher = mv.getCameraOrbit?.();
      /* Die Kamera springt statt zu fliegen. Der Flug war nur zu sehen, wenn
         gar nichts darüberlag — hier liegt das Standbild darüber, er kostete
         also nur Zeit: drei Winkel mal eine halbe Sekunde Einschwingen. */
      const decayVorher = mv.interpolationDecay;
      mv.interpolationDecay = 0;
      // Aktuelle Ansicht einfrieren und darüberlegen. Der Kameraflug läuft
      // dahinter ab; sichtbar bleibt ein ruhiges Standbild.
      const freeze = root.querySelector('[data-p3d-freeze]');
      try {
        if (freeze) {
          freeze.style.backgroundImage = `url('${mv.toDataURL('image/webp', 0.85)}')`;
          freeze.hidden = false;
        }
      } catch (err) { /* ohne Standbild weiter — dann eben mit Bewegung */ }
      try {
        for (let i = 0; i < VIEWS.length; i++) {
          const v = VIEWS[i];
          mv.cameraOrbit = `${v.theta} ${v.phi} 105%`;
          await mitZeitgrenze(mv.updateComplete, 400);
          // Die Kamera fährt weich zum Ziel. Zwei Frames später ist sie erst
          // unterwegs — abgegriffen wurde dann der vorige Winkel, jedes
          // Vorschaubild hing eine Ansicht zurück. Also warten, bis sie
          // wirklich steht.
          await warteAufWinkel(parseFloat(v.theta));
          /* Zwei Frames, nicht eines: toDataURL liest den Zeichenpuffer, und
             der ist nur unmittelbar nach einem Rendern gefüllt. Nach einem
             einzelnen Frame kamen leere Kacheln heraus. */
          await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
          thumbBtns[i].style.backgroundImage = `url('${mv.toDataURL('image/webp', 0.7)}')`;
        }
      } catch (err) {
        // toDataURL scheitert, wenn der WebGL-Kontext verloren geht. Dann
        // bleiben die Kacheln leer statt die Seite mitzureißen.
        console.warn('[fmnv-p3d] Vorschaubilder nicht erzeugbar', err);
      } finally {
        viewIdx = keepIdx;
        radius = keepRadius;
        /* Zurück an genau die Stelle von vorher, springend statt fliegend.
           Vorher fuhr die Kamera weich von der letzten Aufnahme (Hinten)
           zurück; das Standbild ging nach spätestens 0,4 s weg, der Flug
           dauerte länger — nach jedem Stoff- und Farbwechsel schwenkte das
           Sofa sichtbar. */
        if (orbitVorher) {
          mv.cameraOrbit = `${orbitVorher.theta}rad ${orbitVorher.phi}rad ${orbitVorher.radius}m`;
        } else {
          applyCamera();
        }
        mv.jumpCameraToGoal?.();
        mv.interpolationDecay = decayVorher;
        // Erst wenn die Kamera zurück ist, das Standbild wegnehmen — sonst
        // blitzt der letzte Aufnahmewinkel auf.
        if (freeze) {
          await mitZeitgrenze(mv.updateComplete, 400);
          await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
          freeze.hidden = true;
        }
        shooting = false;
      }
    }

    // Nach jedem Stoffwechsel neu abgreifen, aber gebündelt: beim Durchklicken
    // von Farben sonst ein Kameraflug pro Klick.
    let shotTimer = null;
    let ersteAufnahme = true;
    const scheduleThumbs = () => {
      clearTimeout(shotTimer);
      // Kurz genug, dass es beim einzelnen Klick nicht als Warten auffällt,
      // lang genug, dass schnelles Durchklicken nicht drei Kameraflüge auslöst.
      // Mobil: Das erste Mal sofort (hier sieht niemand einen Flug, die Kacheln
      // sollen da sein, wenn man hinschaut). Danach erst nach 1 s Ruhe: Der
      // Schnappschussflug ist dort sichtbar und ließ das Sofa nach jedem
      // einzelnen Klick aufblitzen.
      const mobil = window.matchMedia('(max-width: 989px)').matches;
      shotTimer = setTimeout(shootThumbs, !mobil ? 350 : (ersteAufnahme ? 100 : 1000));
      ersteAufnahme = false;
    };
    root.querySelectorAll('[data-p3d-rotate]').forEach((btn) => {
      btn.addEventListener('click', () => {
        meldeEinmal3d('drehen', Number(btn.dataset.p3dRotate) < 0 ? 'links' : 'rechts');
        goToView(viewIdx + Number(btn.dataset.p3dRotate));
      });
    });
    // Pfeiltasten blättern wie die Pfeile im Bild (Marc, 2026-10-20) — nicht beim Tippen in Feldern.
    document.addEventListener('keydown', (e) => {
      if ((e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if (e.target.closest?.('input, textarea, select, [contenteditable], [role="slider"]')) return;
      e.preventDefault();
      goToView(viewIdx + (e.key === 'ArrowRight' ? 1 : -1));
    });
    /* Auf dem angehefteten Viewer scrollt die Seite nicht (Marc, 2026-09-15).

       Mit der langen Stoffliste bleibt der Viewer mobil fast immer oben
       angeheftet. Wer ihn nicht genau auf dem Sofa traf, schob mit dem
       senkrechten Anteil der Geste die Farben unter ihm hoch und runter:
       model-viewer steht standardmäßig auf touch-action="pan-y" und gibt
       senkrechte Gesten an die Seite ab. Angeheftet gilt deshalb "none" —
       laut model-viewer-Doku verhindert das jedes Scrollen, senkrechtes Ziehen
       neigt dann das Sofa. Am Seitenanfang (noch nicht angeheftet) und im
       Querformat (nie angeheftet) bleibt pan-y, sonst käme man per Wischen
       auf dem Viewer gar nicht erst in die Seite hinein.

       Für die übrige Fläche der Bühne (Punkte, Pfeile, Foto, Rand) greift
       dasselbe per CSS; weil iOS CSS-touch-action nicht zuverlässig befolgt
       (Hinweis in der model-viewer-Doku), fängt zusätzlich ein touchmove die
       Bewegung ab. Taps und das waagerechte Foto-Wischen (Pointer-Ereignisse)
       bleiben davon unberührt. */
    (() => {
      const buehne = root.querySelector('.fmnv-p3d__stage');
      if (!buehne) return;
      /* Mit "none" neigt senkrechtes Ziehen die Kamera — ungebremst bis in die
         Draufsicht (gemessen 85° → 0°). Angeheftet deshalb nur 65–90°: eine
         leichte Schräge, nie von oben. Alle Ansichten (VIEWS) stehen auf 85°,
         die Kachel-Abgriffe bleiben also im erlaubten Bereich; der Abstand
         bleibt der aus der Modellgröße abgeleitete (setzeMinOrbit). */
      let fest = null;
      const pruefe = () => {
        const oben = buehne.getBoundingClientRect().top;
        /* Angeheftet heißt: klebt genau oben. Rutscht die Bühne am Ende des
           Konfigurators nach oben weg, wird top negativ — dann muss der Viewer
           die Seite wieder scrollen lassen, sonst hängt die Geste auf der halb
           sichtbaren Bühne. Im Konfigurier-Bildschirm steht die Bühne fest,
           solange sie ganz im Bild ist: Das Sofa wird gedreht, die Seite
           bleibt stehen. */
        const jetzt = imBildschirm()
          ? oben >= -1
          : getComputedStyle(buehne).position === 'sticky' && Math.abs(oben) <= 1;
        if (jetzt === fest) return;
        fest = jetzt;
        buehne.classList.toggle('ist-angeheftet', jetzt);
        if (mv) {
          mv.setAttribute('touch-action', jetzt ? 'none' : 'pan-y');
          minPhi = jetzt ? '65deg' : 'auto';
          setzeMinOrbit();
        }
      };
      addEventListener('scroll', pruefe, { passive: true });
      addEventListener('resize', pruefe);
      pruefe();
      buehne.addEventListener('touchmove', (e) => {
        if (fest && !e.target.closest('model-viewer')) e.preventDefault();
      }, { passive: false });
    })();

    /* Wischen über das Foto blättert zur nächsten Ansicht. Auf dem Telefon
       liegen die Pfeile klein am Rand, und wer ein Bild sieht, wischt — so
       bedient sich jede Galerie. Nur auf dem Foto: Auf dem Modell ist die
       waagerechte Geste das Drehen, das darf sie bleiben. Senkrecht bleibt
       Scrollen (touch-action im Stylesheet); der Browser nimmt uns die Geste
       dann per pointercancel wieder ab. */
    if (fotoEl) {
      let start = null;
      fotoEl.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        start = { x: e.clientX, y: e.clientY };
      }, { passive: true });
      fotoEl.addEventListener('pointercancel', () => { start = null; }, { passive: true });
      fotoEl.addEventListener('pointerup', (e) => {
        if (!start) return;
        const dx = e.clientX - start.x;
        const dy = e.clientY - start.y;
        start = null;
        // Deutlich waagerecht, sonst war es ein Tipp oder ein Scrollansatz.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        goToView(viewIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
    /* Wird das Fenster breit genug, taucht die Kachelleiste auf — dann sind
       ihre Bilder nachzuholen, weil auf dem Telefon keine abgegriffen wurden.
       Nur beim echten Wechsel der Breite: `resize` feuert auf dem Telefon bei
       jeder Scrollbewegung, weil die Adressleiste ein- und ausfährt. */
    (() => {
      let warSchmal = innerWidth <= 989;
      addEventListener('resize', () => {
        const schmal = innerWidth <= 989;
        if (schmal === warSchmal) return;
        warSchmal = schmal;
        if (!schmal) scheduleThumbs();
      });
    })();

    /* Lieferzeit und Ratenzahlung: am Schreibtisch im Kaufbereich unter dem
       Preis, auf dem Telefon unter den Schritten. Dort ist der Kaufbereich
       eine fixierte Leiste am unteren Rand — jede Zeile darin nimmt dem
       Konfigurator dauerhaft Bildhöhe. Ein Knoten, der wandert: Das
       PayPal-Element wird über seine Kennung gefunden und darf nicht doppelt
       vorkommen. Nur beim echten Wechsel der Breite, wie die Nachbarn oben. */
    (() => {
      const info = root.querySelector('[data-p3d-buy-info]');
      const kauf = root.querySelector('.fmnv-p3d__buy');
      const steps = root.querySelector('.fmnv-p3d__steps');
      if (!info || !kauf || !steps) return;
      function platziereKaufinfo() {
        const schmal = innerWidth <= 989;
        // Mobil ans Ende der Schrittliste: Im Konfigurier-Bildschirm scrollt
        // nur sie, ein Block dahinter bekäme eine feste Höhe vom Bildschirm ab.
        const ziel = schmal ? steps : kauf;
        if (info.parentElement === ziel) return;
        ziel.appendChild(info);
      }
      platziereKaufinfo();
      let warSchmal = innerWidth <= 989;
      addEventListener('resize', () => {
        const schmal = innerWidth <= 989;
        if (schmal === warSchmal) return;
        warSchmal = schmal;
        platziereKaufinfo();
      });
    })();

    /* --------------------------- Start --------------------------- */
    /* Deep-Link und Wiederaufnahme.

       ?stoff=b049 wählt Stoff und Farbe, ?variante= die Ausführung,
       ?schritt= den Schritt. Ohne das begann jedes Neuladen wieder bei der
       Ausführung — bei drei Schritten ärgerlich, bei einem geteilten Link
       schlicht falsch. */
    {
      const p = new URLSearchParams(location.search);

      // Altbestand: frühere Links trugen die Ausführung als Parameter.
      const v = p.get('variante');
      if (v) {
        const k = CONFIGS.find((x) => x.id === v);
        if (k) konfig = k;
      }

      const stoffCode = p.get('stoff');
      if (stoffCode) {
        for (const f of bestellbareFamilien()) {
          const hit = f.colors.find((c) => c.code.toLowerCase() === stoffCode.toLowerCase());
          if (hit) {
            family = f; color = hit;
            // Ohne den Stoff in der Auswahl stünde der Farbschritt leer da.
            chosen.add(f);
            farbeBestaetigt = true;
            /* Wer mit einer Farbe in der Adresse kommt (geteilter Link,
               Favorit, Rückkehr), hat das Schaufenster schon hinter sich —
               ihn noch einmal davorzusetzen wäre ein Rückschritt. */
            srUeberspringen = true;
            break;
          }
        }
      }

      // Die übrigen Stoffe der Auswahl wiederherstellen. Die gezeigte Farbe
      // hat ihren Stoff oben schon hinzugefügt.
      const stoffListe = p.get('stoffe');
      if (stoffListe) {
        const namen = stoffListe.split(',').map((x) => x.trim().toLowerCase()).filter(Boolean);
        bestellbareFamilien().forEach((f) => {
          const kennung = (f.slug || f.name).toLowerCase();
          if (namen.includes(kennung)) chosen.add(f);
        });
      }

      const schritt = p.get('schritt');
      // Test: Ältere Links auf den Farbschritt landen im kombinierten Schritt 2.
      if (schritt === '2' || schritt === '3') {
        stepEls['2']?.classList.remove('is-locked');
        wiederaufnahmeSchritt = '2';
      }
      /* Die mobile Kollektion hat Form, Ausrichtung und Funktion schon
         abgefragt. Das Schaufenster bleibt, aber „Jetzt konfigurieren“ öffnet
         gleich Stoff & Farbe (siehe schaufenster.oeffne). */
      if (p.get('gewaehlt') === '1') {
        formGewaehlt = true;
        stepEls['2']?.classList.remove('is-locked');
        wiederaufnahmeSchritt = wiederaufnahmeSchritt || '2';
      }
      // Jeder Link, der schon einen Schritt oder eine Ausführung nennt, führt
      // direkt in den Konfigurator.
      if (schritt || v) srUeberspringen = true;
    }

    /* Schaufenster oder Konfigurator? Die Entscheidung fällt vor dem ersten
       Zeichnen — und vor setzeKonfiguration, damit das Modell im Schaufenster
       gar nicht erst angefordert wird. Ohne ein einziges Wohnbild mit Farbcode
       (Durham, Ferrara, Treviso, Vaasa) gibt es nichts zu zeigen; dann beginnt
       die Seite wie bisher im Konfigurator. */
    const schaufenster = erstelleSchaufenster(root, {
      familien: FAMILIES,
      holeKonfig: () => konfig,
      istWohnbild, bestellbar, bestellbareFamilien,
      produktTitel: PRODUKT_TITEL,
      video: PDP_VIDEO,
      melde, geld, guenstigsteVariante, ruesteWischreihe,
      selectColor, unlockFabrics, openStep,
      formGewaehlt: () => formGewaehlt,
      platziereMusterknopf, syncLabels, rasteEin,
      // Welches Modell gilt, weiß die Section — das Schaufenster sagt nur, wann.
      modellLaden: () => setzeGlb(glbWunsch || START_GLB),
      mobilArbeitsbereich: () => setupMobileWorkspace(root, { placeSample: platziereMusterknopf }),
      setzeAktiv: (an) => { showroomAktiv = an; },
    });
    showroomAktiv = !srUeberspringen && schaufenster.anzahl > 0;
    if (showroomAktiv) root.classList.add('ist-showroom');

    /* Topseller-Rotation (Marc, 2026-10-20): Statt fest mit der ersten Farbe des beliebtesten
       Stoffs (Cord Glacier) zu starten, wechselt das Bild alle 4 s durch die Bestseller — bis
       der Kunde eine Farbe wählt oder Bild/Modell anfasst. Das 3D-Modell wird nur umgefärbt,
       wenn es gerade im Bild steht; sonst kostet ein Wechsel nur das Foto. */
    const ROT_MS = 4000;
    let rotTimer = null;
    let rotMalen = false;
    function rotationStopp(malen = true) {
      if (!rotTimer) return;
      clearInterval(rotTimer);
      rotTimer = null;
      if (malen && rotMalen) paint();
      rotMalen = false;
    }
    function rotiere() {
      if (farbeBestaetigt) return rotationStopp();
      if (document.hidden) return;
      const liste = bestsellerFarben();
      if (liste.length < 2) return;
      const i = liste.indexOf(color);
      color = liste[(i + 1) % liste.length];
      family = color.fam;
      syncLabels(); setzeFotos(); markiereBestseller();
      if (istFotoPlatz(viewIdx)) rotMalen = true;
      else { rotMalen = false; paint(true); }
      // Raumbild der übernächsten Farbe vorladen, sonst blitzt beim Wechsel ein leeres Bild.
      const naechste = liste[(i + 2) % liste.length];
      ((konfig && konfig.bilder) || []).forEach((b) => {
        if (b.art === 'raum' && b.code === naechste.code) new Image().src = b.u.replace(/^\/\//, location.protocol + '//');
      });
    }
    if (!farbeBestaetigt) {
      const erste = bestsellerFarben()[0];
      if (erste) { family = erste.fam; color = erste; }
      if (!slowConn && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        rotTimer = setInterval(rotiere, ROT_MS);
        // Wer Bild, Galerie oder Modell bedient, will nicht, dass es unter ihm wechselt.
        root.querySelector('.fmnv-p3d__stage')?.addEventListener('click', (e) => {
          if (!e.target.closest('.fmnv-p3d__bsbar, [data-p3d-tabs]')) rotationStopp();
        });
        mv?.addEventListener('camera-change', (e) => {
          if (e.detail && e.detail.source === 'user-interaction') rotationStopp();
        });
      }
    }

    renderFamilies(); renderTones(); renderColors(); syncLabels(); goToView(viewIdx);

    /* Erst hier den Schritt öffnen: Die Wiederaufnahme aus der Adresse steht
       weiter oben im Ablauf, und ein früherer Aufruf hätte sie überschrieben. */
    // setzeKonfiguration statt renderKonfigs: Nur so wird auch das Modell
    // der wiederhergestellten Ausführung geladen.
    if (konfig) setzeKonfiguration(konfig);
    openStep(wiederaufnahmeSchritt || 1);
    syncKauf();
    startFertig = true;
    // Wiederaufnahme mit gewählter Farbe: Musterknopf gleich in deren Zeile.
    platziereMusterknopf();

    /* Relief und Rauheit des ersten Stoffs gleich mit anstoßen. Sie hingen
       bisher hinter dem Modell: paint() läuft erst nach dessen load-Ereignis,
       und erst dort begann der Download der schwersten Texturen. Jetzt laden
       sie neben dem GLB und liegen bereit, wenn es fertig ist. */
    vorladenStruktur(family);
    prefetch(color.tex);

    if (showroomAktiv) {
      schaufenster.starte(color.code);
    } else {
      // Ohne Schaufenster gilt der bisherige Ablauf: Modell sofort laden.
      if (!mv || !mv.getAttribute('src')) setzeGlb(glbWunsch || START_GLB);
      setupMobileWorkspace(root, { placeSample: platziereMusterknopf });
    }

    /* Der Hinweis erscheint einmal je Seitenaufruf und geht, sobald jemand
       das Modell anfasst — wer es ohnehin dreht, braucht ihn nicht mehr.
       Ohne Anfassen blendet er nach acht Sekunden aus, damit er nicht
       dauerhaft im Bild steht. */
    const drehEl = root.querySelector('[data-p3d-dreh]');
    let drehGezeigt = false;
    function zeigeDrehhinweis() {
      if (!drehEl || drehGezeigt) return;
      drehGezeigt = true;
      drehEl.hidden = false;
      requestAnimationFrame(() => drehEl.classList.add('is-da'));
      const weg = () => {
        drehEl.classList.remove('is-da');
        setTimeout(() => { drehEl.hidden = true; }, 400);
      };
      const timer = setTimeout(weg, 8000);
      const beiBeruehrung = () => { clearTimeout(timer); weg(); };
      mv?.addEventListener('pointerdown', beiBeruehrung, { once: true, passive: true });
      mv?.addEventListener('wheel', beiBeruehrung, { once: true, passive: true });
    }

    if (mv) {
      showLoading('3D-Modell wird geladen …');
      /* Kommt die model-viewer-Bibliothek nicht an (Werbeblocker, Firmennetz,
         CDN-Ausfall), feuert weder load noch error — die Lade-Pille stünde
         für immer. Nach einer Frist deshalb sagen, dass die 3D-Ansicht fehlt;
         Auswahl und Bestellung hängen nicht an ihr. */
      setTimeout(() => {
        if (!customElements.get('model-viewer')) {
          hideSkeleton();
          showLoading('3D-Ansicht nicht verfügbar — Auswahl und Bestellung funktionieren trotzdem.');
        }
      }, 20000);
      /* Benannt, weil das Ereignis schon gefallen sein kann: Bibliothek und
         Modell laden unabhängig von diesem Skript, aus dem Cache sind beide
         mitunter vor dem Ende des Parsens fertig. Dann steht `mv.loaded`
         bereits, und der Handler wird von Hand nachgeholt. */
      const beiModellGeladen = () => {
        hideSkeleton();
        hideLoading();
        zeigeDrehhinweis();

        // Nahgrenze sofort: Sie hängt allein an den Maßen des Modells, nicht
        // an der Einpassung — und soll stehen, bevor die erste Geste kommt.
        setzeMinOrbit();

        /* Zoomgrenzen aus dem tatsächlichen Startabstand ableiten. Der
           Startwert entspricht dem Prozentsatz aus camera-orbit (STARTABSTAND);
           min/max spiegeln die Werte in min-/max-camera-orbit wider.

           Zwei Frames später, nicht sofort: model-viewer rechnet die Einpassung
           gegen die Größe der Leinwand, und die steht beim Ladeereignis noch
           nicht endgültig fest. Der Prozentsatz wird dabei noch einmal gesetzt
           — dann rechnet er gegen die fertige Leinwand und das Sofa steht in
           der Größe im Bild, für die der Wert gewählt wurde. */
        requestAnimationFrame(() => requestAnimationFrame(() => {
          // Winkel der gewählten Ansicht, nicht ein eigener Startwinkel: Mit
          // 30° flog die Kamera beim nächsten Neuzeichnen auf „Vorne" (0°).
          const v = VIEWS[viewIdx - vorne()] || VIEWS[0];
          mv.cameraOrbit = `${v.theta} ${v.phi} ${Math.round(STARTABSTAND() * 100)}%`;
          mv.jumpCameraToGoal?.();
          const r0 = mv.getCameraOrbit?.().radius;
          if (Number.isFinite(r0) && r0 > 0) {
            const base = r0 / STARTABSTAND();
            radius = r0;
            radiusMax = base * 1.60;
          }
        }));

        buildThumbs();

        fabricMat = mv.model.materials.find((m) => m.name === D.materialName)
                 || mv.model.materials[0];
        if (!fabricMat) {
          console.error('[fmnv-p3d] Kein Stoffmaterial im GLB gefunden');
          return;
        }
        paint();
        warmup();


        // Studio-HDRI erst jetzt: Es macht Unterschiede in Rauheit und Glanz
        // überhaupt erst sichtbar — ein flacher Verlauf wirft keine Lichter,
        // in denen sich Cord von Velours unterscheiden könnte. Schlägt der
        // Download fehl, bleibt der Verlauf einfach stehen.

      };
      mv.addEventListener('load', beiModellGeladen);
      if (mv.loaded) beiModellGeladen();
      mv.addEventListener('error', () => {
        /* Lite-Modell fehlt (neues Sofa ohne verkleinerte Fassung): still
           auf das Original zurückfallen statt eine Fehlermeldung zu zeigen.
           Der Fehlschlag wird gemerkt, damit ein späterer Wechsel zurück auf
           diese Ausführung nicht erneut ins Leere lädt. */
        const src = new URL(mv.getAttribute('src') || '', location.href).href;
        if (/-lite\.glb$/.test(src)) {
          liteFehlt.add(src);
          fabricMat = null;
          mv.setAttribute('src', src.replace(/-lite\.glb$/, '.glb'));
          return;
        }
        hideSkeleton();
        showLoading('3D-Modell konnte nicht geladen werden.');
      });
    }

    // Texturen der aktuellen Familie im Leerlauf gestaffelt vorladen. Nur
    // HTTP-Cache, keine GPU-Texturen — 181 × ~5 MB VRAM wären auf Mobile
    // ein Absturzrisiko.
    function warmup() {
      if (slowConn) return;
      /* Telefone (Touch) nur die Nachbarn der gewählten Farbe statt der ganzen
         Familie (Cord: 13 × ~350 KB). Safari kennt navigator.connection nicht,
         slowConn greift dort also nie (2026-10-14, Ladezeit mobil). */
      const alle = family.colors;
      const i0 = Math.max(0, alle.indexOf(color));
      const urls = (matchMedia('(pointer: coarse)').matches ? alle.slice(Math.max(0, i0 - 1), i0 + 3) : alle)
        .map((c) => c.tex);
      let i = 0;
      const step = () => {
        while (i < urls.length && prefetched.has(urls[i])) i++;
        if (i >= urls.length) return;
        prefetch(urls[i++]);
        setTimeout(step, 250);
      };
      setTimeout(step, 900);
    }
  })();
